import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { AppService } from "src/app/app.service";
import { ENDPOINTS, ORG_DETAILS } from "src/app/app.config";
import { ActivatedRoute, Router, NavigationEnd, Params } from "@angular/router";
import { CartService } from "src/app/Lazy-loaded-Modules/Cart-module/cart-page/cart-page.service";
import { LocalStorageService } from "src/app/Services/auth-service/local-storage.service";
import { AlertsService } from "src/app/Components/alerts/alerts.service";
import metaData from "src/assets/data/default/product-listing.json";
import { config } from "src/configs/config";
import { MetaDataMapService } from "src/app/meta-data-map.service";
import { ProductFilterComponent } from "../product-filter/product-filter.component";
import { ProductListingService } from "../product-listing/product-listing.service";
import { ProductFilterService } from "../product-filter/product-filter.service";
import { HostListener } from '@angular/core';
import {HttpHeaders } from '@angular/common/http';
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  FormArray,
  Validators,
} from "@angular/forms";
import { CheckoutApiService } from "src/app/Lazy-loaded-Modules/Checkout-new/checkout-api.service";
import { CheckoutLocalStorageService } from "src/app/Lazy-loaded-Modules/Checkout-new/checkout-local-storage.service";
import { CustomerLoginStorageService } from "src/app/Lazy-loaded-Modules/Checkout-new/checkout-login/customer-login-storage.service";
import { LoaderService } from "src/app/Components/loader/loader.service";
import { HeaderService } from "src/app/Components/Common/header/header-two/header.service";
import { NewNavbarService } from 'src/app/Components/new-navbar/new-navbar.service';
import { userInfo } from "os";
import { element } from "protractor";
import { json } from "stream/consumers";
import { LoginService } from "src/app/Lazy-loaded-Modules/Account-Modules/login-new/login-new.service";
import { SEO_VARIABLES } from "src/seo/seo.config";
import { MetadataService } from "src/app/Services/seo_services/head_metadata.service";
import { Console } from "console";

@Component({
  selector: "app-product-listing",
  templateUrl: "./product-listing.component.html",
})
export class ProductListingComponent implements OnInit {
  @ViewChild(ProductFilterComponent) productfilter: ProductFilterComponent;
  @ViewChild("closeModal") private closeModal: ElementRef;
  material_vimpro:any=[];
  color_vimpro:any=[];
  usage_vimpro:any=["One Time","Recycle"];
  fields = metaData.groups[0].fields;
  CONFIG = config;
  imageName : string="";
  previewImgUrl : string = "";
  imgFile : string="";
  sizeVariable: any;
  isValid = false;
  sortvalue:any = "sort"
  isDisabled: boolean = false;
  showPrice = false;
  sort_selected: boolean = true
  showMoreOption: boolean = true
  checkVariantInCart: any;
  priceOfVariant: any;
  totalPrice = 0;
  path;
  activeMenu: string;
  banner = "";
  isActive: any;
  promotionData: any;
  approved:any;
  taz_initial=20;
  taz_addvalue = 20;
  taz_max = 140;
  taz_increment;
  counter = 1
  public executionData = [];
  public brandValues: any = [];
  public categoryList: any = [];
  public allInOneData: any = [];
  public allInOneData1: any = [];
  public newarrival: any = [];
  public include = false;
  public days90 = false;
  public days30 = false;
  brandPush: any;
  cate: any;
  clearCategoryData: any;
  selectedIndex: number = null;
  subCategories: any;
  categoryType: any;
  public active;
  public cartData = [];
  public cartQuantity = [];
  public searchCategory;
  public priceStrikeOutInListScreen;
  public showPricekey;
  public strikeOutPriceKey;
  public fixedAmount;
  public discountValue;
  public promotionType;
  public productQuantity = 0;
  public percentageValue;
  public current_index=0;
  public outletId: any;
  productQuantity1 = false;
  subProductArray= [];
  low_to_high:boolean=false;
  deera_price_data : any;
  high_to_low:boolean=false;
  special_add_cart:boolean=false;
  Taz_price:boolean = false;
  vimpro_pro_name;
  special_pro_name;
  totalProducts: any = 0;
  showAlerts = false;
  options = {
    autoClose: true,
    keepAfterRouteChange: false,
  };
  facets;
  themes;
  finish;
  features;
  prices;
  price_range;
  size;
  thickness;
  age;
  affiliation;
  standard;
  subject;
  year;
  color;
  type;
  material;
  products = [];
  products1 = [];
  sortorders :{ value: any, name: any }[] = [
    {value:"Recommended",name:"Recommended"},
    {value:"Low to High",name:"Price: Low to High"},
    {value:"High to Low",name:"Price: High to Low"}
  ];
  linenRajOption:any;
  DeeraOption:any;
  breadcrumbs =
    'Home > Ground Engaging Tools > <span class="active"><b>KHIN Teeth</b></span>';
  pricefilters = {
    minPrice: 0,
    maxPrice: 72,
  };
  public minPrice = 0;
  public maxPrice = 72;
  public productsApiData: any;
  public categoryApiData: any;
  public countPerPage = 25;
  public child_index=0;
  // public countPerPage = 25;
  public pageNumber = 0;
  public totalNumberOfProducts;
  // public currentPageInPagination = 1;
  public currentPageInPagination = 0;
  public itemsPerPage: number;
  public totalLength;
  public page;
  public filtersApiData;
  public brandProductsApiData;
  public category = [];
  public filter = "no";
  public search = "no";
  public searchKey;
  public searchApiData;
  public brand = "no";
  public last90Days = "no";
  public combine = "no";
  public outOfStockProductsApiData;
  public outOfStock;
  public last90DaysProductsApiData;
  public dataFilter = "az";
  public days = "no";
  public req_filter_data1;
  public req_filter_data2;
  public req_filter_data3;
  public req_filter_data4;
  public req_last90days_product_data;
  public req_last90days_product_data1;
  public req_last90days_product_data2;
  public req_last90days_product_data3;
  public req_search_data;
  public product1;
  public product2;
  public product3;
  public product4;

  pagenation: any;
  latest_products: any = "";
  brad: any;
  eventValue;
  searchTypeValue: any;
  ninetyDaysLastCheck: any;
  totalItemsOrProducts: any = 0;
  categoryTobeShown: any = "All Categories";
  currentRating = 4.5;
  enquiryForm: UntypedFormGroup;
  enquiryForm_vimpro: UntypedFormGroup;
  enquiryForm_special: UntypedFormGroup;
  sortingForm: UntypedFormGroup;
  validateForm: boolean = false;
  memberId: any = "";
  checkoutAlerts: boolean = false;
  companyName;
  isfilter: boolean = false;
  bbcrumb: string;
  bbcrumb1:string;
  existingCartProduts = [];
  selectedOption1:any;
  selectedOption2:any;
  product:any;
  selectedSCH:any;
  currentUserType: any;
  selectedboth:boolean=false;
  showTheme:boolean=false;
  maxValuetemp: Number = 200;
  dropSelectType;
  bombayhardwareprice;
  showDropDown = true;
  categoryName;
  LinenPrice:any;
  LinenName:any;
  categoryDescription;
  metaSchiftTitle;
  currentUrl:string;
  newBreadcrumbs:boolean=false;
  activeTabIndex: number = 0;
  activeTabIndex1: number = 0;
  
  filterData:boolean=false;
  filterData1:boolean=false;
  categoryNewData="default";
  categoryNewData1="default";


  constructor(
    public appService: AppService,
    private router: Router,
    private route: ActivatedRoute,
    private cartService: CartService,
    private localService: LocalStorageService,
    private alertService: AlertsService,
    private productListingService: ProductListingService,
    public metaDataMapService: MetaDataMapService,
    private productFilterService: ProductFilterService,
    private formBuilder: UntypedFormBuilder,
    private checkoutApiService: CheckoutApiService,
    private checkoutLocalStorageService: CheckoutLocalStorageService,
    private customerLoginStorageService: CustomerLoginStorageService,
    private loaderService: LoaderService,
    private headerService: HeaderService,
    private newNavbarService : NewNavbarService,
    private LoginService:LoginService,
    private metadataService: MetadataService
  ) {

    // this.metadataService.configureMetadata(SEO_VARIABLES.PRODUCT_LIST.DESCRIPTION, SEO_VARIABLES.PRODUCT_LIST.KEYWORDS, SEO_VARIABLES.PRODUCT_LIST.TITLE)
  }
  ngAfterViewInit(){
    // console.log("TEST",this.products)
    // alert('ccccc')
    // this.productListingService.currentData.subscribe((currentData) => {
    //   let data:any = currentData;
    //  // if(data.name === "know_more"){
    //   alert(currentData);
    //    alert('shdvgddgvdgvdg')
    //  // }


    // })


    if(this.bbcrumb=="Arts of India"){
      this.showTheme=true;
      if ( document.getElementById("ta-1")) {
        document.getElementById("ta-1").style.color='red!important';
      } else {
       
        setTimeout(() => {
          console.log("111")
          const element = document.getElementById('ta-1');
          if (element) {
            console.log("222",element)
            document.getElementById("ta-1").style.color='red!important';
          } else {
            console.warn('Element not found');
          }
        },5000);
      }
     
     
      
       console.log("ssssss")

    }
      

   
  }
  ngOnInit() {
    this.currentUrl = (window.location.href).split('?')[0];

   
    console.log(this.currentUrl,"this.currentUrl");
    if(this.CONFIG.title=="KatbookStore" && this.currentUrl=="http://localhost:4200/#/productListing-newarrival"){
      this.newBreadcrumbs=true;

    }


    console.log("this.allInOneData[12].yadtest",this.allInOneData[1])
    console.log("comein1")
    if(document.getElementsByClassName('modal-backdrop')[0]) {

      document.getElementsByClassName('modal-backdrop')[0].remove()
       
      }


      // this.outletId= this.localService.get("karupattirajaOutletId");
      if(this.CONFIG.title!=="ShubhCards"){
      this.outletId = this.appService.outletId;
    }
      console.log("outletIdddddddddddddddddddddd"+this.outletId);
      if(this.outletId==1){
        this.outletId = this.localService.get('karupattirajaOutletId');
      }
      if(this.CONFIG.title=="Karupattiraja" || this.CONFIG.title=="Deera"){
        if(this.outletId=="0"|| this.outletId==0||this.outletId==""|| this.outletId==null){
          this.outletId=1;
        }
        
      }

    //   window.addEventListener("beforeunload", function (e) {
    //     var confirmationMessage = "\o/";
    //     e.returnValue = confirmationMessage;     // Gecko, Trident, Chrome 34+
    //     return confirmationMessage;              // Gecko, WebKit, Chrome <34
    // });  
    // this.loadCartBombay() 
    
    this.route.queryParams
    .subscribe(params => {
      this.bbcrumb=params.terms; 
      console.log("comein2",this.bbcrumb)
    })
     if (this.CONFIG.title === "ShubhCards"){
      
      this.route.queryParams
      .subscribe(params => {
        this.bbcrumb=params.terms[3]; 
        console.log("comein2",this.bbcrumb)
        if(this.bbcrumb=="Arts of India"){
          this.activeTabIndex=0;
          this.showTheme=true;
          console.log("text",this.bbcrumb)
          
          
           console.log("ssssss")

          
          

        }
        else{
          this.showTheme=false;

        }
      })

     }
     
  // if (this.CONFIG.title === "Aiema" || this.CONFIG.title === "Beaubelle"|| this.CONFIG.title === "Deera" || this.CONFIG.title === "Karupattiraja") {
      this.countPerPage = 25;
  // }
  //  else if (this.CONFIG.title === "Beaubelle") {
  //     this.countPerPage = 15;
  //     console.log("pagination")
  //   } 
  
    // else {
    //   this.countPerPage = 25;
    // }

    // this.getFilterByProduct(this.currentPageInPagination);
    console.log("Test for calling the function")
    this.productListingService.clearEvent();
    this.cartService.updateCartItem(this.appService.cartProducts.results);
    this.headerService.updateAdminFormEvent('clearSearchTerm');
    this.brandPush = [];
     this.cate = [];
    this.brad = [];
    this.pagenation = false;
    this.checkoutAlerts = true;
    // CLEAR ALL FUNCTIONALITY
    this.productListingService.currentData.subscribe((currentData) => {
      console.log("insidee"+currentData)
      let data:any = currentData;
      console.log("data.name",data.name)
      
      if (currentData === "clearAll" && this.CONFIG.title!=="ShubhCards" && this.CONFIG.title!=="Babys Pride") {
        if (this.latest_products === "latest") {
          this.refreshLast90Days(1);
          console.log("comein5")
        } else {
          let topCategories = [];
          if (this.categoryList.length > 0) {
            this.categoryList.forEach((element) => {
              topCategories.push(element.name);
            });
            if (this.CONFIG.title !== "Aiema" && this.CONFIG.title !== "Cle") {
              this.refreshProducts(topCategories);
            }
          }
        }
      } 
      else {
        // FOR CLEAR ALL FUNCTIONLITY TO COVER LATEST PRODUCTS
        if (this.route.snapshot.queryParamMap) {
          if (
            this.route.snapshot.queryParamMap.get("type") === "last90days" ||
            this.CONFIG.title !== "Aiema" && this.CONFIG.title !== "Cle"
          ) {
            this.latest_products = "latest";
          }
        }

        this.route.queryParams.subscribe((params) => {
          // SCROLL TO THE TOP
          document.body.scrollTop = 0; // For Safari
          document.documentElement.scrollTop = 72; // For Chrome, Firefox, IE and Opera
          if (params.type == "filter") {
            this.clearCategoryData = [];
            this.latest_products = "";
            this.combine = "no";
            this.search = "no";
            this.last90Days = "no";
            this.ninetyDaysLastCheck = false;
            this.cate = [];
            this.route.queryParamMap.subscribe(
              (params) => (this.category = params.getAll("terms"))
            );
            this.categoryTobeShown = this.category[0];
            console.log("test for category listing",this.category)
            console.log("test for category listing1",this.categoryTobeShown)
            this.cate = this.category;
            if (this.productfilter !== undefined) {
              this.productfilter.brands = [];
              this.productfilter.cate = [];
              this.productfilter.stockDetails = [];
              if (this.CONFIG.title !== "Aiema" && this.CONFIG.title !== "Cle") {
                this.productfilter.clearCheckBox();
              }
              this.productfilter.active = "";
            }
            this.currentPageInPagination = 1;
            console.log("comein7")
            this.getFilterByProduct(this.currentPageInPagination);
          } 
          else if (params.type == "searchresults") {
            this.latest_products = "";
            this.clearCategoryData = [];
            // this.breadCrumbService.updateAdminFormEvent('');
            this.combine = "no";
            this.ninetyDaysLastCheck = false;
            this.filter = "no";
            this.last90Days = "no";
            if (this.productfilter !== undefined) {
              this.productfilter.brands = [];
              console.log("comein6")
              this.productfilter.cate = [];
              this.productfilter.stockDetails = [];
              this.productfilter.clearCheckBox();
              this.productfilter.active = "";
            }
            this.cate = [];
            this.brad = [];
            this.route.queryParamMap.subscribe((params) => {
              this.searchKey = params.getAll("terms")[0];
              this.categoryTobeShown = params.getAll("terms")[0];
              this.searchTypeValue = params.getAll("terms")[1];
            });
            if (this.searchTypeValue) {
              if (this.searchTypeValue === "Brand") {
                this.brad = this.searchKey;
              } else {
                this.cate = [this.searchKey];
              }
            } else {
              this.cate = [this.searchKey];
            }

            this.currentPageInPagination = 1;
            this.getSearchResult(this.currentPageInPagination);
          } else if (params.type == "all") {
          }
        });

        this.route.queryParams.subscribe((params) => {
          if (params.type == "last90days" && this.CONFIG.title !== "Aiema" && this.CONFIG.title !== "Cle") {
            this.categoryTobeShown = "Latest Prodcuts";
            this.latest_products = "latest";
            this.combine = "no";
            this.filter = "no";
            this.search = "no";
            this.days = "yes";
            this.ninetyDaysLastCheck = true;
            if (this.productfilter !== undefined) {
              this.productfilter.brands = [];
              this.productfilter.cate = [];
              this.productfilter.stockDetails = [];
              //  this.productfilter.clearCheckBox()
              if (this.CONFIG.title !== "Aiema" && this.CONFIG.title !== "Cle") {
                this.productfilter.clearCheckBox();
              }
            }

            this.getProductByLast90Days(this.currentPageInPagination);
          } 
          else if (
            params.type == "last90days" &&
            this.CONFIG.title === "Aiema"
          ) {
            this.categoryTobeShown = "All Categories";
            this.latest_products = "";
            this.combine = "no";
            this.filter = "no";
            this.search = "no";
            this.days = "yes";
            this.ninetyDaysLastCheck = true;
            // this.ninetyDaysLastCheck = false;
            // this.categoryList = [];
            if (this.productfilter !== undefined) {
              this.productfilter.brands = [];
              this.productfilter.cate = [];
              this.productfilter.stockDetails = [];
              //  this.productfilter.clearCheckBox()
            }
            console.log("dataaaaaaaa00")
            this.getAiemaProductByLast90Days(this.currentPageInPagination);
          }
        });

        if(this.CONFIG.title !== "Deera"){
        this.route.queryParams.subscribe((params) => {
          if (params.type == "combine") {
            this.search = "no";
            this.filter = "no";
            this.last90Days = "no";
            if (
              (this.CONFIG.title === "Aiema" || this.CONFIG.title === "Cle") ||
              this.CONFIG.title !== "BombayHardware"
            ) {
              this.ninetyDaysLastCheck = false;
            }
            console.log("this.allInOneDatarrrrrrrrrr",this.allInOneData)
            this.route.queryParamMap.subscribe(
              (params) => (this.allInOneData = params.getAll("terms"))
            );
            console.log("this.allInOneData",this.allInOneData)
            this.route.queryParamMap.subscribe(
              (params) => (this.allInOneData1 = params.getAll("terms"))
            );
            console.log("test for shubhcards")
            if(this.CONFIG.title === "Taazah"){
              this.taz_increment = 20
              this.counter = 1
            }

            this.getFilterByProductAll(1);
          }
        });
      }
        for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
          this.cartData.push(
            this.appService.cartProducts.results[i].product_id
          );
        }
      }
      if(data.name==="fromKnowMore"){
        console.log("123456789")
      }
       if(data.name === "categoryName"){
        // this.calculateShippingCharges(data.value);
        console.log("data.valuetttttttt"+data.value)

        if (this.categoryList.length > 0) {
          this.categoryList.forEach((element) => {
            // topCategories.push(element.name);
            console.log("element"+element.name)
            if(data.value===element.name){
              this.categoryName = element.name;
            }
          });
        }
      }
      
      if(data.name === "categorySEOData"){
        // this.calculateShippingCharges(data.value);
        if(this.CONFIG.title === "Babys Pride"){
          console.log("data.valuetttttttt"+data.value)
          let categoryData = data.value
          if (categoryData.length > 0) {
           for(let i=0;i<categoryData.length;i++){
             if(this.allInOneData[1]==categoryData[i].name){
               console.log("fffffffffffffffffffffffffffff")
               this.metadataService.configureMetadata(categoryData[i].meta_description, categoryData[i].meta_keywords, categoryData[i].meta_title)
               break;
             } else {
               console.log("lllllllllllllllllllllllllllllll")
               this.metadataService.configureMetadata(SEO_VARIABLES.PRODUCT_LIST.DESCRIPTION, SEO_VARIABLES.PRODUCT_LIST.KEYWORDS, SEO_VARIABLES.PRODUCT_LIST.TITLE)
   
             }
            }
          }
        }
      }
      if(this.CONFIG.title === "Babys Pride"){
        this.selectSort(this.sortvalue)

      }
      if(this.CONFIG.title === "Taazah"){
        this.selectSort(this.sortvalue)

      }
    });

    if(this.CONFIG.title === "Deera"){
      this.route.queryParams.subscribe((params) => {
        if (params.type == "combine") {
          this.search = "no";
          this.filter = "no";
          this.last90Days = "no";
          // if (
          //   (this.CONFIG.title === "Aiema" || this.CONFIG.title === "Cle") ||
          //   this.CONFIG.title !== "BombayHardware"
          // ) {
          //   this.ninetyDaysLastCheck = false;
          // }
          console.log("this.allInOneDatarrrrrrrrrr",this.allInOneData)
          this.route.queryParamMap.subscribe(
            (params) => (this.allInOneData = params.getAll("terms"))
          );
          console.log("this.allInOneData",this.allInOneData)
          this.route.queryParamMap.subscribe(
            (params) => (this.allInOneData1 = params.getAll("terms"))
          );
          console.log("asasas"+this.allInOneData[1].length,this.allInOneData[9].length,this.allInOneData[18].length,)
          if(this.allInOneData[1].length>0 && this.allInOneData[9].length===0 && this.allInOneData[18].length===0) {
            console.log("njnj" +this.categoryNewData)
            console.log("njnj" +this.allInOneData[1])
            // if(this.filterData===false){
              if(this.categoryNewData!=this.allInOneData[1]){
                console.log("ccc"+this.categoryNewData)
                console.log("ccc"+this.allInOneData[1])
              this.getFilterByProductAll(1);
              this.categoryNewData = this.allInOneData[1];
              this.filterData=false;
            }
            console.log("hjhj"+this.categoryNewData)
                console.log("hjhj"+this.allInOneData[1])
          }
          if(this.allInOneData[1].length>0 && this.allInOneData[9].length>0 && this.allInOneData[18].length>0) {
            console.log("jjjj")
            this.getFilterByProductAll(1);
            this.categoryNewData = this.allInOneData[1];
            this.categoryNewData1 = this.categoryNewData;
            console.log("nnnn" +this.categoryNewData)
            console.log("nnnn" +this.allInOneData[1])
            this.filterData = true;
          }
          if(this.allInOneData[1].length===0 && this.allInOneData[9].length===0 && this.allInOneData[18].length===0) {
            console.log("njnj" +this.categoryNewData)
            console.log("njnj" +this.allInOneData[1])
            // if(this.filterData===false){    
                console.log("ccc"+this.categoryNewData)
                console.log("ccc"+this.allInOneData[1])
              this.getFilterByProductAll(1);
          // }
          }
          if(this.allInOneData[1].length>0 && this.allInOneData[9].length>0 && this.allInOneData[18].length===0) {
            console.log("hjhj" +this.categoryNewData1)
            console.log("hjhj" +this.allInOneData[1])
            this.getFilterByProductAll(1);
            this.categoryNewData = this.allInOneData[1];
          }
        }
      });
    }
    
    if(this.CONFIG.title === "Cle"){
      this.newNavbarService.updateAdminFormEvent({name: "categoryData"});
    }
   

    this.priceStrikeOutInListScreen = this.localService.get(
      "price_strikeout_in_list_screen"
    );
    this.showPricekey = this.localService.get("show_price_key");
    this.strikeOutPriceKey = this.localService.get("strike_out_price_key");
    


    this.enquiryForm = new UntypedFormGroup({
      name: this.formBuilder.control("", [
        Validators.required,
        Validators.maxLength(80),
      ]),
      email: this.formBuilder.control("", [
        Validators.required,
        Validators.maxLength(50),
        Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$"),
      ]),
      phone_number: this.formBuilder.control("", [
        Validators.required,
        Validators.maxLength(10),
        Validators.pattern("^[+]*[(]{0,1}[0-9]{10}[)]{0,1}[-s./0-9]*$"),
      ]),
      category: this.formBuilder.control("", [Validators.required]),
      message: this.formBuilder.control("", [
        Validators.required,
        Validators.maxLength(600),
      ]),
    });
    this.enquiryForm_vimpro = new UntypedFormGroup({
      name: this.formBuilder.control("", [
        Validators.required,
        Validators.maxLength(80),
      ]),
      email: this.formBuilder.control("", [
        Validators.required,
        Validators.maxLength(50),
        Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$"),
      ]),
      phone_number: this.formBuilder.control("", [
        Validators.required,
        Validators.maxLength(10),
        Validators.pattern("^[+]*[(]{0,1}[0-9]{10}[)]{0,1}[-s./0-9]*$"),
      ]),
      category: this.formBuilder.control(""),
      product_name: this.formBuilder.control("", [Validators.required]),
       length: this.formBuilder.control(""),
       thickness: this.formBuilder.control(""),
       height: this.formBuilder.control(""),
       width: this.formBuilder.control(""),
       quantity: this.formBuilder.control(""),
      material: this.formBuilder.control(""),
      color: this.formBuilder.control(""),
      usage: this.formBuilder.control(""),
      message: this.formBuilder.control("", [
        Validators.required,
        Validators.maxLength(600),
      ]),
    });
    this.sortingForm = new UntypedFormGroup({
      sort_value : this.formBuilder.control("Recommended")
    });
    this.enquiryForm_special = new UntypedFormGroup({
      name: this.formBuilder.control("", [
        Validators.required,
        Validators.maxLength(80),
      ]),
      email: this.formBuilder.control("", [
        Validators.required,
        Validators.maxLength(50),
        Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$"),
      ]),
      phone_number: this.formBuilder.control("", [
        Validators.required,
        Validators.maxLength(10), Validators.minLength(10),
        Validators.pattern("[789][0-9]{9}"),
      ]),
      category: this.formBuilder.control(""),
      product_name: this.formBuilder.control("", [Validators.required]),
      message: this.formBuilder.control("", [
        Validators.required,
        Validators.maxLength(600),
      ]),
      e_length: this.formBuilder.control(""),
      imageFile: this.formBuilder.control(""),
      diameter: this.formBuilder.control(""),
      quantity: this.formBuilder.control(""),
    });
    if(this.CONFIG.title === "Taazah"){
      this.currentUserType == "individual customer"
    }
    if (this.localService.get('CustomerData')) {
      this.currentUserType = JSON.parse(this.localService.get('CustomerData')).type
      console.log("currentUser: ", (this.currentUserType == "business customer"))

      console.log("currentUser: business customer")
    } else {
      this.currentUserType = "individual customer"
      console.log("currentUser: ", this.currentUserType)
    }
    console.log(JSON.stringify(this.products),"this.product")
    console.log("this.allInOneData[1]dddddddddddddddddddddd"+this.allInOneData[1])
   
    if(this.CONFIG.title === "Deera"){
     if(this.currentUserType==="individual customer"){

     }
    }

 

  }
  @HostListener('window:popstate', ['$event'])
  onPopState(event) {    
    if(document.getElementById('statusModel').classList.contains('show')) {
      document.getElementById('launch-model').click()
    }
  }
  
  get f() {
    if(this.CONFIG.title === "Beaubelle"){
    return this.enquiryForm.controls;
    }
    if(this.CONFIG.title === "Accel"){
      return this.enquiryForm.controls;
      }
      if(this.CONFIG.title === "SpecialWires"){
        return this.enquiryForm_special.controls;
        }
  }
  get f_vimpro() {
    if(this.CONFIG.title === "Vimpro"){
    return this.enquiryForm_vimpro.controls;
    }
  }
  loadCartBombay(){
    for(let i=0;i<this.products.length;i++){
      for(let j=0;j<this.appService.cartProducts.results.length;j++){
        if(this.products[i].id==this.appService.cartProducts.results[j].product_id){
          this.products[i].subcart=this.appService.cartProducts.results[j].subcart
          this.products[i].subquantity=this.appService.cartProducts.results[j].subquantity
          this.products[i].price=this.appService.cartProducts.results[j].price
        }
        else{
          this.products[i].subcart=[]
          this.products[i].subquantity=[]
          this.products[i].price=[]
        }
      }
      if(this.appService.cartProducts.results.length==0){
        this.products[i].subcart=[]
        this.products[i].subquantity=[]
        this.products[i].price=[]
      }
    }
  }
  selectOption1(value,id){
    for(let i=0;i<this.products.length;i++){
      if(this.products[i].id == id){
        this.products[i].size[0]=value;
        this.products[i].subname = this.products[i].name + " - " + value + this.products[i].dropdown_consider[0]  
      }

    }
    this.selectedOption1=value; 
  }
  selectSecond(value,id){
    for(let i=0;i<this.products.length;i++){
      if(this.products[i].id == id){
        this.products[i].size[1]=value;
        this.products[i].subname = this.selectedSCH + this.products[i].dropdown_consider[0] +" - "+ this.products[i].name +" - "+ value + this.products[i].dropdown_consider[1]
      }
    }
    this.selectedboth=true;
    this.selectedOption2=value;
  }
  selectSecondSCH(value,id){
    for(let i=0;i<this.products.length;i++){
      if(this.products[i].id == id){
        this.products[i].size[1]=value;
        this.products[i].subname = this.products[i].name +" - "+ this.products[i].size[2] + this.products[i].dropdown_consider[1] +" - "+  value + this.products[i].dropdown_consider[0]
      }
    }
    this.selectedboth=true;
    this.selectedOption2=value;
  }
  addSubProduct(item){
    console.log('add')
    this.loadCartBombay()
    for(let i=0;i<this.products.length;i++){
      console.log("this.selectedOption1",this.selectedOption1,this.selectedOption2)
      if(this.products[i].id == item.id){
        if(item.subname != item.name && !this.products[i].subcart.includes(item.subname)){
          if(!this.products[i].subcart.includes(item.subname) || !this.appService.subProductinCart.includes(item.subname)){
            for(let z=0;z<this.appService.cartProducts.results.length;z++){
              if(item.id==this.appService.cartProducts.results[z].product_id){
                this.products[i].subcart=this.appService.cartProducts.results[z].subcart
                this.products[i].price=  this.products[i].price.length>=0? this.appService.cartProducts.results[z].price:[]
               
                this.products[i].subquantity=this.appService.cartProducts.results[z].subquantity
              }
            }
            if(this.products[i].childs.type.length>0){
            for(let p =0;p<this.products[i].childs.type.length;p++){
              for(let q=0;q<this.products[i].childs.type[p].values.length;q++){
               

                if(this.products[i].childs.type[p].sch_value==this.dropSelectType){
                  
                 // console.log(this.products[i].childs.type[p].values[q].mm,"this.products[i].childs.type[p].value[q]")
                 
                  if(this.products[i].childs.type[p].values[q].mm===this.selectedOption2 || this.products[i].childs.type[p].values[q].mm===this.selectedOption1 ){
                    console.log("ist if")
                    console.log(this.products[i].childs.type[p].values[q].price,"this.products[i].childs.type[p].values[q].mm");
                    this.bombayhardwareprice=''
                    console.log("type1")
                    this.bombayhardwareprice=this.products[i].childs.type[p].values[q].price
                    if(this.bombayhardwareprice==null){
                      this.bombayhardwareprice==0

                    }
                   

                  }
                  else if(this.products[i].childs.type[p].values[q].inch==this.selectedOption2 || this.products[i].childs.type[p].values[q].inch==this.selectedOption1){
                    console.log("sec if")
                    console.log(this.products[i].childs.type[p].values[q].price,"this.products[i].childs.type[p].values[q].mm")
                    this.bombayhardwareprice='';
                    console.log("type2")
                    this.bombayhardwareprice= this.products[i].childs.type[p].values[q].price;
                    if(this.bombayhardwareprice==null){
                      this.bombayhardwareprice==0

                    }

                  }
                  // if(this.products[i].childs.type[p].values[q].price==undefined){

                  //   this.bombayhardwareprice=0
                  // }
                  

                 }
               
                 
                


              }
            }}
            if(this.products[i].childs.size.length>0){
              console.log("inside size")
              for(let r=0;r<this.products[i].childs.size.length;r++){
              
                
                
                  if(this.products[i].childs.size[r].value===this.selectedOption1 || this.products[i].childs.size[r].value===this.selectedOption2){
                    console.log(this.products[i].childs.size[r].price,"this.products[i].childs.size[r].price")
                    this.bombayhardwareprice=''
                    this.bombayhardwareprice=this.products[i].childs.size[r].price;
                    
                  
                    //console.log(this.products[i].childs.type[r].values[q].price,"this.products[i].childs.type[p].values[q].mm")
                   

                  


                  

                

               
               }
                 if(this.products[i].childs.size[r].price==undefined){
                this.bombayhardwareprice=0;

              }

            }}
            if(this.products[i].childs.size_pn.length>0){
              console.log("inside size_pn")
              for(let r=0;r<this.products[i].childs.size_pn.length;r++){
                
                  
                  if(this.products[i].childs.size_pn[r].mm===this.selectedOption1 || this.products[i].childs.size_pn[r].mm===this.selectedOption2){
                    console.log(this.products[i].childs.size_pn[r].price,"mmthis.products[i].childs.size[r].price")
                    this.bombayhardwareprice=''
                    this.bombayhardwareprice=this.products[i].childs.size_pn[r].price;
                    
                  
                    //console.log(this.products[i].childs.type[r].values[q].price,"this.products[i].childs.type[p].values[q].

               
               

                }
               
                  if(this.products[i].childs.size_pn[r].pn===this.selectedOption1|| this.products[i].childs.size_pn[r].pn===this.selectedOption2){
                    console.log(this.products[i].childs.size_pn[r].price,"pnthis.products[i].childs.size_pn.price")
                    this.bombayhardwareprice=''
                    this.bombayhardwareprice=this.products[i].childs.size_pn[r].price;
  
                  }
                  if(this.products[i].childs.size_pn[r].price==undefined){
                    this.bombayhardwareprice=0;
    
                  }

                
                
              
                
                

            }
              

            }
            if(this.products[i].childs.size_ml.length>0){
              for(let r=0;r<this.products[i].childs.size_ml.length;r++){
                if(this.products[i].childs.size_ml[r].value===this.selectedOption1 || this.products[i].childs.size_ml[r].value===this.selectedOption2){
                  console.log(this.products[i].childs.size_ml[r].price,"mlthis.products[i].childs.size[r].price")
                  this.bombayhardwareprice='';
                  this.bombayhardwareprice=this.products[i].childs.size_ml[r].price
                  
                
                  //console.log(this.products[i].childs.type[r].values[q].price,"this.products[i].childs.type[p].values[q].

             
             

              }
              if(this.products[i].childs.size_ml[r].price==undefined){
                this.bombayhardwareprice=0;

              }


              }
              

            }
            if(this.products[i].childs.size_pipe.length>0){
              for(let r=0;r<this.products[i].childs.size_pipe.length;r++){
                if(this.products[i].childs.size_pipe[r].mm===this.selectedOption1 || this.products[i].childs.size_pipe[r].mm===this.selectedOption2){
                  console.log(this.products[i].childs.size_pipe[r].price,"mlthis.products[i].childs.size[r].price");
                  this.bombayhardwareprice=''
                  this.bombayhardwareprice=this.products[i].childs.size_pipe[r].price
                  
                
                  //console.log(this.products[i].childs.type[r].values[q].price,"this.products[i].childs.type[p].values[q].

             
             

              }
              else if(this.products[i].childs.size_pipe[r].inch===this.selectedOption1 || this.products[i].childs.size_pipe[r].inch===this.selectedOption2){
                console.log(this.products[i].childs.size_pipe[r].price,"mlthis.products[i].childs.size[r].price");
                this.bombayhardwareprice='';
                this.bombayhardwareprice=this.products[i].childs.size_pipe[r].price
                
              
                //console.log(this.products[i].childs.type[r].values[q].price,"this.products[i].childs.type[p].values[q].

           
           

            }
              if(this.products[i].childs.size_pipe[r].price==undefined){
                this.bombayhardwareprice=0;

              }



              }
              

            }
            if(this.products[i].childs.diameter.length>0){
              for(let r=0;r<this.products[i].childs.diameter.length;r++){
                if(this.products[i].childs.diameter[r].value===this.selectedOption1 || this.products[i].childs.diameter[r].value===this.selectedOption2){
                  console.log("diameter")
                  if(this.products[i].childs.diameter[r].price!=undefined){
                    
                    console.log(this.products[i].childs.diameter[r].price,"diameterlthis.products[i].childs.size[r].price");
                    this.bombayhardwareprice='';
                    this.bombayhardwareprice=this.products[i].childs.diameter[r].price

                  }
                  else if(this.products[i].childs.diameter[r].price==undefined) {
                    this.bombayhardwareprice=0;

                  }

                

                }

              }
              
            }
            
           // this.products[i].subcart.push({ "name":item.subname,"price":"0"}) ;
          
          //console.log(this.bombayhardwareprice,"bombayhardwareprice");
          //  console.log( tempprice," tempprice")
           //console.log(this.products[i],"this.products[i]")
           console.log( this.products[i].price, this.products[i].subcart,"1")
           this.products[i].price.push(this.bombayhardwareprice);
           console.log(this.bombayhardwareprice,"push"+i,item.subname)
           
           this.products[i].subcart.push(item.subname) ;
           console.log( this.products[i].price, this.products[i].subcart,"2")
            this.products[i].subquantity.push(1)
            //

            this.appService.subProductinCart.push(item.subname);
            

            this.cartService.addToCartSub(this.products[i]);
          }
        }
      }
    }
    this.cartService.updateCartItem(this.appService.cartProducts.results);
    for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
     
      this.cartData.push(this.appService.cartProducts.results[i].product_id);
      console.log(JSON.stringify(this.appService.cartProducts.results[i].subcart))
     
     
    }
  }
  selectFirst(value,id){
    this.selectedboth=false;
    for(let i=0;i<this.products.length;i++){
      if(this.products[i].id == id){
        this.products[i].size[0]=value;
        this.products[i].size[1]="";
        this.products[i].subname = value + this.products[i].dropdown_consider[0] + " - " + this.products[i].name
      }

    }
    this.selectedSCH=value;
  }
  selectFirstSCH(value,id){
    this.dropSelectType =value
    this.selectedboth=false;
    for(let i=0;i<this.products.length;i++){
      if(this.products[i].id == id){
        this.products[i].size[0]=value;
        this.products[i].size[1]="";
        this.products[i].subname = this.products[i].name + " - " +  value + this.products[i].dropdown_consider[1] 
        this.products[i].size[2]=value
        var filter_product_by_index=this.products[i];
        var type_filter=filter_product_by_index.childs.type.filter(values=>{
          if(String(values.sch_value)==value)
          {
            return value;
          }
          })
              if(filter_product_by_index.dropdown_consider[0] == 'inch')
              {
                this.selectSecondSCH(type_filter[0].values[0].inch,id);
              }
              else if(filter_product_by_index.dropdown_consider[0] == 'mm'){
                this.selectSecondSCH(type_filter[0].values[0].mm,id);
              }
              else if(filter_product_by_index.dropdown_consider[0] == 'Thickness/Class'){
                this.selectSecondSCH(type_filter[0].values[0].Thickness,id);
              }else if(filter_product_by_index.dropdown_consider[0] == 'class'){
                this.selectSecondSCH(type_filter[0].values[0].class,id);
              }
              else if(filter_product_by_index.dropdown_consider[0] == 'Thickness'){
                this.selectSecondSCH(type_filter[0].values[0].Thickness,id);
              }
              else if(filter_product_by_index.dropdown_consider[0] == 'SCH'){
                this.selectSecondSCH(type_filter[0].values[0].sch,id);
              }
        
      }
      
    }
    
    // this.selectedSCH=value;
  }
  decreaseSubItem(i,j,id)
  { 
    console.log("dec")
    this.alertService.clear();
    let tempArray = this.appService.cartProducts.results; 
    console.log(tempArray)
  
      if(this.appService.cartProducts.results[i].subquantity[j] === 1) {
        for(let k=0;k<this.products.length;k++){
          if(this.products[k].id == id){
            for(let x=0;x<this.products[k].subcart.length;x++){
              if(this.products[k].subname==this.products[k].subcart[x])
              this.products[k].subcart.splice(x,1)
              this.products[k].subquantity.splice(x,1)
            }
          }
        }
        this.removeSubItem(i,j,id)
        return
    }
  
    tempArray[i].subquantity[j] = (Number(tempArray[i].subquantity[j]) - 1)
    this.appService.cartProducts.results = tempArray;
    this.calculateTotal();
    this.cartService.updateCartItem(this.appService.cartProducts.results);
    this.loadExistingCart()
    
  }
  increaseSubItem(i,j,id){
    this.alertService.clear();
    console.log("this.appService.cartProducts.results",this.appService.cartProducts.results)
    
    let tempArray = this.appService.cartProducts.results;
    if(tempArray[i].subquantity[j]<1000){
      tempArray[i].subquantity[j]+=1;
    for(let k=0;k<this.products.length;k++){
      if(this.products[k].id == id){
        this.products[k].subquantity[j]=tempArray[i].subquantity[j];
        this.products[k].price[j]= tempArray[i].subquantity[j]
        
      }
    }
    this.appService.cartProducts.results = tempArray;
    
    this.calculateTotal();
    this.cartService.updateCartItem(this.appService.cartProducts.results);
    this.loadExistingCart()
    }
    else{
      this.alertService.error("Maximum allowed quantity is 1000 only",this.options);
    }
    
  }
  minQuantity0(i,j,id,event){
    this.alertService.clear();
    let tempArray=this.appService.cartProducts.results
    this.cartService.updateCartItem(this.appService.cartProducts.results);
    if(tempArray[i].subquantity[j]<=0){
      this.removeSubItem(i,j,id)
    }
    else if(event.srcElement.value>1000){
      this.alertService.error("Maximum allowed quantity is 1000 only",this.options);
      event.srcElement.value =1000
      this.appService.cartProducts.results[i].subquantity[j]=1000
      this.cartService.updateCartItem(this.appService.cartProducts.results);
      return;
    }

  }
  removeSubItem(i,j,id)
  {
    this.appService.cartProducts.results[i].subcart.splice(j,1)
    this.appService.cartProducts.results[i].subquantity.splice(j,1)
    for(let k=0;k<this.products.length;k++){
      if(this.products[k].id == id){
        for(let x=0;x<this.products[k].subcart.length;x++){
          if(this.products[k].subname==this.products[k].subcart[x])
          this.products[k].subcart.splice(x,1)
          this.products[k].subquantity.splice(x,1)
        }
        // for(let z=0;z<this.appService.subProductinCart.length;z++){
        //   if(this.appService.subProductinCart[z]==this.products[k].subname){
        //     this.appService.subProductinCart.splice(z,1)
        //   }
        // }
      }
    }
    
    // this.appService.cartProducts.results.splice(i,1);
    this.appService.totalCartItems = this.cartService.totalCartItems();
    if(this.appService.cartProducts.results[i].subcart.length==0){
      this.appService.cartProducts.results.splice(i,1)
    }
    this.calculateTotal();
    this.cartService.updateCartItem(this.appService.cartProducts.results);
    // this.loadExistingCart()
  }
  
  selectOptionCarience(value,id,index){
    this.child_index=0;
    for(let i=0;i<this.products.length;i++){
      if(this.products[i].id == id){
        var product=this.products[i];
         this.current_index=index;
        product['current_index']=index;
        product['child_index']=0;
        console.log("1")
        if(this.CONFIG.title === "LinenRaj")
        {
          console.log("2")
          this.selectColourOptions(this.products[i].variant.option_values[index].option,this.products[i].id,index)
        }
        if(this.products[i].variant.variant_child)
        {
        this.selectColour(this.products[i].variant.option_values[index].child[this.child_index].color,this.products[i].id,0)
      }
    }
    }
    //this.products[i].current_index!=null?product.current_index:0=index
    this.selectedOption1=value;
  }
  selectOptionSpecialWires(value,id,index){
    
    this.child_index=0;
    for(let i=0;i<this.products.length;i++){
      if(this.products[i].id == id){
        var product=this.products[i];
        //this.current_index=index;
        product['current_index']=-1;
        product['child_index']=0;
      //   if(this.products[i].variant.variant_child)
      //                   {
      //   this.selectColour(this.products[i].variant.option_values[index].child[this.child_index].color,this.products[i].id,0)
      // }
    }
    }
    //this.products[i].current_index!=null?product.current_index:0=index
    this.selectedOption1=value;
  }
  selectOptionSpecialWires1(value,id,index){
    this.special_add_cart=true;
    this.child_index=0;
    for(let i=0;i<this.products.length;i++){
      if(this.products[i].id == id){
        var product=this.products[i];
        //this.current_index=index;
        product['current_index']=index;
        product['child_index']=0;
        if(this.products[i].variant.variant_child)
                        {
        this.selectColourOptions(this.products[i].variant.option_values[index].child[this.child_index].color,this.products[i].id,0)
      }
    }
    }
    //this.products[i].current_index!=null?product.current_index:0=index
    this.selectedOption1=value;
  }
  selectColour(value,id,index){
    console.log(this.products)
    for(let i=0;i<this.products.length;i++){
      console.log(this.products.length,'checkflow')
      //console.log(this.products.length)
      if(this.products[i].id == id){
        // this.products[i].size[1]=color;
        // this.products[i].subname = this.products[i].name +" - "+ this.products[i].size[0]  +" - "+  color
        for(let k=0;k<this.products[i].variant.option_values[this.current_index!=-1?this.current_index:0].child.length;k++){
          this.products[i].variant.option_values[this.current_index!=-1?this.current_index:0].child[k].is_default=false
          if(index==k){
            this.products[i]['child_index']=index;
            this.products[i].variant.option_values[this.current_index!=null?this.current_index:0].child[index].is_default=true;
            this.child_index=index;
          }
        }
      }
    }
  }


  selectColourOptions(value,id,index){
    console.log(this.products)
    for(let i=0;i<this.products.length;i++){
      console.log(this.products.length,'checkflow')
      //console.log(this.products.length)
      if(this.products[i].id == id){
        // this.products[i].size[1]=color;
        // this.products[i].subname = this.products[i].name +" - "+ this.products[i].size[0]  +" - "+  color
        
        for(let k=0;k<this.products[i].variant.option_values[this.current_index!=-1?this.current_index:0].length;k++){
          console.log(this.products[i].variant.option_values[this.current_index!=-1?this.current_index:0].length,"check value")
          this.products[i].variant.option_values[this.current_index!=-1?this.current_index:0].is_default=false
          if(index==k){
            this.products[i]['child_index']=index;
            this.products[i].variant.option_values[this.current_index!=null?this.current_index:0].is_default=true;
            this.child_index=index;
          }
        }
      }
    }
  }
  closeDropDown() {
    this.showDropDown = false;
    console.log('clicked outside');
}
  count()
  {
    return 1;
  }
  selectSpecial(id,index){
    console.log(this.products)
    for(let i=0;i<this.products.length;i++){
      console.log(this.products.length,'checkflow')
      //console.log(this.products.length)
      if(this.products[i].id == id){
        // this.products[i].size[1]=color;
        // this.products[i].subname = this.products[i].name +" - "+ this.products[i].size[0]  +" - "+  color
        for(let k=0;k<this.products[i].variant.option_values[this.products[i].current_index!=null?this.products[i].current_index:0].child.length;k++){
            if(index==k){
            this.products[i].variant.option_values[this.products[i].current_index!=null?this.products[i].current_index:0].child[k].is_default=true;
          }
          else{
            this.products[i].variant.option_values[this.products[i].current_index!=null?this.products[i].current_index:0].child[k].is_default=false
        
          }
        }
      }
    }
  }

  addWishList(product: any) {
    product.select = !product.select;
  }
  alphabetsFilter() {
    if (
      this.filter == "yes" &&
      this.combine !== "yes" &&
      this.search !== "yes"
    ) {
      this.getFilterByProduct(this.currentPageInPagination);
    } else if (
      this.search == "yes" &&
      this.combine !== "yes" &&
      this.filter !== "yes"
    ) {
      this.getSearchResult(this.currentPageInPagination);
    } else if (
      this.last90Days == "yes" &&
      this.combine !== "yes" &&
      this.search !== "yes" &&
      this.filter !== "yes"
    ) {
      this.getProductByLast90Days(this.currentPageInPagination);
    } else if (
      this.combine == "yes" &&
      this.dataFilter == "az" &&
      this.search !== "yes" &&
      this.last90Days !== "yes"
    ) {
      this.getFilterByProductAll(this.currentPageInPagination);

    }
  }

  pageChange(event) {
  
    window.scrollTo(0,0);
    this.currentPageInPagination = event;
    if(this.low_to_high==true){

      this.getLowtoHighProducts(this.currentPageInPagination);
    }
    else if(this.high_to_low==true){
      this.getHightoLowProducts(this.currentPageInPagination);

    }
    
   else{
  if (
    this.filter == "yes" &&
    this.combine !== "yes" &&
    this.search !== "yes" &&
    this.last90Days !== "yes"
  ) {
    this.getFilterByProduct(this.currentPageInPagination);
  } else if (
    this.search == "yes" &&
    this.combine !== "yes" &&
    this.filter !== "yes" &&
    this.last90Days !== "yes"
  ) {
    this.getSearchResult(this.currentPageInPagination);
  } else if (
    this.last90Days == "yes" &&
    this.combine !== "yes" &&
    this.search !== "yes" &&
    this.filter !== "yes"
  ) {
    this.getProductByLast90Days(this.currentPageInPagination);
  } else if (
    this.combine == "yes" &&
    this.dataFilter == "az" &&
    this.search !== "yes" &&
    this.last90Days !== "yes" &&
    this.filter !== "yes"
  ) {
    console.log("productall")
    this.pagenation = true;
    this.getFilterByProductAll(this.currentPageInPagination);
    
  } else if (
    this.combine == "yes" &&
    this.dataFilter == "za" &&
    this.search !== "yes" &&
    this.last90Days !== "yes" &&
    this.filter !== "yes"
  ) {
    this.getFilterByProductAllZToA(this.currentPageInPagination);
  } else if (
    this.combine !== "yes" &&
    this.filter !== "yes" &&
    this.search !== "yes" &&
    this.days == "yes"
  ) {
    console.log("dataaaaaaaa")
    this.getAiemaProductByLast90Days(this.currentPageInPagination);
  }
  
}
    
  }

  //GET ALL BRANDS PRODUCTS
  getAllBrandProducts(event: number) {
    this.currentPageInPagination = event;
    this.page = event - 1;
    if (this.dataFilter == "az") {
      var req_product_data = {
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: null,
        extras: {
          find: {},
          pagination: true,
          paginationDetails: {
            limit: event,
            pagesize: 25,
            
          },
          sorting: true,
          sortingDetails: {
            sortfield: "name",
            sortorder: -1,
          },
          subcategoryfilter: false,
        },
      };
    } else if (this.dataFilter == "za") {
      var req_product_data = {
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: null,
        extras: {
          find: {},
          pagination: true,
          paginationDetails: {
            limit: event,
            pagesize: 25,
           
          },
          sorting: true,
          sortingDetails: {
            sortfield: "name",
            sortorder: +1,
          },
          subcategoryfilter: false,
        },
      };
    }

    this.appService
      .postApiCall(req_product_data, ENDPOINTS.GET_ALL_PRODUCTS)
      .subscribe(
        (resp) => {

          this.productsApiData = resp;
          this.products = this.productsApiData.result.data;
       
          this.totalNumberOfProducts = this.productsApiData.result.total;
          //  if(!this.isfilter)
          //  {
          //this.isfilter=true;
          
          this.categoryList = this.productsApiData.result.filters[0].categories;
          this.facets = this.productsApiData.result.filters[1].brands;

          this.themes = this.productsApiData.result.filters[2].themes;
          this.finish = this.productsApiData.result.filters[3].finish;
          this.features = this.productsApiData.result.filters[4].features;
          this.prices = this.productsApiData.result.filters[5].prices;
          this.size = this.productsApiData.result.filters[6].size;
          this.thickness = this.productsApiData.result.filters[7].thickness;
          this.color = this.productsApiData.result.filters[8].color;
          this.type = this.productsApiData.result.filters[9].type;
          this.material =
            this.productsApiData.result.filters[10].product_material;
            this.age = this.productsApiData.result.filters[12].age;
            console.log("age2",this.age)
            if (this.CONFIG.title !== "Karupattiraja"){
            this.affiliation = this.productsApiData.result.filters[13].affiliation;
            console.log("affiliation2",this.affiliation)
            this.standard = this.productsApiData.result.filters[14].standard;
            console.log("standard2",this.standard)
            this.subject = this.productsApiData.result.filters[15].subject;
            console.log("subject",this.subject)
            this.year = this.productsApiData.result.filters[16].year;
            console.log("subjyearect",this.year)
            this.price_range = this.productsApiData.result.filters[17].price_range;
          }
          //}standard
          //  this.totalLength = this.products ? this.products.totalLength : 0;
          this.totalLength = this.productsApiData.result.total
            ? this.productsApiData.result.total
            : 0;
          if (
            this.CONFIG.title === "Aiema" || this.CONFIG.title === "Cle" ||
            this.CONFIG.title === "ShubhCards" ||
            this.CONFIG.title === "BombayHardware" ||this.CONFIG.title === "Vimpro"||
            this.CONFIG.title === "Deera" ||  this.CONFIG.title === "KatbookStore" || this.CONFIG.title === "LushNGreen" || this.CONFIG.title === "Taazah" || this.CONFIG.title === "Karupattiraja"|| this.CONFIG.title === "AvonSeals" || this.CONFIG.title === "Vistas" || this.CONFIG.title === "Linenraj" || this.CONFIG.title === "SpecialWires" || this.CONFIG.title === "Babys Pride" || this.CONFIG.title === "Beaubelle" || this.CONFIG.title === "Schift Cosmetics" || this.CONFIG.title === "BestGifts"||this.CONFIG.title === "Kubendran" ||this.CONFIG.title === "Carience"
          ) {
            this.totalLength = this.totalItemsOrProducts = this.productsApiData
              .result.total.value
              ? this.productsApiData.result.total.value
              : 0;
              console.log(this.totalLength,"bestgifts")
          }
        },
        (err) => {
          if (err.error.error.message) {
            console.log(err.error.error.message);
          } else {
            console.log("Something bad happened; Please try again!");
          }
        }
      );
  }

  //GET FILTER PRODUCTS
  getFilterByProduct(event: number) {
    
    console.log("11")
    console.log("comein8")
    this.currentPageInPagination = event;
    this.filter = "yes";
    if (
      this.CONFIG.title === "BombayHardware" || this.CONFIG.title === "Babys Pride" || this.CONFIG.title === "LushNGreen" || this.CONFIG.title === "KatbookStore" || this.CONFIG.title === "LinenRaj"|| this.CONFIG.title === "Karupattiraja" || this.CONFIG.title === "AvonSeals" || this.CONFIG.title === "Vistas" || this.CONFIG.title === "LinenRaj" || this.CONFIG.title === "SpecialWires" || this.CONFIG.title==="BestGifts"||this.CONFIG.title==="Kubendran"||this.CONFIG.title==="Carience"||this.CONFIG.title==="Vimpro"||this.CONFIG.title==="Taazah"
    ) {
      if (this.dataFilter == "az") {
        this.req_filter_data1 = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: null,
          extras: {
            find: {
              // "brand":[this.allInOneData[0]],
              category: this.category,
              last90days: false,
              last30days: false,
              includeoutofstock: false,
              isglobalfilter: true,
            },
            pagination: true,
            paginationDetails: {
              limit: event,
              pagesize: 25,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "name",
              sortorder: -1,
            },
            subcategoryfilter: false,
          },
        };
      } else if (this.dataFilter == "za") {
        this.req_filter_data1 = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: null,
          extras: {
            find: {
              // "brand":[this.allInOneData[0]],
              category: this.category,
              last90days: false,
              last30days: false,
              includeoutofstock: false,
              isglobalfilter: true,
            },
            pagination: true,
            paginationDetails: {
              limit: event,
              pagesize: 25,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "name",
              sortorder: +1,
            },
            subcategoryfilter: false,
          },
        };
      }
      
    } else if(this.CONFIG.title === "Deera"){
      if (this.dataFilter == "az") {
        this.req_filter_data1 = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: null,
          extras: {
            find: {
              // "brand":[this.allInOneData[0]],
              category: this.category,
              last90days: false,
              last30days: false,
              includeoutofstock: false,
              isglobalfilter: true,
            },
            pagination: true,
            paginationDetails: {
              limit: event,
              pagesize: 25,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "name",
              sortorder: -1,
            },
            subcategoryfilter: false,
          },
        };
      } else if (this.dataFilter == "za") {
        this.req_filter_data1 = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: null,
          extras: {
            find: {
              // "brand":[this.allInOneData[0]],
              category: this.category,
              last90days: false,
              last30days: false,
              includeoutofstock: false,
              isglobalfilter: true,
            },
            pagination: true,
            paginationDetails: {
              limit: event,
              pagesize: 25,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "name",
              sortorder: +1,
            },
            subcategoryfilter: false,
          },
        };
      }
    }
   else if (
      this.CONFIG.title === "Beaubelle" || this.CONFIG.title === "Schift Cosmetics"
    ) {
      if (this.dataFilter == "az") {
        this.req_filter_data1 = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: null,
          extras: {
            find: {
              // "brand":[this.allInOneData[0]],
              category: this.category,
              last90days: false,
              last30days: false,
              includeoutofstock: false,
              isglobalfilter: false,
              filters_based_on:"brand",
            },
            pagination: true,
            paginationDetails: {
              limit: event,
              pagesize: 25,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "name",
              sortorder: -1,
            },
            subcategoryfilter: false,
          },
        };
      } else if (this.dataFilter == "za") {
        this.req_filter_data1 = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: null,
          extras: {
            find: {
              // "brand":[this.allInOneData[0]],
              category: this.category,
              last90days: false,
              last30days: false,
              includeoutofstock: false,
              isglobalfilter: false,
            },
            pagination: true,
            paginationDetails: {
              limit: event,
              pagesize: 25,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "name",
              sortorder: +1,
            },
            subcategoryfilter: false,
          },
        };
      }
      
    }
    else {
      if (this.dataFilter == "az") {
        this.req_filter_data1 = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: null,
          extras: {
            find: {
              // "brand":[this.allInOneData[0]],
              category: this.category,
              last90days: false,
              last30days: false,
              includeoutofstock: false,
            },
            pagination: true,
            paginationDetails: {
              limit: event,
              pagesize: 25,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "name",
              sortorder: -1,
            },
            subcategoryfilter: false,
          },
        };
      } else if (this.dataFilter == "za") {
        this.req_filter_data1 = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: null,
          extras: {
            find: {
              // "brand":[this.allInOneData[0]],
              category: this.category,
              last90days: false,
              last30days: false,
              includeoutofstock: false,
            },
            pagination: true,
            paginationDetails: {
              limit: event,
              pagesize: 25,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "name",
              sortorder: +1,
            },
            subcategoryfilter: false,
          },
        };
      }
    }

    this.appService
      .postApiCall(this.req_filter_data1, ENDPOINTS.GET_FILTER_PRODUCTS)
      .subscribe(
        (resp) => {
          this.filtersApiData = resp;
          this.products = this.filtersApiData.result.data;
          console.log("123",this.products)
     
          this.totalNumberOfProducts = this.filtersApiData.result.total;
          //  if(!this.isfilter)
          //  {
          //this.isfilter=true;
          this.categoryList = this.filtersApiData.result.filters[0].categories;
          this.facets = this.filtersApiData.result.filters[1].brands;

          this.themes = this.filtersApiData.result.filters[2].themes;
          this.finish = this.filtersApiData.result.filters[3].finish;
          this.features = this.filtersApiData.result.filters[4].features;
          this.prices = this.filtersApiData.result.filters[5].prices;
          this.size = this.filtersApiData.result.filters[6].size;
          this.thickness = this.filtersApiData.result.filters[7].thickness;
          this.color = this.filtersApiData.result.filters[8].color;
          this.type = this.filtersApiData.result.filters[9].type;
          this.material =
            this.filtersApiData.result.filters[10].product_material;
            this.age = this.filtersApiData.result.filters[12].age;
            console.log("age1",this.age)
            this.affiliation = this.filtersApiData.result.filters[13].affiliation;
            console.log("affiliation1",this.affiliation)
            this.standard = this.filtersApiData.result.filters[14].standard;
            console.log("standard1",this.standard)
            this.subject = this.filtersApiData.result.filters[15].subject;
            console.log("subject",this.subject)
            this.year = this.filtersApiData.result.filters[16].year;
            console.log("subjyearect",this.year)
            this.price_range = this.filtersApiData.result.filters[17].price_range;
          // }

          this.totalItemsOrProducts = this.filtersApiData.result.total.value
            ? this.filtersApiData.result.total.value
            : 0;

          this.totalProducts = this.filtersApiData.result.total
            ? this.filtersApiData.result.total
            : 0;
          this.totalLength = this.filtersApiData.result.total
            ? this.filtersApiData.result.total
            : 0;
          if (
            this.CONFIG.title === "Aiema" || this.CONFIG.title === "Cle" ||
            this.CONFIG.title === "ShubhCards" ||
            this.CONFIG.title === "BombayHardware" ||
            this.CONFIG.title === "Deera" || this.CONFIG.title === "Karupattiraja" || this.CONFIG.title === "AvonSeals" || this.CONFIG.title === "LushNGreen" || this.CONFIG.title === "Babys Pride" || this.CONFIG.title === "Vistas" || this.CONFIG.title === "Linenraj" || this.CONFIG.title === "SpecialWires" || this.CONFIG.title === "Beaubelle"  || this.CONFIG.title === "Schift Cosmetics" || this.CONFIG.title === "BestGifts"||this.CONFIG.title === "Kubendran" ||this.CONFIG.title==="Carience"||this.CONFIG.title==="Vimpro" || this.CONFIG.title === "Taazah"
          ) {
            this.totalLength = this.totalItemsOrProducts = this.filtersApiData
              .result.total.value
              ? this.filtersApiData.result.total.value
              : 0;
          }
        },
        (err) => {
          if (err.error.error.message) {
            console.log(err.error.error.message);
          } else {
            console.log("Something bad happened; Please try again!");
          }
        }
      );
  }
  showMore(){
    this.taz_increment = 20;
    this.counter++;
    console.log("counter number :",this.counter)
    this.taz_increment = this.counter * this.taz_initial
    console.log("increment value",this.taz_increment)
      console.log("test for categoryyyyyyyyyyyyyyyyyyyyyyyyyyyy",this.allInOneData[1])
      if(this.Taz_price){
        if(this.high_to_low){
      this.req_filter_data2 = {
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: null,
        extras: {
          find: {
            brand:
              this.allInOneData[0] != "" &&
              this.allInOneData[0] != undefined &&
              this.allInOneData[0] != null
                ? this.allInOneData[0]
                : [],
            category: this.allInOneData[1],
            theme:
              this.allInOneData[3] != "" &&
              this.allInOneData[3] != undefined &&
              this.allInOneData[3] != null
                ? this.allInOneData[3]
                : [],
            finish:
              this.allInOneData[4] != "" &&
              this.allInOneData[4] != undefined &&
              this.allInOneData[4] != null
                ? this.allInOneData[4]
                : [],
            feature:
              this.allInOneData[5] != "" &&
              this.allInOneData[5] != undefined &&
              this.allInOneData[5] != null
                ? this.allInOneData[5]
                : [],
            price:
              this.allInOneData[6] != "" &&
              this.allInOneData[6] != undefined &&
              this.allInOneData[6] != null
                ? this.allInOneData[6]
                : [],
            size:
              this.allInOneData[7] != "" &&
              this.allInOneData[7] != undefined &&
              this.allInOneData[7] != null
                ? this.allInOneData[7]
                : [],
            thickness:
              this.allInOneData[8] != "" &&
              this.allInOneData[8] != undefined &&
              this.allInOneData[8] != null
                ? this.allInOneData[8]
                : [],
            color:
              this.allInOneData[9] != "" &&
              this.allInOneData[9] != undefined &&
              this.allInOneData[9] != null
                ? this.allInOneData[9]
                : [],
            type:
              this.allInOneData[10] != "" &&
              this.allInOneData[10] != undefined &&
              this.allInOneData[10] != null
                ? this.allInOneData[10]
                : [],
            product_material:
              this.allInOneData[11] != "" &&
              this.allInOneData[11] != undefined &&
              this.allInOneData[11] != null
                ? this.allInOneData[11]
                : [],
                age:
                this.allInOneData[12] != "" &&
                this.allInOneData[12] != undefined &&
                this.allInOneData[12] != null
                  ? this.allInOneData[12]
                  : [],
                affiliation:
                this.allInOneData[13] != "" &&
                this.allInOneData[13] != undefined &&
                this.allInOneData[13] != null
                  ? this.allInOneData[13]
                  : [],
                  standard:
                this.allInOneData[14] != "" &&
                this.allInOneData[14] != undefined &&
                this.allInOneData[14] != null
                  ? this.allInOneData[14]
                  : [],
                  subject:
                this.allInOneData[15] != "" &&
                this.allInOneData[15] != undefined &&
                this.allInOneData[15] != null
                  ? this.allInOneData[15]
                  : [],
                  year:
                this.allInOneData[16] != "" &&
                this.allInOneData[16] != undefined &&
                this.allInOneData[16] != null
                  ? this.allInOneData[16]
                  : [],
                  price_range:
              this.allInOneData[17] != "" &&
              this.allInOneData[17] != undefined &&
              this.allInOneData[17] != null
                ? this.allInOneData[17]
                : [],
            last90days: this.days90,
            last30days: this.days30,
            includeoutofstock: this.include,
          },
          pagination: true,
          paginationDetails: {
            pagesize: this.taz_increment,
          },
          sorting: true,
          sortingDetails: {
            sortfield: "pricing.raw.price",
            sortorder: 1,
          },
          subcategoryfilter: false,
        },
      };
      try{
        console.log("545556666")
        this.appService
        .postApiCall(this.req_filter_data2, ENDPOINTS.GET_FILTER_PRODUCTS)
        .subscribe(
          (resp) => {
            //  this.allInOneData=[];

            this.pagenation = false;
            this.filtersApiData = resp;
              this.products = this.filtersApiData.result.data
              console.log("Test for total value in the api",this.filtersApiData.result.total.value)
              console.log("Test for no of values in the page",this.taz_increment)
             if(this.taz_increment>=this.filtersApiData.result.total.value){
this.showMoreOption = false
             }
             else{
              this.showMoreOption = true
             }
             console.log(JSON.stringify(this.products))
            //  .filter(element=>{if(element.id==27||element.id==9){return element}});
            this.totalNumberOfProducts = this.filtersApiData.result.total;
          



            if (!this.isfilter) {
              this.isfilter = true;
              if (this.categoryList.length === 0) {
                this.categoryList =
                  this.filtersApiData.result.filters[0].categories;
              }
              if (this.facets && this.facets.length === 0) {
                this.facets = this.filtersApiData.result.filters[1].brands;
              }
              if (this.allInOneData[0].length === 1) {
                this.allInOneData[0].forEach((element) => {
                  if (!element) {
                    this.facets = this.filtersApiData.result.filters[1].brands;
                  }
                });
              }
              if (this.facets && this.facets.length === 0) {
                this.facets = this.filtersApiData.result.filters[1].brands;
              }
              if (this.allInOneData[0].length === 1) {
                this.allInOneData[0].forEach((element) => {
                  if (!element) {
                    this.facets = this.filtersApiData.result.filters[1].brands;
                  }
                });
              }

   
            }

       

            this.totalItemsOrProducts = this.filtersApiData.result.total.value
              ? this.filtersApiData.result.total.value
              : 0;

            //  this.totalLength = this.products ? this.products.totalLength : 0;
            this.totalLength = this.filtersApiData.result.total
              ? this.filtersApiData.result.total
              : 0;
              this.totalLength = this.totalItemsOrProducts = this.filtersApiData
                .result.total.value
                ? this.filtersApiData.result.total.value
                : 0;

            this.loaderService.emitComplete();
            
          },
          (err) => {
            if (err.error.error.message) {
              console.log(err.error.error.message);
            } else {
              console.log("Something bad happened; Please try again!");
            }
          }
        
        );
      } catch (error) {
        console.log('Error while hitting api: ', error)
      }
    }
    else{
      this.req_filter_data2 = {
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: null,
        extras: {
          find: {
            brand:
              this.allInOneData[0] != "" &&
              this.allInOneData[0] != undefined &&
              this.allInOneData[0] != null
                ? this.allInOneData[0]
                : [],
            category: this.allInOneData[1],
            theme:
              this.allInOneData[3] != "" &&
              this.allInOneData[3] != undefined &&
              this.allInOneData[3] != null
                ? this.allInOneData[3]
                : [],
            finish:
              this.allInOneData[4] != "" &&
              this.allInOneData[4] != undefined &&
              this.allInOneData[4] != null
                ? this.allInOneData[4]
                : [],
            feature:
              this.allInOneData[5] != "" &&
              this.allInOneData[5] != undefined &&
              this.allInOneData[5] != null
                ? this.allInOneData[5]
                : [],
            price:
              this.allInOneData[6] != "" &&
              this.allInOneData[6] != undefined &&
              this.allInOneData[6] != null
                ? this.allInOneData[6]
                : [],
            size:
              this.allInOneData[7] != "" &&
              this.allInOneData[7] != undefined &&
              this.allInOneData[7] != null
                ? this.allInOneData[7]
                : [],
            thickness:
              this.allInOneData[8] != "" &&
              this.allInOneData[8] != undefined &&
              this.allInOneData[8] != null
                ? this.allInOneData[8]
                : [],
            color:
              this.allInOneData[9] != "" &&
              this.allInOneData[9] != undefined &&
              this.allInOneData[9] != null
                ? this.allInOneData[9]
                : [],
            type:
              this.allInOneData[10] != "" &&
              this.allInOneData[10] != undefined &&
              this.allInOneData[10] != null
                ? this.allInOneData[10]
                : [],
            product_material:
              this.allInOneData[11] != "" &&
              this.allInOneData[11] != undefined &&
              this.allInOneData[11] != null
                ? this.allInOneData[11]
                : [],
                age:
                this.allInOneData[12] != "" &&
                this.allInOneData[12] != undefined &&
                this.allInOneData[12] != null
                  ? this.allInOneData[12]
                  : [],
                affiliation:
                this.allInOneData[13] != "" &&
                this.allInOneData[13] != undefined &&
                this.allInOneData[13] != null
                  ? this.allInOneData[13]
                  : [],
                  standard:
                this.allInOneData[14] != "" &&
                this.allInOneData[14] != undefined &&
                this.allInOneData[14] != null
                  ? this.allInOneData[14]
                  : [],
                  subject:
                this.allInOneData[15] != "" &&
                this.allInOneData[15] != undefined &&
                this.allInOneData[15] != null
                  ? this.allInOneData[15]
                  : [],
                  year:
                this.allInOneData[16] != "" &&
                this.allInOneData[16] != undefined &&
                this.allInOneData[16] != null
                  ? this.allInOneData[16]
                  : [],
                  price_range:
              this.allInOneData[17] != "" &&
              this.allInOneData[17] != undefined &&
              this.allInOneData[17] != null
                ? this.allInOneData[17]
                : [],
            last90days: this.days90,
            last30days: this.days30,
            includeoutofstock: this.include,
          },
          pagination: true,
          paginationDetails: {
            pagesize: this.taz_increment,
          },
          sorting: true,
          sortingDetails: {
            sortfield: "pricing.raw.price",
            sortorder: -1,
          },
          subcategoryfilter: false,
        },
      };
      try{
        console.log("545556666")
        this.appService
        .postApiCall(this.req_filter_data2, ENDPOINTS.GET_FILTER_PRODUCTS)
        .subscribe(
          (resp) => {
            //  this.allInOneData=[];

            this.pagenation = false;
            this.filtersApiData = resp;
              this.products = this.filtersApiData.result.data
              console.log("Test for total value in the api",this.filtersApiData.result.total.value)
              console.log("Test for no of values in the page",this.taz_increment)
             if(this.taz_increment>=this.filtersApiData.result.total.value){
this.showMoreOption = false
             }
             else{
              this.showMoreOption = true
             }
             console.log(JSON.stringify(this.products))
            //  .filter(element=>{if(element.id==27||element.id==9){return element}});
            this.totalNumberOfProducts = this.filtersApiData.result.total;
          



            if (!this.isfilter) {
              this.isfilter = true;
              if (this.categoryList.length === 0) {
                this.categoryList =
                  this.filtersApiData.result.filters[0].categories;
              }
              if (this.facets && this.facets.length === 0) {
                this.facets = this.filtersApiData.result.filters[1].brands;
              }
              if (this.allInOneData[0].length === 1) {
                this.allInOneData[0].forEach((element) => {
                  if (!element) {
                    this.facets = this.filtersApiData.result.filters[1].brands;
                  }
                });
              }
              if (this.facets && this.facets.length === 0) {
                this.facets = this.filtersApiData.result.filters[1].brands;
              }
              if (this.allInOneData[0].length === 1) {
                this.allInOneData[0].forEach((element) => {
                  if (!element) {
                    this.facets = this.filtersApiData.result.filters[1].brands;
                  }
                });
              }

   
            }

       

            this.totalItemsOrProducts = this.filtersApiData.result.total.value
              ? this.filtersApiData.result.total.value
              : 0;

            //  this.totalLength = this.products ? this.products.totalLength : 0;
            this.totalLength = this.filtersApiData.result.total
              ? this.filtersApiData.result.total
              : 0;
              this.totalLength = this.totalItemsOrProducts = this.filtersApiData
                .result.total.value
                ? this.filtersApiData.result.total.value
                : 0;

            this.loaderService.emitComplete();
            
          },
          (err) => {
            if (err.error.error.message) {
              console.log(err.error.error.message);
            } else {
              console.log("Something bad happened; Please try again!");
            }
          }
        
        );
      } catch (error) {
        console.log('Error while hitting api: ', error)
      }
    }
    }
    else{
      this.req_filter_data2 = {
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: null,
        extras: {
          find: {
            brand:
              this.allInOneData[0] != "" &&
              this.allInOneData[0] != undefined &&
              this.allInOneData[0] != null
                ? this.allInOneData[0]
                : [],
            category: this.allInOneData[1],
            theme:
              this.allInOneData[3] != "" &&
              this.allInOneData[3] != undefined &&
              this.allInOneData[3] != null
                ? this.allInOneData[3]
                : [],
            finish:
              this.allInOneData[4] != "" &&
              this.allInOneData[4] != undefined &&
              this.allInOneData[4] != null
                ? this.allInOneData[4]
                : [],
            feature:
              this.allInOneData[5] != "" &&
              this.allInOneData[5] != undefined &&
              this.allInOneData[5] != null
                ? this.allInOneData[5]
                : [],
            price:
              this.allInOneData[6] != "" &&
              this.allInOneData[6] != undefined &&
              this.allInOneData[6] != null
                ? this.allInOneData[6]
                : [],
            size:
              this.allInOneData[7] != "" &&
              this.allInOneData[7] != undefined &&
              this.allInOneData[7] != null
                ? this.allInOneData[7]
                : [],
            thickness:
              this.allInOneData[8] != "" &&
              this.allInOneData[8] != undefined &&
              this.allInOneData[8] != null
                ? this.allInOneData[8]
                : [],
            color:
              this.allInOneData[9] != "" &&
              this.allInOneData[9] != undefined &&
              this.allInOneData[9] != null
                ? this.allInOneData[9]
                : [],
            type:
              this.allInOneData[10] != "" &&
              this.allInOneData[10] != undefined &&
              this.allInOneData[10] != null
                ? this.allInOneData[10]
                : [],
            product_material:
              this.allInOneData[11] != "" &&
              this.allInOneData[11] != undefined &&
              this.allInOneData[11] != null
                ? this.allInOneData[11]
                : [],
                age:
                this.allInOneData[12] != "" &&
                this.allInOneData[12] != undefined &&
                this.allInOneData[12] != null
                  ? this.allInOneData[12]
                  : [],
                affiliation:
                this.allInOneData[13] != "" &&
                this.allInOneData[13] != undefined &&
                this.allInOneData[13] != null
                  ? this.allInOneData[13]
                  : [],
                  standard:
                this.allInOneData[14] != "" &&
                this.allInOneData[14] != undefined &&
                this.allInOneData[14] != null
                  ? this.allInOneData[14]
                  : [],
                  subject:
                this.allInOneData[15] != "" &&
                this.allInOneData[15] != undefined &&
                this.allInOneData[15] != null
                  ? this.allInOneData[15]
                  : [],
                  year:
                this.allInOneData[16] != "" &&
                this.allInOneData[16] != undefined &&
                this.allInOneData[16] != null
                  ? this.allInOneData[16]
                  : [],
                  price_range:
              this.allInOneData[17] != "" &&
              this.allInOneData[17] != undefined &&
              this.allInOneData[17] != null
                ? this.allInOneData[17]
                : [],
            last90days: this.days90,
            last30days: this.days30,
            includeoutofstock: this.include,
          },
          pagination: true,
          paginationDetails: {
            pagesize: this.taz_increment,
          },
          sorting: true,
          sortingDetails: {
            sortfield: "name",
            sortorder: this.dataFilter === "az" ? -1 : +1,
          },
          subcategoryfilter: false,
        },
      };
      try{
        console.log("545556666")
        this.appService
        .postApiCall(this.req_filter_data2, ENDPOINTS.GET_FILTER_PRODUCTS)
        .subscribe(
          (resp) => {
            //  this.allInOneData=[];

            this.pagenation = false;
            this.filtersApiData = resp;
              this.products = this.filtersApiData.result.data
              console.log("Test for total value in the api",this.filtersApiData.result.total.value)
              console.log("Test for no of values in the page",this.taz_increment)
             if(this.taz_increment>=this.filtersApiData.result.total.value){
this.showMoreOption = false
             }
             else{
              this.showMoreOption = true
             }
             console.log(JSON.stringify(this.products))
            //  .filter(element=>{if(element.id==27||element.id==9){return element}});
            this.totalNumberOfProducts = this.filtersApiData.result.total;
          



            if (!this.isfilter) {
              this.isfilter = true;
              if (this.categoryList.length === 0) {
                this.categoryList =
                  this.filtersApiData.result.filters[0].categories;
              }
              if (this.facets && this.facets.length === 0) {
                this.facets = this.filtersApiData.result.filters[1].brands;
              }
              if (this.allInOneData[0].length === 1) {
                this.allInOneData[0].forEach((element) => {
                  if (!element) {
                    this.facets = this.filtersApiData.result.filters[1].brands;
                  }
                });
              }
              if (this.facets && this.facets.length === 0) {
                this.facets = this.filtersApiData.result.filters[1].brands;
              }
              if (this.allInOneData[0].length === 1) {
                this.allInOneData[0].forEach((element) => {
                  if (!element) {
                    this.facets = this.filtersApiData.result.filters[1].brands;
                  }
                });
              }

   
            }

       

            this.totalItemsOrProducts = this.filtersApiData.result.total.value
              ? this.filtersApiData.result.total.value
              : 0;

            //  this.totalLength = this.products ? this.products.totalLength : 0;
            this.totalLength = this.filtersApiData.result.total
              ? this.filtersApiData.result.total
              : 0;
              this.totalLength = this.totalItemsOrProducts = this.filtersApiData
                .result.total.value
                ? this.filtersApiData.result.total.value
                : 0;

            this.loaderService.emitComplete();
            
          },
          (err) => {
            if (err.error.error.message) {
              console.log(err.error.error.message);
            } else {
              console.log("Something bad happened; Please try again!");
            }
          }
        
        );
      } catch (error) {
        console.log('Error while hitting api: ', error)
      }
    }
  }
  getFilterByProductAll(event: number) {
    if(this.currentUrl=="http://localhost:4200/#/productListing-newarrival" && this.CONFIG.title=="KatbookStore"){
      this.getNewArrival();
    }
    console.log(this.currentUrl,"this.currentUrl")
 
   
      console.log("222","newpro");
      console.log("test for shubhcards",this.category)
      // console.log(this.allInOneData[12].nand,"this.allInOneData[12]")
      this.combine = "yes";
      this.include = false;
      this.days30 = false;
      this.days90 = false;
  
  
      if (this.allInOneData[2]) {
        this.include = false;
        this.days30 = false;
        this.days90 = false;
        for (var i = 0; i < this.allInOneData[2].split(",").length; i++) {
          if (this.allInOneData[2].split(",")[i] == "Include Out of Stock") {
            this.include = true;
          } else if (this.allInOneData[2].split(",")[i] == "Last 90 days") {
            console.log("insideee");
            this.days90 = true;
          } else if (this.allInOneData[2].split(",")[i] == "Last 30 days") {
            this.days30 = true;
          } else {
            this.include = false;
            this.days30 = false;
            this.days90 = false;
          }
        }
      }
  
      this.currentPageInPagination = event;
      if(this.CONFIG.title=='KatbookStore'){
      if (this.allInOneData.length === 0) {
        this.allInOneData[0] = "";
        this.allInOneData[1] = [];
      } 
    }
    else{
      if (this.allInOneData.length === 0) {
        this.allInOneData[0] = "";
        this.allInOneData[1] = "";
      } else {
        if (this.allInOneData[1].length === 0) {
          //this.allInOneData[1]=this.cate
        } else {
          if (Array.isArray(this.allInOneData[1])) {
          } else {
            this.allInOneData[1] = [this.allInOneData[1]];
          }
        }
      }
    }
      // else {
      //   if (this.allInOneData[1].length === 0) {
      //   } else {
      //     if (Array.isArray(this.allInOneData[1])) {
      //     } else {
      //       this.allInOneData[1] = [this.allInOneData[1]];
      //     }
      //   }
      // }
      if(this.CONFIG.title=='ShubhCards'){
        {
          console.log(this.category,"this.category")
          if(this.category!=undefined &&  this.category!=null &&  this.category.length>0){
            console.log("120000")
          this.allInOneData[1] = this.category;
        } 
        
          
        }
      }
  
      var brandData = JSON.parse(JSON.stringify(this.allInOneData));
  
      if (this.pagenation != true &&( this.low_to_high!=false&&this.high_to_low!=false )&& this.CONFIG.title=='BestGifts') {
        this.allInOneData[0] = brandData[0].split(",");
        this.allInOneData[3] = brandData[3].split(",");
        this.allInOneData[4] = brandData[4].split(",");
        this.allInOneData[5] = brandData[5].split(",");
        this.allInOneData[6] = brandData[6].split(",");
         {
          // this.allInOneData[7]=brandData[7].split(',');
          this.allInOneData[8] = brandData[8].split(",");
        }
        
        {
          this.allInOneData[7] = brandData[7].split(",");
          this.allInOneData[9] = brandData[9].split(",");
          this.allInOneData[10] = brandData[10].split(",");
          this.allInOneData[11] = brandData[11].split(",");
          this.allInOneData[12] = brandData[12].split(",");
          this.allInOneData[13] = brandData[13].split(",");
          this.allInOneData[14] = brandData[14].split(",");
          this.allInOneData[15] = brandData[15].split(",");
          this.allInOneData[16] = brandData[16].split(",");
        }
        
      }
      if (this.pagenation != true && this.CONFIG.title!='BestGifts' && this.CONFIG.title!='Deera' && this.CONFIG.title!='ShubhCards' && this.CONFIG.title!='Schift Cosmetics') {
        this.allInOneData[0] = brandData[0].split(",");
        this.allInOneData[3] = brandData[3].split(",");
        this.allInOneData[4] = brandData[4].split(",");
        this.allInOneData[5] = brandData[5].split(",");
        this.allInOneData[6] = brandData[6].split(",");
        if (this.CONFIG.title !== "Deera" && this.CONFIG.title !== "Schift Cosmetics" && this.CONFIG.title !== "Babys Pride" && this.CONFIG.title !== "LushNGreen" && this.CONFIG.title !== "Karupattiraja" && this.CONFIG.title !== "AvonSeals" && this.CONFIG.title !== "Vistas" && this.CONFIG.title !== "LinenRaj" && this.CONFIG.title !== "SpecialWires" && this.CONFIG.title !== "ShubhCards" &&  this.CONFIG.title!=="BestGifts"&&this.CONFIG.title!=="Kubendran" && this.CONFIG.title!=="Carience"&&this.CONFIG.title!=="Vimpro" && this.CONFIG.title!=="Taazah") {
          // this.allInOneData[7]=brandData[7].split(',');
          this.allInOneData[8] = brandData[8].split(",");
        }
        if(this.CONFIG.title!=="Carience"&& this.CONFIG.title!=="Vimpro" &&this.CONFIG.title!=="" &&this.CONFIG.title!=="Schift Cosmetics" && this.CONFIG.title!=="Taazah" && this.CONFIG.title !== "AvonSeals" && this.CONFIG.title !== "Vistas" && this.CONFIG.title !== "Karupattiraja" && this.CONFIG.title !== "ShubhCards")
        {
          this.allInOneData[7] = brandData[7].split(",");
          this.allInOneData[9] = brandData[9].split(",");
          this.allInOneData[10] = brandData[10].split(",");
          this.allInOneData[11] = brandData[11].split(",");
          this.allInOneData[12] = brandData[12].split(",");
          this.allInOneData[13] = brandData[13].split(",");
          this.allInOneData[14] = brandData[14].split(",");
          this.allInOneData[15] = brandData[15].split(",");
          this.allInOneData[16] = brandData[16].split(",");
          this.allInOneData[17] = brandData[17].split(",");
          if(this.CONFIG.title==="Deera"){

            this.allInOneData[18] = brandData[18].split(",");

          }
        }
        
      }
  
  
  
  
  
      if (
        this.latest_products === "latest" &&
        (this.productfilter == undefined || this.productfilter.active === "")
      ) {
        this.days90 = true;
        //this.allInOneData[1] = [];
      } else if (this.productfilter && this.productfilter.active === "") {
        if ((this.CONFIG.title!=='Aiema' && this.CONFIG.title!=='Cle') && this.clearCategoryData.length > 0) {
          console.log("ppoopoop",this.clearCategoryData)
          this.allInOneData[1] = this.clearCategoryData;
        }
      }
  
      if (this.allInOneData[0].length === 1) {
        this.allInOneData[0].forEach((element) => {
          if (!element) {
            if (this.brad.length > 0) {
              this.allInOneData[0] = [this.brad];
            }
          }
        });
      }
  
      if (this.days90 === false) {
        if (this.ninetyDaysLastCheck === true) {
          this.days90 = true;
        } else {
          this.days90 = false;
        }
      }
      var sortField = "created_on";
      var sortOrderValue = 1;
  
      if (this.CONFIG.title === "AvonSeals" || this.CONFIG.title === "LinenRaj" || this.CONFIG.title === "Vistas" || this.CONFIG.title === "SpecialWires" || this.CONFIG.title==="BestGifts" ||this.CONFIG.title==="Carience") {
        // console.log("test for API hit",this.allInOneData[12] ) 
        // if(this.allInOneData[12][0]==""){
        // this.allInOneData[12]=[];
        // console.log("test for yadhu API",this.allInOneData[12] ) 
        // }
        // if(this.allInOneData[6][0]==""){
        //   this.allInOneData[6]=[];
        //   console.log("test for yadhu API",this.allInOneData[12] ) 
        //   }
        this.req_filter_data2 = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: null,
          extras: {
            find: {
              brand:
                this.allInOneData[0] != "" &&
                this.allInOneData[0] != undefined &&
                this.allInOneData[0] != null
                  ? this.allInOneData[0]
                  : [],
              category: this.allInOneData[1],
              theme:
                this.allInOneData[3] != "" &&
                this.allInOneData[3] != undefined &&
                this.allInOneData[3] != null
                  ? this.allInOneData[3]
                  : [],
              finish:
                this.allInOneData[4] != "" &&
                this.allInOneData[4] != undefined &&
                this.allInOneData[4] != null
                  ? this.allInOneData[4]
                  : [],
              feature:
                this.allInOneData[5] != "" &&
                this.allInOneData[5] != undefined &&
                this.allInOneData[5] != null
                  ? this.allInOneData[5]
                  : [],
              price:
                this.allInOneData[6] != "" &&
                this.allInOneData[6] != undefined &&
                this.allInOneData[6] != null
                  ? this.allInOneData[6]
                  : [],
              size:
                this.allInOneData[7] != "" &&
                this.allInOneData[7] != undefined &&
                this.allInOneData[7] != null
                  ? this.allInOneData[7]
                  : [],
              thickness:
                this.allInOneData[8] != "" &&
                this.allInOneData[8] != undefined &&
                this.allInOneData[8] != null
                  ? this.allInOneData[8]
                  : [],
              color:
                this.allInOneData[9] != "" &&
                this.allInOneData[9] != undefined &&
                this.allInOneData[9] != null
                  ? this.allInOneData[9]
                  : [],
              type:
                this.allInOneData[10] != "" &&
                this.allInOneData[10] != undefined &&
                this.allInOneData[10] != null
                  ? this.allInOneData[10]
                  : [],
              product_material:
                this.allInOneData[11] != "" &&
                this.allInOneData[11] != undefined &&
                this.allInOneData[11] != null
                  ? this.allInOneData[11]
                  : [],
                  age:
                  this.allInOneData[12] != "" &&
                  this.allInOneData[12] != undefined &&
                  this.allInOneData[12] != null
                    ? this.allInOneData[12]
                    : [],
                  affiliation:
                  this.allInOneData[13] != "" &&
                  this.allInOneData[13] != undefined &&
                  this.allInOneData[13] != null
                  ? this.allInOneData[13]
                  : [],
                  standard:
                  this.allInOneData[14] != "" &&
                  this.allInOneData[14] != undefined &&
                  this.allInOneData[14] != null
                    ? this.allInOneData[14]
                    : [],
                    subject:
                  this.allInOneData[15] != "" &&
                  this.allInOneData[15] != undefined &&
                  this.allInOneData[15] != null
                    ? this.allInOneData[15]
                    : [],
                    year:
                  this.allInOneData[16] != "" &&
                  this.allInOneData[16] != undefined &&
                  this.allInOneData[16] != null
                    ? this.allInOneData[16]
                    : [],
                    price_range:
                this.allInOneData[17] != "" &&
                this.allInOneData[17] != undefined &&
                this.allInOneData[17] != null
                  ? this.allInOneData[17]
                  : [],
              last90days: this.days90,
              last30days: this.days30,
              includeoutofstock: this.include,
              isglobalfilter: true,
            },
            pagination: true,
            paginationDetails: {
              limit: event,
              pagesize: 25,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "name",
              sortorder: this.dataFilter === "az" ? -1 : +1,
            },
            subcategoryfilter: false,
          },
        };
      }
      else if (this.CONFIG.title === "Babys Pride") {
        console.log("test for API hit",this.allInOneData[12] ) 
        if(this.allInOneData[12][0]==""){
        this.allInOneData[12]=[];
        console.log("test for yadhu API",this.allInOneData[12] ) 
        }
        if(this.allInOneData[6][0]==""){
          this.allInOneData[6]=[];
          console.log("test for yadhu API" ) 
          }
        this.req_filter_data2 = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: null,
          extras: {
            find: {
              brand:
                this.allInOneData[0] != "" &&
                this.allInOneData[0] != undefined &&
                this.allInOneData[0] != null
                  ? this.allInOneData[0]
                  : [],
              category: this.allInOneData[1],
              theme:
                this.allInOneData[3] != "" &&
                this.allInOneData[3] != undefined &&
                this.allInOneData[3] != null
                  ? this.allInOneData[3]
                  : [],
              finish:
                this.allInOneData[4] != "" &&
                this.allInOneData[4] != undefined &&
                this.allInOneData[4] != null
                  ? this.allInOneData[4]
                  : [],
              feature:
                this.allInOneData[5] != "" &&
                this.allInOneData[5] != undefined &&
                this.allInOneData[5] != null
                  ? this.allInOneData[5]
                  : [],
              price:
                this.allInOneData[6] != "" &&
                this.allInOneData[6] != undefined &&
                this.allInOneData[6] != null
                  ? this.allInOneData[6]
                  : [],
              size:
                this.allInOneData[7] != "" &&
                this.allInOneData[7] != undefined &&
                this.allInOneData[7] != null
                  ? this.allInOneData[7]
                  : [],
              thickness:
                this.allInOneData[8] != "" &&
                this.allInOneData[8] != undefined &&
                this.allInOneData[8] != null
                  ? this.allInOneData[8]
                  : [],
              color:
                this.allInOneData[9] != "" &&
                this.allInOneData[9] != undefined &&
                this.allInOneData[9] != null
                  ? this.allInOneData[9]
                  : [],
              type:
                this.allInOneData[10] != "" &&
                this.allInOneData[10] != undefined &&
                this.allInOneData[10] != null
                  ? this.allInOneData[10]
                  : [],
              product_material:
                this.allInOneData[11] != "" &&
                this.allInOneData[11] != undefined &&
                this.allInOneData[11] != null
                  ? this.allInOneData[11]
                  : [],
                  age:
                  this.allInOneData[12] != "" &&
                  this.allInOneData[12] != undefined &&
                  this.allInOneData[12] != null
                    ? this.allInOneData[12]
                    : [],
                    affiliation:
                    this.allInOneData[13] != "" &&
                    this.allInOneData[13] != undefined &&
                    this.allInOneData[13] != null
                      ? this.allInOneData[13]
                      : [],
                      standard:
                  this.allInOneData[14] != "" &&
                  this.allInOneData[14] != undefined &&
                  this.allInOneData[14] != null
                    ? this.allInOneData[14]
                    : [],
                    subject:
                  this.allInOneData[15] != "" &&
                  this.allInOneData[15] != undefined &&
                  this.allInOneData[15] != null
                    ? this.allInOneData[15]
                    : [],
                    year:
                  this.allInOneData[16] != "" &&
                  this.allInOneData[16] != undefined &&
                  this.allInOneData[16] != null
                    ? this.allInOneData[16]
                    : [],
                    price_range:
                this.allInOneData[17] != "" &&
                this.allInOneData[17] != undefined &&
                this.allInOneData[17] != null
                  ? this.allInOneData[17]
                  : [],
              last90days: this.days90,
              last30days: this.days30,
              includeoutofstock: this.include,
              isglobalfilter: true,
            },
            pagination: true,
            paginationDetails: {
              limit: event,
              pagesize: 25,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "name",
              sortorder: this.dataFilter === "az" ? -1 : +1,
            },
            subcategoryfilter: false,
          },
        };
      }
      else if (this.CONFIG.title === "LushNGreen") {
        console.log("test for API hit",this.allInOneData[12] ) 
        if(this.allInOneData[12][0]==""){
        this.allInOneData[12]=[];
        console.log("test for yadhu API",this.allInOneData[12] ) 
        }
        if(this.allInOneData[6][0]==""){
          this.allInOneData[6]=[];
          console.log("test for yadhu API",this.allInOneData[12] ) 
          }
        this.req_filter_data2 = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: null,
          extras: {
            find: {
              brand:
                this.allInOneData[0] != "" &&
                this.allInOneData[0] != undefined &&
                this.allInOneData[0] != null
                  ? this.allInOneData[0]
                  : [],
              category: this.allInOneData[1],
              theme:
                this.allInOneData[3] != "" &&
                this.allInOneData[3] != undefined &&
                this.allInOneData[3] != null
                  ? this.allInOneData[3]
                  : [],
              finish:
                this.allInOneData[4] != "" &&
                this.allInOneData[4] != undefined &&
                this.allInOneData[4] != null
                  ? this.allInOneData[4]
                  : [],
              feature:
                this.allInOneData[5] != "" &&
                this.allInOneData[5] != undefined &&
                this.allInOneData[5] != null
                  ? this.allInOneData[5]
                  : [],
              price:
                this.allInOneData[6] != "" &&
                this.allInOneData[6] != undefined &&
                this.allInOneData[6] != null
                  ? this.allInOneData[6]
                  : [],
              size:
                this.allInOneData[7] != "" &&
                this.allInOneData[7] != undefined &&
                this.allInOneData[7] != null
                  ? this.allInOneData[7]
                  : [],
              thickness:
                this.allInOneData[8] != "" &&
                this.allInOneData[8] != undefined &&
                this.allInOneData[8] != null
                  ? this.allInOneData[8]
                  : [],
              color:
                this.allInOneData[9] != "" &&
                this.allInOneData[9] != undefined &&
                this.allInOneData[9] != null
                  ? this.allInOneData[9]
                  : [],
              type:
                this.allInOneData[10] != "" &&
                this.allInOneData[10] != undefined &&
                this.allInOneData[10] != null
                  ? this.allInOneData[10]
                  : [],
              product_material:
                this.allInOneData[11] != "" &&
                this.allInOneData[11] != undefined &&
                this.allInOneData[11] != null
                  ? this.allInOneData[11]
                  : [],
                  age:
                  this.allInOneData[12] != "" &&
                  this.allInOneData[12] != undefined &&
                  this.allInOneData[12] != null
                    ? this.allInOneData[12]
                    : [],
                  affiliation:
                  this.allInOneData[13] != "" &&
                  this.allInOneData[13] != undefined &&
                  this.allInOneData[13] != null
                    ? this.allInOneData[13]
                    : [],
                    standard:
                  this.allInOneData[14] != "" &&
                  this.allInOneData[14] != undefined &&
                  this.allInOneData[14] != null
                    ? this.allInOneData[14]
                    : [],
                    subject:
                  this.allInOneData[15] != "" &&
                  this.allInOneData[15] != undefined &&
                  this.allInOneData[15] != null
                    ? this.allInOneData[15]
                    : [],
                    year:
                  this.allInOneData[16] != "" &&
                  this.allInOneData[16] != undefined &&
                  this.allInOneData[16] != null
                    ? this.allInOneData[16]
                    : [],
                    price_range:
                this.allInOneData[17] != "" &&
                this.allInOneData[17] != undefined &&
                this.allInOneData[17] != null
                  ? this.allInOneData[17]
                  : [],
              last90days: this.days90,
              last30days: this.days30,
              includeoutofstock: this.include,
              isglobalfilter: true,
            },
            pagination: true,
            paginationDetails: {
              limit: event,
              pagesize: 25,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "name",
              sortorder: this.dataFilter === "az" ? -1 : +1,
            },
            subcategoryfilter: false,
          },
        };
      }
      else if (this.CONFIG.title === "KatbookStore") {
        console.log("test for categoryyyyyyyyyyyyyyyyyyyyyyyyyyyy",this.allInOneData[1])
        console.log("test for API hit",this.allInOneData[12] ) 
        if(this.allInOneData[12][0]==""){
        this.allInOneData[12]=[];
        console.log("test for yadhu API",this.allInOneData[12] ) 
        }
        console.log("plot for split", this.allInOneData[1])
        if(this.allInOneData[1] != ""){
        this.allInOneData[1] = this.allInOneData[1].split(",");
      }
        if(this.allInOneData[1][0]==""){
          this.allInOneData[1]=[];
          console.log("test for yadhu Category API",this.allInOneData[1] ) 
          }
        if(this.allInOneData[13][0]==""){
          this.allInOneData[13]=[];
          console.log("test for yadhu API aff",this.allInOneData[13] ) 
          }
          if(this.allInOneData[14][0]==""){
            this.allInOneData[14]=[];
            console.log("test for yadhu API Stand",this.allInOneData[14] ) 
            }
            if(this.allInOneData[15][0]==""){
              this.allInOneData[15]=[];
              console.log("test for yadhu API Subj",this.allInOneData[15] ) 
              }
              if(this.allInOneData[16][0]==""){
                this.allInOneData[16]=[];
                console.log("test for yadhu API Year",this.allInOneData[16] ) 
                }
        if(this.allInOneData[17][0]==""){
          this.allInOneData[17]=[];
          console.log("test for yadhu API",this.allInOneData[17] ) 
          }
        this.req_filter_data2 = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: null,
          extras: {
            find: {
              brand:
                this.allInOneData[0] != "" &&
                this.allInOneData[0] != undefined &&
                this.allInOneData[0] != null
                  ? this.allInOneData[0]
                  : [],
              category: this.allInOneData[1] != "" &&
              this.allInOneData[1] != undefined &&
              this.allInOneData[1] != null
                ? this.allInOneData[1]
                : [],
              theme:
                this.allInOneData[3] != "" &&
                this.allInOneData[3] != undefined &&
                this.allInOneData[3] != null
                  ? this.allInOneData[3]
                  : [],
              finish:
                this.allInOneData[4] != "" &&
                this.allInOneData[4] != undefined &&
                this.allInOneData[4] != null
                  ? this.allInOneData[4]
                  : [],
              feature:
                this.allInOneData[5] != "" &&
                this.allInOneData[5] != undefined &&
                this.allInOneData[5] != null
                  ? this.allInOneData[5]
                  : [],
              price:
                this.allInOneData[6] != "" &&
                this.allInOneData[6] != undefined &&
                this.allInOneData[6] != null
                  ? this.allInOneData[6]
                  : [],
              size:
                this.allInOneData[7] != "" &&
                this.allInOneData[7] != undefined &&
                this.allInOneData[7] != null
                  ? this.allInOneData[7]
                  : [],
              thickness:
                this.allInOneData[8] != "" &&
                this.allInOneData[8] != undefined &&
                this.allInOneData[8] != null
                  ? this.allInOneData[8]
                  : [],
              color:
                this.allInOneData[9] != "" &&
                this.allInOneData[9] != undefined &&
                this.allInOneData[9] != null
                  ? this.allInOneData[9]
                  : [],
              type:
                this.allInOneData[10] != "" &&
                this.allInOneData[10] != undefined &&
                this.allInOneData[10] != null
                  ? this.allInOneData[10]
                  : [],
              product_material:
                this.allInOneData[11] != "" &&
                this.allInOneData[11] != undefined &&
                this.allInOneData[11] != null
                  ? this.allInOneData[11]
                  : [],
                  age:
                  this.allInOneData[12] != "" &&
                  this.allInOneData[12] != undefined &&
                  this.allInOneData[12] != null
                    ? this.allInOneData[12]
                    : [],
                  affiliation:
                  this.allInOneData[13] != "" &&
                  this.allInOneData[13] != undefined &&
                  this.allInOneData[13] != null
                    ? this.allInOneData[13]
                    : [],
                    standard:
                  this.allInOneData[14] != "" &&
                  this.allInOneData[14] != undefined &&
                  this.allInOneData[14] != null
                    ? this.allInOneData[14]
                    : [],
                    subject:
                  this.allInOneData[15] != "" &&
                  this.allInOneData[15] != undefined &&
                  this.allInOneData[15] != null
                    ? this.allInOneData[15]
                    : [],
                    year:
                  this.allInOneData[16] != "" &&
                  this.allInOneData[16] != undefined &&
                  this.allInOneData[16] != null
                    ? this.allInOneData[16]
                    : [],
                    price_range:
                this.allInOneData[17] != "" &&
                this.allInOneData[17] != undefined &&
                this.allInOneData[17] != null
                  ? this.allInOneData[17]
                  : [],
              last90days: this.days90,
              last30days: this.days30,
              includeoutofstock: this.include,
              isglobalfilter: false,
            },
            pagination: true,
            paginationDetails: {
              limit: event,
              pagesize: 25,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "name",
              sortorder: this.dataFilter === "az" ? -1 : +1,
            },
            subcategoryfilter: false,
          },
        };
      }
      else if(this.CONFIG.title === "Karupattiraja" || this.CONFIG.title === "Schift Cosmetics" ){
        console.log("hhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhh"+this.outletId)
        this.req_filter_data2 = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: null,
          outlet_id:Number(this.outletId),
          // "outlet_id":"",
          extras: {
            find: {
              brand:
                this.allInOneData[0] != "" &&
                this.allInOneData[0] != undefined &&
                this.allInOneData[0] != null
                  ? this.allInOneData[0]
                  : [],
              category: this.allInOneData[1],
              theme:
                this.allInOneData[3] != "" &&
                this.allInOneData[3] != undefined &&
                this.allInOneData[3] != null
                  ? this.allInOneData[3]
                  : [],
              finish:
                this.allInOneData[4] != "" &&
                this.allInOneData[4] != undefined &&
                this.allInOneData[4] != null
                  ? this.allInOneData[4]
                  : [],
              feature:
                this.allInOneData[5] != "" &&
                this.allInOneData[5] != undefined &&
                this.allInOneData[5] != null
                  ? this.allInOneData[5]
                  : [],
              price:
                this.allInOneData[6] != "" &&
                this.allInOneData[6] != undefined &&
                this.allInOneData[6] != null
                  ? this.allInOneData[6]
                  : [],
              size:
                this.allInOneData[7] != "" &&
                this.allInOneData[7] != undefined &&
                this.allInOneData[7] != null
                  ? this.allInOneData[7]
                  : [],
              thickness:
                this.allInOneData[8] != "" &&
                this.allInOneData[8] != undefined &&
                this.allInOneData[8] != null
                  ? this.allInOneData[8]
                  : [],
              color:
                this.allInOneData[9] != "" &&
                this.allInOneData[9] != undefined &&
                this.allInOneData[9] != null
                  ? this.allInOneData[9]
                  : [],
              type:
                this.allInOneData[10] != "" &&
                this.allInOneData[10] != undefined &&
                this.allInOneData[10] != null
                  ? this.allInOneData[10]
                  : [],
              product_material:
                this.allInOneData[11] != "" &&
                this.allInOneData[11] != undefined &&
                this.allInOneData[11] != null
                  ? this.allInOneData[11]
                  : [],
                  age:
                this.allInOneData[12] != "" &&
                this.allInOneData[12] != undefined &&
                this.allInOneData[12] != null
                  ? this.allInOneData[12]
                  : [],
                affiliation:
                this.allInOneData[13] != "" &&
                this.allInOneData[13] != undefined &&
                this.allInOneData[13] != null
                  ? this.allInOneData[13]
                  : [],
                  standard:
                  this.allInOneData[14] != "" &&
                  this.allInOneData[14] != undefined &&
                  this.allInOneData[14] != null
                    ? this.allInOneData[14]
                    : [],
                    subject:
                  this.allInOneData[15] != "" &&
                  this.allInOneData[15] != undefined &&
                  this.allInOneData[15] != null
                    ? this.allInOneData[15]
                    : [],
                    year:
                  this.allInOneData[16] != "" &&
                  this.allInOneData[16] != undefined &&
                  this.allInOneData[16] != null
                    ? this.allInOneData[16]
                    : [],
                    price_range:
                this.allInOneData[17] != "" &&
                this.allInOneData[17] != undefined &&
                this.allInOneData[17] != null
                  ? this.allInOneData[17]
                  : [],
              last90days: this.days90,
              last30days: this.days30,
              includeoutofstock: this.include,
              isglobalfilter: true,
            },
            pagination: true,
            paginationDetails: {
              limit: event,
              pagesize: 25,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "name",
              sortorder: this.dataFilter === "az" ? -1 : +1,
            },
            subcategoryfilter: false,
          },
        };
      } 
      else if(this.CONFIG.title === "Deera"){
        console.log("hhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhh"+this.outletId)
        if(this.allInOneData[9][0]==""){
          this.allInOneData[9]=[];
          console.log("test for yadhu API Subj",this.allInOneData[15] ) 
          }
          if(this.allInOneData[18][0]==""){
            this.allInOneData[18]=[];
            console.log("test for yadhu API Subj",this.allInOneData[15] ) 
            }
        this.req_filter_data2 = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: null,
          outlet_id:Number(this.outletId),
          // "outlet_id":"",
          extras: {
            find: {
              brand:
                this.allInOneData[0] != "" &&
                this.allInOneData[0] != undefined &&
                this.allInOneData[0] != null
                  ? this.allInOneData[0]
                  : [],
              category: this.allInOneData[1],
              theme:
                this.allInOneData[3] != "" &&
                this.allInOneData[3] != undefined &&
                this.allInOneData[3] != null
                  ? this.allInOneData[3]
                  : [],
              finish:
                this.allInOneData[4] != "" &&
                this.allInOneData[4] != undefined &&
                this.allInOneData[4] != null
                  ? this.allInOneData[4]
                  : [],
              feature:
                this.allInOneData[5] != "" &&
                this.allInOneData[5] != undefined &&
                this.allInOneData[5] != null
                  ? this.allInOneData[5]
                  : [],
              price:
                this.allInOneData[6] != "" &&
                this.allInOneData[6] != undefined &&
                this.allInOneData[6] != null
                  ? this.allInOneData[6]
                  : [],
              size:
                this.allInOneData[7] != "" &&
                this.allInOneData[7] != undefined &&
                this.allInOneData[7] != null
                  ? this.allInOneData[7]
                  : [],
              thickness:
                this.allInOneData[8] != "" &&
                this.allInOneData[8] != undefined &&
                this.allInOneData[8] != null
                  ? this.allInOneData[8]
                  : [],
              color:
                this.allInOneData[9] != "" &&
                this.allInOneData[9] != undefined &&
                this.allInOneData[9] != null
                  ? [this.allInOneData[9]]
                  : [],
              type:
                this.allInOneData[10] != "" &&
                this.allInOneData[10] != undefined &&
                this.allInOneData[10] != null
                  ? this.allInOneData[10]
                  : [],
              product_material:
                this.allInOneData[11] != "" &&
                this.allInOneData[11] != undefined &&
                this.allInOneData[11] != null
                  ? this.allInOneData[11]
                  : [],
                  age:
                this.allInOneData[12] != "" &&
                this.allInOneData[12] != undefined &&
                this.allInOneData[12] != null
                  ? this.allInOneData[12]
                  : [],
                affiliation:
                this.allInOneData[13] != "" &&
                this.allInOneData[13] != undefined &&
                this.allInOneData[13] != null
                  ? this.allInOneData[13]
                  : [],
                  standard:
                  this.allInOneData[14] != "" &&
                  this.allInOneData[14] != undefined &&
                  this.allInOneData[14] != null
                    ? this.allInOneData[14]
                    : [],
                    subject:
                  this.allInOneData[15] != "" &&
                  this.allInOneData[15] != undefined &&
                  this.allInOneData[15] != null
                    ? this.allInOneData[15]
                    : [],
                    year:
                  this.allInOneData[16] != "" &&
                  this.allInOneData[16] != undefined &&
                  this.allInOneData[16] != null
                    ? this.allInOneData[16]
                    : [],
                    price_range:
                this.allInOneData[17] != "" &&
                this.allInOneData[17] != undefined &&
                this.allInOneData[17] != null
                  ? this.allInOneData[17]
                  : [],
                  dimension:
                  this.allInOneData[18] != "" &&
                  this.allInOneData[18] != undefined &&
                  this.allInOneData[18] != null
                    ? [this.allInOneData[18]]
                    : [],
              last90days: this.days90,
              last30days: this.days30,
              includeoutofstock: this.include,
              isglobalfilter: true,
            },
            pagination: true,
            paginationDetails: {
              limit: event,
              pagesize: 25,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "name",
              sortorder: this.dataFilter === "az" ? -1 : +1,
            },
            subcategoryfilter: false,
          },
        };
      }
      else if (this.CONFIG.title==="Vimpro") {
        this.req_filter_data2 = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: null,
          extras: {
            find: {
              brand:
                this.allInOneData[0] != "" &&
                this.allInOneData[0] != undefined &&
                this.allInOneData[0] != null
                  ? this.allInOneData[0]
                  : [],
              category: this.allInOneData[1],
              theme:
                this.allInOneData[3] != "" &&
                this.allInOneData[3] != undefined &&
                this.allInOneData[3] != null
                  ? this.allInOneData[3]
                  : [],
              finish:
                this.allInOneData[4] != "" &&
                this.allInOneData[4] != undefined &&
                this.allInOneData[4] != null
                  ? this.allInOneData[4]
                  : [],
              feature:
                this.allInOneData[5] != "" &&
                this.allInOneData[5] != undefined &&
                this.allInOneData[5] != null
                  ? this.allInOneData[5]
                  : [],
              price:
                this.allInOneData[6] != "" &&
                this.allInOneData[6] != undefined &&
                this.allInOneData[6] != null
                  ? this.allInOneData[6]
                  : [],
              size:
                this.allInOneData[7] != "" &&
                this.allInOneData[7] != undefined &&
                this.allInOneData[7] != null
                  ? this.allInOneData[7]
                  : [],
              thickness:
                this.allInOneData[8] != "" &&
                this.allInOneData[8] != undefined &&
                this.allInOneData[8] != null
                  ? this.allInOneData[8]
                  : [],
              color:
                this.allInOneData[9] != "" &&
                this.allInOneData[9] != undefined &&
                this.allInOneData[9] != null
                  ? this.allInOneData[9]
                  : [],
              type:
                this.allInOneData[10] != "" &&
                this.allInOneData[10] != undefined &&
                this.allInOneData[10] != null
                  ? this.allInOneData[10]
                  : [],
              product_material:
                this.allInOneData[11] != "" &&
                this.allInOneData[11] != undefined &&
                this.allInOneData[11] != null
                  ? this.allInOneData[11]
                  : [],
                  age:
                  this.allInOneData[12] != "" &&
                  this.allInOneData[12] != undefined &&
                  this.allInOneData[12] != null
                    ? this.allInOneData[12]
                    : [],
                  affiliation:
                  this.allInOneData[13] != "" &&
                  this.allInOneData[13] != undefined &&
                  this.allInOneData[13] != null
                    ? this.allInOneData[13]
                    : [],
                    standard:
                  this.allInOneData[14] != "" &&
                  this.allInOneData[14] != undefined &&
                  this.allInOneData[14] != null
                    ? this.allInOneData[14]
                    : [],
                    subject:
                  this.allInOneData[15] != "" &&
                  this.allInOneData[15] != undefined &&
                  this.allInOneData[15] != null
                    ? this.allInOneData[15]
                    : [],
                    year:
                  this.allInOneData[16] != "" &&
                  this.allInOneData[16] != undefined &&
                  this.allInOneData[16] != null
                    ? this.allInOneData[16]
                    : [],
                    price_range:
                this.allInOneData[17] != "" &&
                this.allInOneData[17] != undefined &&
                this.allInOneData[17] != null
                  ? this.allInOneData[17]
                  : [],
              last90days: this.days90,
              last30days: this.days30,
              includeoutofstock: this.include,
              isglobalfilter: false,
            },
            pagination: true,
            paginationDetails: {
              limit: event,
              pagesize: 25,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "sort_order",
              //sortfield: "id",
             // sortorder: 'sort_order'
              sortorder: this.dataFilter === "az" ? -1 : +1,
            },
            subcategoryfilter: false,
          },
        };
      }
      else  if (this.CONFIG.title === "BombayHardware") {
        this.req_filter_data2 = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: null,
          extras: {
            find: {
              brand:
                this.allInOneData[0] != "" &&
                this.allInOneData[0] != undefined &&
                this.allInOneData[0] != null
                  ? this.allInOneData[0]
                  : [],
              category: this.allInOneData[1],
              theme:
                this.allInOneData[3] != "" &&
                this.allInOneData[3] != undefined &&
                this.allInOneData[3] != null
                  ? this.allInOneData[3]
                  : [],
              finish:
                this.allInOneData[4] != "" &&
                this.allInOneData[4] != undefined &&
                this.allInOneData[4] != null
                  ? this.allInOneData[4]
                  : [],
              feature:
                this.allInOneData[5] != "" &&
                this.allInOneData[5] != undefined &&
                this.allInOneData[5] != null
                  ? this.allInOneData[5]
                  : [],
              price:
                this.allInOneData[6] != "" &&
                this.allInOneData[6] != undefined &&
                this.allInOneData[6] != null
                  ? this.allInOneData[6]
                  : [],
              size:
                this.allInOneData[7] != "" &&
                this.allInOneData[7] != undefined &&
                this.allInOneData[7] != null
                  ? this.allInOneData[7]
                  : [],
              thickness:
                this.allInOneData[8] != "" &&
                this.allInOneData[8] != undefined &&
                this.allInOneData[8] != null
                  ? this.allInOneData[8]
                  : [],
              color:
                this.allInOneData[9] != "" &&
                this.allInOneData[9] != undefined &&
                this.allInOneData[9] != null
                  ? this.allInOneData[9]
                  : [],
              type:
                this.allInOneData[10] != "" &&
                this.allInOneData[10] != undefined &&
                this.allInOneData[10] != null
                  ? this.allInOneData[10]
                  : [],
              product_material:
                this.allInOneData[11] != "" &&
                this.allInOneData[11] != undefined &&
                this.allInOneData[11] != null
                  ? this.allInOneData[11]
                  : [],
                  age:
                  this.allInOneData[12] != "" &&
                  this.allInOneData[12] != undefined &&
                  this.allInOneData[12] != null
                    ? this.allInOneData[12]
                    : [],
                  affiliation:
                  this.allInOneData[13] != "" &&
                  this.allInOneData[13] != undefined &&
                  this.allInOneData[13] != null
                    ? this.allInOneData[13]
                    : [],
                    standard:
                  this.allInOneData[14] != "" &&
                  this.allInOneData[14] != undefined &&
                  this.allInOneData[14] != null
                    ? this.allInOneData[14]
                    : [],
                    subject:
                  this.allInOneData[15] != "" &&
                  this.allInOneData[15] != undefined &&
                  this.allInOneData[15] != null
                    ? this.allInOneData[15]
                    : [],
                    year:
                  this.allInOneData[16] != "" &&
                  this.allInOneData[16] != undefined &&
                  this.allInOneData[16] != null
                    ? this.allInOneData[16]
                    : [],
                    price_range:
                this.allInOneData[17] != "" &&
                this.allInOneData[17] != undefined &&
                this.allInOneData[17] != null
                  ? this.allInOneData[17]
                  : [],
              last90days: this.days90,
              last30days: this.days30,
              includeoutofstock: this.include,
              isglobalfilter: false,
            },
            pagination: true,
            paginationDetails: {
              limit: event,
              pagesize: 25,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "sort_order",
              sortorder: this.dataFilter === "az" ? -1 : +1,
            },
            subcategoryfilter: false,
          },
        };
      }
      else  if (this.CONFIG.title === "Kubendran") {
        this.req_filter_data2 = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: null,
          extras: {
            find: {
              brand:
                this.allInOneData[0] != "" &&
                this.allInOneData[0] != undefined &&
                this.allInOneData[0] != null
                  ? this.allInOneData[0]
                  : [],
              category: this.allInOneData[1],
              theme:
                this.allInOneData[3] != "" &&
                this.allInOneData[3] != undefined &&
                this.allInOneData[3] != null
                  ? this.allInOneData[3]
                  : [],
              finish:
                this.allInOneData[4] != "" &&
                this.allInOneData[4] != undefined &&
                this.allInOneData[4] != null
                  ? this.allInOneData[4]
                  : [],
              feature:
                this.allInOneData[5] != "" &&
                this.allInOneData[5] != undefined &&
                this.allInOneData[5] != null
                  ? this.allInOneData[5]
                  : [],
              price:
                this.allInOneData[6] != "" &&
                this.allInOneData[6] != undefined &&
                this.allInOneData[6] != null
                  ? this.allInOneData[6]
                  : [],
              size:
                this.allInOneData[7] != "" &&
                this.allInOneData[7] != undefined &&
                this.allInOneData[7] != null
                  ? this.allInOneData[7]
                  : [],
              thickness:
                this.allInOneData[8] != "" &&
                this.allInOneData[8] != undefined &&
                this.allInOneData[8] != null
                  ? this.allInOneData[8]
                  : [],
              color:
                this.allInOneData[9] != "" &&
                this.allInOneData[9] != undefined &&
                this.allInOneData[9] != null
                  ? this.allInOneData[9]
                  : [],
              type:
                this.allInOneData[10] != "" &&
                this.allInOneData[10] != undefined &&
                this.allInOneData[10] != null
                  ? this.allInOneData[10]
                  : [],
              product_material:
                this.allInOneData[11] != "" &&
                this.allInOneData[11] != undefined &&
                this.allInOneData[11] != null
                  ? this.allInOneData[11]
                  : [],
                  age:
                  this.allInOneData[12] != "" &&
                  this.allInOneData[12] != undefined &&
                  this.allInOneData[12] != null
                    ? this.allInOneData[12]
                    : [],
                  affiliation:
                  this.allInOneData[13] != "" &&
                  this.allInOneData[13] != undefined &&
                  this.allInOneData[13] != null
                    ? this.allInOneData[13]
                    : [],
                    standard:
                  this.allInOneData[14] != "" &&
                  this.allInOneData[14] != undefined &&
                  this.allInOneData[14] != null
                    ? this.allInOneData[14]
                    : [],
                    subject:
                  this.allInOneData[15] != "" &&
                  this.allInOneData[15] != undefined &&
                  this.allInOneData[15] != null
                    ? this.allInOneData[15]
                    : [],
                    year:
                  this.allInOneData[16] != "" &&
                  this.allInOneData[16] != undefined &&
                  this.allInOneData[16] != null
                    ? this.allInOneData[16]
                    : [],
                    price_range:
                this.allInOneData[17] != "" &&
                this.allInOneData[17] != undefined &&
                this.allInOneData[17] != null
                  ? this.allInOneData[17]
                  : [],
              last90days: this.days90,
              last30days: this.days30,
              includeoutofstock: this.include,
              isglobalfilter: true,
            },
            pagination: true,
            paginationDetails: {
              limit: event,
              pagesize: 25,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "sort_order",
              sortorder: this.dataFilter === "az" ? -1 : +1,
            },
            subcategoryfilter: false,
          },
        };
      }
      else if(this.CONFIG.title === "Taazah" ) {
        console.log("test for categoryyyyyyyyyyyyyyyyyyyyyyyyyyyy",this.allInOneData[1])
        this.req_filter_data2 = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: null,
          extras: {
            find: {
              brand:
                this.allInOneData[0] != "" &&
                this.allInOneData[0] != undefined &&
                this.allInOneData[0] != null
                  ? this.allInOneData[0]
                  : [],
              category: this.allInOneData[1],
              theme:
                this.allInOneData[3] != "" &&
                this.allInOneData[3] != undefined &&
                this.allInOneData[3] != null
                  ? this.allInOneData[3]
                  : [],
              finish:
                this.allInOneData[4] != "" &&
                this.allInOneData[4] != undefined &&
                this.allInOneData[4] != null
                  ? this.allInOneData[4]
                  : [],
              feature:
                this.allInOneData[5] != "" &&
                this.allInOneData[5] != undefined &&
                this.allInOneData[5] != null
                  ? this.allInOneData[5]
                  : [],
              price:
                this.allInOneData[6] != "" &&
                this.allInOneData[6] != undefined &&
                this.allInOneData[6] != null
                  ? this.allInOneData[6]
                  : [],
              size:
                this.allInOneData[7] != "" &&
                this.allInOneData[7] != undefined &&
                this.allInOneData[7] != null
                  ? this.allInOneData[7]
                  : [],
              thickness:
                this.allInOneData[8] != "" &&
                this.allInOneData[8] != undefined &&
                this.allInOneData[8] != null
                  ? this.allInOneData[8]
                  : [],
              color:
                this.allInOneData[9] != "" &&
                this.allInOneData[9] != undefined &&
                this.allInOneData[9] != null
                  ? this.allInOneData[9]
                  : [],
              type:
                this.allInOneData[10] != "" &&
                this.allInOneData[10] != undefined &&
                this.allInOneData[10] != null
                  ? this.allInOneData[10]
                  : [],
              product_material:
                this.allInOneData[11] != "" &&
                this.allInOneData[11] != undefined &&
                this.allInOneData[11] != null
                  ? this.allInOneData[11]
                  : [],
                  age:
                  this.allInOneData[12] != "" &&
                  this.allInOneData[12] != undefined &&
                  this.allInOneData[12] != null
                    ? this.allInOneData[12]
                    : [],
                  affiliation:
                  this.allInOneData[13] != "" &&
                  this.allInOneData[13] != undefined &&
                  this.allInOneData[13] != null
                    ? this.allInOneData[13]
                    : [],
                    standard:
                  this.allInOneData[14] != "" &&
                  this.allInOneData[14] != undefined &&
                  this.allInOneData[14] != null
                    ? this.allInOneData[14]
                    : [],
                    subject:
                  this.allInOneData[15] != "" &&
                  this.allInOneData[15] != undefined &&
                  this.allInOneData[15] != null
                    ? this.allInOneData[15]
                    : [],
                    year:
                  this.allInOneData[16] != "" &&
                  this.allInOneData[16] != undefined &&
                  this.allInOneData[16] != null
                    ? this.allInOneData[16]
                    : [],
                    price_range:
                this.allInOneData[17] != "" &&
                this.allInOneData[17] != undefined &&
                this.allInOneData[17] != null
                  ? this.allInOneData[17]
                  : [],
              last90days: this.days90,
              last30days: this.days30,
              includeoutofstock: this.include,
            },
            pagination: true,
            paginationDetails: {
              limit: event,
              pagesize: this.taz_increment,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "name",
              sortorder: this.dataFilter === "az" ? -1 : +1,
            },
            subcategoryfilter: false,
          },
        };
      }
      else if(this.CONFIG.title === "Beaubelle" ){
        this.req_filter_data2 = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: null,
          extras: {
            find: {
                brand:
                this.allInOneData[0] != "" &&
                this.allInOneData[0] != undefined &&
                this.allInOneData[0] != null
                  ? this.allInOneData[0]
                  : [],
              category: this.allInOneData[1],
               theme:
                this.allInOneData[3] != "" &&
                this.allInOneData[3] != undefined &&
                this.allInOneData[3] != null
                  ? this.allInOneData[3]
                  : [],
              finish:
                this.allInOneData[4] != "" &&
                this.allInOneData[4] != undefined &&
                this.allInOneData[4] != null
                  ? this.allInOneData[4]
                  : [],
              feature:
                this.allInOneData[5] != "" &&
                this.allInOneData[5] != undefined &&
                this.allInOneData[5] != null
                  ? this.allInOneData[5]
                  : [],
              price:
                this.allInOneData[6] != "" &&
                this.allInOneData[6] != undefined &&
                this.allInOneData[6] != null
                  ? this.allInOneData[6]
                  : [],
              size:
                this.allInOneData[7] != "" &&
                this.allInOneData[7] != undefined &&
                this.allInOneData[7] != null
                  ? this.allInOneData[7]
                  : [],
              thickness:
                this.allInOneData[8] != "" &&
                this.allInOneData[8] != undefined &&
                this.allInOneData[8] != null
                  ? this.allInOneData[8]
                  : [],
              color:
                this.allInOneData[9] != "" &&
                this.allInOneData[9] != undefined &&
                this.allInOneData[9] != null
                  ? this.allInOneData[9]
                  : [],
              type:
                this.allInOneData[10] != "" &&
                this.allInOneData[10] != undefined &&
                this.allInOneData[10] != null
                  ? this.allInOneData[10]
                  : [],
              product_material:
                this.allInOneData[11] != "" &&
                this.allInOneData[11] != undefined &&
                this.allInOneData[11] != null
                  ? this.allInOneData[11]
                  : [],
                  age:
                  this.allInOneData[12] != "" &&
                  this.allInOneData[12] != undefined &&
                  this.allInOneData[12] != null
                    ? this.allInOneData[12]
                    : [],
                  affiliation:
                  this.allInOneData[13] != "" &&
                  this.allInOneData[13] != undefined &&
                  this.allInOneData[13] != null
                    ? this.allInOneData[13]
                    : [],
                    standard:
                  this.allInOneData[14] != "" &&
                  this.allInOneData[14] != undefined &&
                  this.allInOneData[14] != null
                    ? this.allInOneData[14]
                    : [],
                    subject:
                  this.allInOneData[15] != "" &&
                  this.allInOneData[15] != undefined &&
                  this.allInOneData[15] != null
                    ? this.allInOneData[15]
                    : [],
                    year:
                  this.allInOneData[16] != "" &&
                  this.allInOneData[16] != undefined &&
                  this.allInOneData[16] != null
                    ? this.allInOneData[16]
                    : [],
                    price_range:
                this.allInOneData[17] != "" &&
                this.allInOneData[17] != undefined &&
                this.allInOneData[17] != null
                  ? this.allInOneData[17]
                  : [],
              isglobalfilter:false,
               filters_based_on:"brand",
  
              last90days: this.days90,
              last30days: this.days30,
              includeoutofstock: this.include,
            },
            pagination: true,
            paginationDetails: {
              limit: event,
              pagesize: 25,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "name",
              sortorder: this.dataFilter === "az" ? -1 : +1,
            },
            subcategoryfilter: false,
          },
        };
  
  
      }
      
       else {
        console.log("test for categoryyyyyyyyyyyyyyyyyyyyyyyyyyyy",this.allInOneData[3])
        if(this.allInOneData[1][0]=="Classic" && this.category.length==0 ){
           this.activeTabIndex1=1;

        }
        else if (this.allInOneData[1][0]=="Elite" && this.category.length==0 ){
           this.activeTabIndex1=2;

        }
        else if (this.allInOneData[1][0]=="Luxury" && this.category.length==0 ){
           this.activeTabIndex1=3;

        }
        else if (this.allInOneData[1][0]=="Premium" && this.category.length==0 ) {
           this.activeTabIndex1=4;

        }
        else if (this.allInOneData[3]=="Arts of India"){
          this.showTheme=true;
          this.activeTabIndex=0;

        }
        else if (this.allInOneData[3]=="Floral"){
          this.showTheme=true;
          this.activeTabIndex=1;

        }
        else if (this.allInOneData[3]=="Indian Patterns"){
          this.showTheme=true;
          this.activeTabIndex=2;

        }
        else if (this.allInOneData[3]=="Laser Cut"){
          this.showTheme=true;
          this.activeTabIndex=3;

        }
        else if (this.allInOneData[3]=="Lotus"){
          this.showTheme=true;
          this.activeTabIndex=4;

        }
        else if (this.allInOneData[3]=="Peacock"){
          this.showTheme=true;
          this.activeTabIndex=5;

        }
        else if (this.allInOneData[3]=="Traditional"){
          this.showTheme=true;
          this.activeTabIndex=6;

        }
        else if (this.allInOneData[3]=="Tree Of Life"){
          this.showTheme=true;
          this.activeTabIndex=7;
          this.allInOneData[1]=[];

        }
        
       
        this.req_filter_data2 = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: null,
          extras: {
            find: {
              brand:
                this.allInOneData[0] != "" &&
                this.allInOneData[0] != undefined &&
                this.allInOneData[0] != null
                  ? this.allInOneData[0]
                  : [],
              category: this.allInOneData[1],
              theme:
                this.allInOneData[3] != "" &&
                this.allInOneData[3] != undefined &&
                this.allInOneData[3] != null
                  ? [this.allInOneData[3]]
                  : [],
              finish:
                this.allInOneData[4] != "" &&
                this.allInOneData[4] != undefined &&
                this.allInOneData[4] != null
                  ? this.allInOneData[4]
                  : [],
              feature:
                this.allInOneData[5] != "" &&
                this.allInOneData[5] != undefined &&
                this.allInOneData[5] != null
                  ? this.allInOneData[5]
                  : [],
              price:
                this.allInOneData[6] != "" &&
                this.allInOneData[6] != undefined &&
                this.allInOneData[6] != null
                  ? this.allInOneData[6]
                  : [],
              size:
                this.allInOneData[7] != "" &&
                this.allInOneData[7] != undefined &&
                this.allInOneData[7] != null
                  ? this.allInOneData[7]
                  : [],
              thickness:
                this.allInOneData[8] != "" &&
                this.allInOneData[8] != undefined &&
                this.allInOneData[8] != null
                  ? this.allInOneData[8]
                  : [],
              color:
                this.allInOneData[9] != "" &&
                this.allInOneData[9] != undefined &&
                this.allInOneData[9] != null
                  ? this.allInOneData[9]
                  : [],
              type:
                this.allInOneData[10] != "" &&
                this.allInOneData[10] != undefined &&
                this.allInOneData[10] != null
                  ? this.allInOneData[10]
                  : [],
              product_material:
                this.allInOneData[11] != "" &&
                this.allInOneData[11] != undefined &&
                this.allInOneData[11] != null
                  ? this.allInOneData[11]
                  : [],
                  age:
                  this.allInOneData[12] != "" &&
                  this.allInOneData[12] != undefined &&
                  this.allInOneData[12] != null
                    ? this.allInOneData[12]
                    : [],
                  affiliation:
                  this.allInOneData[13] != "" &&
                  this.allInOneData[13] != undefined &&
                  this.allInOneData[13] != null
                    ? this.allInOneData[13]
                    : [],
                    standard:
                  this.allInOneData[14] != "" &&
                  this.allInOneData[14] != undefined &&
                  this.allInOneData[14] != null
                    ? this.allInOneData[14]
                    : [],
                    subject:
                  this.allInOneData[15] != "" &&
                  this.allInOneData[15] != undefined &&
                  this.allInOneData[15] != null
                    ? this.allInOneData[15]
                    : [],
                    year:
                  this.allInOneData[16] != "" &&
                  this.allInOneData[16] != undefined &&
                  this.allInOneData[16] != null
                    ? this.allInOneData[16]
                    : [],
                    price_range:
                this.allInOneData[17] != "" &&
                this.allInOneData[17] != undefined &&
                this.allInOneData[17] != null
                  ? this.allInOneData[17]
                  : [],
              last90days: this.days90,
              last30days: this.days30,
              includeoutofstock: this.include,
            },
            pagination: true,
            paginationDetails: {
              limit: event,
              pagesize: 25,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "name",
              sortorder: this.dataFilter === "az" ? -1 : +1,
            },
            subcategoryfilter: false,
          },
        };
      }
  
  
      this.loaderService.emitLoading();
      if((this.low_to_high===false && this.high_to_low===false)&& this.CONFIG.title=="BestGifts"){
        console.log(this.low_to_high,this.high_to_low==false)
        try{
          this.appService
          .postApiCall(this.req_filter_data2, ENDPOINTS.GET_FILTER_PRODUCTS)
          .subscribe(
            (resp) => {
              //  this.allInOneData=[];
              this.pagenation = false;
              this.filtersApiData = resp;
               this.products = this.filtersApiData.result.data;
              this.totalNumberOfProducts = this.filtersApiData.result.total;
              this.taz_increment = 20;
              if(this.taz_increment>=this.filtersApiData.result.total.value){
                this.showMoreOption = false
                             }
                             else{
                              this.showMoreOption = true
                             }
              console.log("Test for total value in the api",this.filtersApiData.result.total.value)
              console.log("Test for no of values in the page",this.taz_increment)
               
  
  
              if (!this.isfilter) {
                this.isfilter = true;
                if (this.categoryList.length === 0) {
                  this.categoryList =
                    this.filtersApiData.result.filters[0].categories;
                    
                    
                }
                if (this.facets && this.facets.length === 0) {
                  this.facets = this.filtersApiData.result.filters[1].brands;
                }
                if (this.allInOneData[0].length === 1) {
                  this.allInOneData[0].forEach((element) => {
                    if (!element) {
                      this.facets = this.filtersApiData.result.filters[1].brands;
                    }
                  });
                }
                if (this.facets && this.facets.length === 0) {
                  this.facets = this.filtersApiData.result.filters[1].brands;
                }
                if (this.allInOneData[0].length === 1) {
                  this.allInOneData[0].forEach((element) => {
                    if (!element) {
                      this.facets = this.filtersApiData.result.filters[1].brands;
                    }
                  });
                }
  
               
              }
              if ( this.CONFIG.title === "BestGifts" || this.CONFIG.title === "Babys Pride") {
                this.themes = this.filtersApiData.result.filters[2].themes;
                this.finish = this.filtersApiData.result.filters[3].finish;
                this.features = this.filtersApiData.result.filters[4].features;
                this.prices = this.filtersApiData.result.filters[5].prices;
                this.size = this.filtersApiData.result.filters[6].size;
                this.thickness = this.filtersApiData.result.filters[7].thickness;
                this.color = this.filtersApiData.result.filters[8].color;
                this.type = this.filtersApiData.result.filters[9].type;
                this.material =
                  this.filtersApiData.result.filters[10].product_material;
                  this.age =  this.filtersApiData.result.filters[12].age;
                  console.log("age3",this.age)
                  this.affiliation =  this.filtersApiData.result.filters[13].affiliation;
                  console.log("affiliation3",this.affiliation)
                  this.standard =  this.filtersApiData.result.filters[14].standard;
                  console.log("standard3",this.standard)
                  this.subject = this.filtersApiData.result.filters[15].subject;
              console.log("subject",this.subject)
              this.year = this.filtersApiData.result.filters[16].year;
              console.log("subjyearect",this.year)
              this.price_range = this.filtersApiData.result.filters[17].price_range;
              
              }
            
             
              this.totalItemsOrProducts = this.filtersApiData.result.total.value
                ? this.filtersApiData.result.total.value
                : 0;
  
              //  this.totalLength = this.products ? this.products.totalLength : 0;
              this.totalLength = this.filtersApiData.result.total
                ? this.filtersApiData.result.total
                : 0;
              
              if (
                this.CONFIG.title === "Aiema" ||
                this.CONFIG.title === "Cle" || 
                this.CONFIG.title === "ShubhCards" ||
                this.CONFIG.title === "BombayHardware" ||
                this.CONFIG.title === "Deera" || this.CONFIG.title === "Babys Pride" || this.CONFIG.title === "KatbookStore" || this.CONFIG.title === "Karupattiraja" || this.CONFIG.title === "Beaubelle" || this.CONFIG.title === "Schift Cosmetics" || this.CONFIG.title === "BestGifts"|| this.CONFIG.title === "Kubendran" ||this.CONFIG.title==="Carience"||this.CONFIG.title==="SpecialWires"||this.CONFIG.title==="Vistas" || this.CONFIG.title === "Linenraj"||this.CONFIG.title==="Vimpro" || this.CONFIG.title==="Taazah"
              ) {
                this.totalLength = this.totalItemsOrProducts = this.filtersApiData
                  .result.total.value
                  ? this.filtersApiData.result.total.value
                  : 0;
                  console.log(this.totalLength,"bestgifts")
              }
              this.loaderService.emitComplete();
            },
            (err) => {
              if (err.error.error.message) {
                console.log(err.error.error.message);
              } else {
                console.log("Something bad happened; Please try again!");
              }
            }
          
          );
        } catch (error) {
          console.log('Error while hitting api: ', error)
        }
        
      }
      else if(this.CONFIG.title=="BestGifts"&& this.low_to_high==true ){
        console.log("54555")
        console.log(this.totalLength,"bestgifts")
  
        this.getLowtoHighProducts(1)
  
      }
      else if (this.CONFIG.title=="BestGifts"&& this.high_to_low==true){
        console.log("545556666")
        this.getHightoLowProducts(1)
  
      }
      else{
        try{
          console.log("545556666")
          this.appService
          .postApiCall(this.req_filter_data2, ENDPOINTS.GET_FILTER_PRODUCTS)
          .subscribe(
            (resp) => {
              //  this.allInOneData=[];
              
                if(this.CONFIG.title === "Babys Pride" ){
                  this.sortingForm.controls['sort_value'].setValue("Recommended");
                  this.sortingForm.updateValueAndValidity();
                  console.log("this.sortingForm",this.sortingForm.controls['sort_value'].value)
                  this.sort_selected = true
                  // this.sortingForm.controls['sort_value.value'].setValue("sort")
                }
                if(this.CONFIG.title === "Taazah" ){
                  this.sortingForm.controls['sort_value'].setValue("Recommended");
                  this.sortingForm.updateValueAndValidity();
                  console.log("this.sortingForm",this.sortingForm.controls['sort_value'].value)
                  this.sort_selected = true
                  // this.sortingForm.controls['sort_value.value'].setValue("sort")
                }
                if(this.CONFIG.title === "LushNGreen" ){
                  this.sortingForm.controls['sort_value'].setValue("Recommended");
                  this.sortingForm.updateValueAndValidity();
                  console.log("this.sortingForm",this.sortingForm.controls['sort_value'].value)
                  this.sort_selected = true
                  // this.sortingForm.controls['sort_value.value'].setValue("sort")
                }
              this.pagenation = false;
              this.filtersApiData = resp;
              this.taz_increment = 20;
              if(this.taz_increment>=this.filtersApiData.result.total.value){
                this.showMoreOption = false
                             }
                             else{
                              this.showMoreOption = true
                             }
              console.log("Test for total value in the api",this.filtersApiData.result.total.value)
              console.log("Test for no of values in the page",this.taz_increment)
              if(this.currentUrl=='http://localhost:4200/#/productListing-newarrival' && this.CONFIG.title=="KatbookStore"){
                this.products=this.newarrival;

              }
              else{
                this.products = this.filtersApiData.result.data;
                if(this.CONFIG.title=="KatbookStore"){
                  console.log("123456")
                  this.categoryList =this.filtersApiData.result.filters[0].categories;
                  this.affiliation=this.filtersApiData.result.filters[13].affiliation;
                  this.standard=this.filtersApiData.result.filters[14].standard;
                  this.year=this.filtersApiData.result.filters[16].year;
                  this.subject=this.filtersApiData.result.filters[15].subject;
                  // this.year==this.filtersApiData.result.filters[0].year;
                  this.facets=this.filtersApiData.result.filters[1].brands;


                }


              }
               
               console.log(JSON.stringify(this.products))
              //  .filter(element=>{if(element.id==27||element.id==9){return element}});
              this.totalNumberOfProducts = this.filtersApiData.result.total;
              if(this.CONFIG.title=='Vimpro'||this.CONFIG.title=='Kubendran'||this.CONFIG.title === "LinenRaj" || this.CONFIG.title=='Carience'){
                      for(let i=0;i<this.products.length;i++){
                        if(this.products[i].product_type=="Variable")
                        {
                          if(this.products[i].variant){
                            this.selectOptionCarience(this.products[i].variant.option_values[0].option,this.products[i].id,0)
                            if(this.products[i].variant.variant_child)
                            {
                              this.selectColour(this.products[i].variant.option_values[0].child[0].color,this.products[i].id,0)
                              this.selectColourOptions(this.products[i].variant.option_values[0].child[0].color,this.products[i].id,0)
                            }
  
                          }
          
                         
                         
                        }
                 
                }
                
                 }
                 else if(this.CONFIG.title=='SpecialWires')
                 {
                  for(let i=0;i<this.products.length;i++){
                    if(this.products[i].product_type=="Variable")
                    {
                      
                     this.selectOptionSpecialWires(this.products[i].variant.option_values[0].option,this.products[i].id,0)
                    
                    //   if(this.products[i].variant.variant_child)
  //this.products[i]['current_index']=-1
                    //   {
  
                    //   }
                      // if(this.products[i].variant.variant_child)
                      // {
                      //   this.selectColour(this.products[i].variant.option_values[0].child[0].color,this.products[i].id,0)
                    
                      // }
                     
                    }
             
            }
                 }
  
  
              if (!this.isfilter) {
                this.isfilter = true;
                if (this.categoryList.length === 0) {
                  this.categoryList =
                    this.filtersApiData.result.filters[0].categories;
                }
                if (this.facets && this.facets.length === 0) {
                  this.facets = this.filtersApiData.result.filters[1].brands;
                }
                if (this.allInOneData[0].length === 1) {
                  this.allInOneData[0].forEach((element) => {
                    if (!element) {
                      this.facets = this.filtersApiData.result.filters[1].brands;
                    }
                  });
                }
                if (this.facets && this.facets.length === 0) {
                  this.facets = this.filtersApiData.result.filters[1].brands;
                }
                if (this.allInOneData[0].length === 1) {
                  this.allInOneData[0].forEach((element) => {
                    if (!element) {
                      this.facets = this.filtersApiData.result.filters[1].brands;
                    }
                  });
                }
  
                if (this.CONFIG.title !== "Deera" && this.CONFIG.title !== "Karupattiraja" && this.CONFIG.title !== "AvonSeals" && this.CONFIG.title !== "Vistas" && this.CONFIG.title !== "Schift Cosmetics" && this.CONFIG.title !== "Linenraj" && this.CONFIG.title !== "Taazah" && this.CONFIG.title !== "SpecialWires" && this.CONFIG.title !== "Beaubelle`" && this.CONFIG.title!=="BestGifts"&& this.CONFIG.title!=="Kubendran" && this.CONFIG.title !== "BombayHardware" && this.CONFIG.title!=="Carience" &&this.CONFIG.title!=="Babys Pride" &&this.CONFIG.title!=="LushNGreen" &&this.CONFIG.title!=="Vimpro") {
                  this.themes = this.filtersApiData.result.filters[2].themes;
                  this.finish = this.filtersApiData.result.filters[3].finish;
                  this.features = this.filtersApiData.result.filters[4].features;
                  this.prices = this.filtersApiData.result.filters[5].prices;
                  this.size = this.filtersApiData.result.filters[6].size;
                  this.thickness = this.filtersApiData.result.filters[7].thickness;
                  this.color = this.filtersApiData.result.filters[8].color;
                  this.type = this.filtersApiData.result.filters[9].type;
                  this.material =
                    this.filtersApiData.result.filters[10].product_material;
                    this.age = this.filtersApiData.result.filters[12].age;
                    this.affiliation = this.filtersApiData.result.filters[13].affiliation;
                    console.log("affiliation3",this.affiliation)
                    this.standard = this.filtersApiData.result.filters[14].standard;
                    console.log("standard3",this.standard)
                    this.subject = this.filtersApiData.result.filters[15].subject;
              console.log("subject",this.subject)
              this.year = this.filtersApiData.result.filters[16].year;
              console.log("subjyearect",this.year)
              this.price_range = this.filtersApiData.result.filters[17].price_range;
                }
              }
              if (this.CONFIG.title === "Deera" || this.CONFIG.title === "Karupattiraja" || this.CONFIG.title === "AvonSeals" || this.CONFIG.title === "Vistas" || this.CONFIG.title === "LinenRaj" || this.CONFIG.title === "SpecialWires" || this.CONFIG.title === "BestGifts"|| this.CONFIG.title === "Kubendran" || this.CONFIG.title === "Babys Pride" || this.CONFIG.title === "LushNGreen" || this.CONFIG.title === "LinenRaj") {
                this.themes = this.filtersApiData.result.filters[2].themes;
                this.finish = this.filtersApiData.result.filters[3].finish;
                this.features = this.filtersApiData.result.filters[4].features;
                this.prices = this.filtersApiData.result.filters[5].prices;
                this.size = this.filtersApiData.result.filters[6].size;
                this.thickness = this.filtersApiData.result.filters[7].thickness;
                this.color = this.filtersApiData.result.filters[8].color;
                this.type = this.filtersApiData.result.filters[9].type;
                this.material =
                  this.filtersApiData.result.filters[10].product_material;
                  if (this.CONFIG.title !== "Karupattiraja"){
                  this.age = this.filtersApiData.result.filters[12].age;
                  this.affiliation = this.filtersApiData.result.filters[13].affiliation;
                  this.standard = this.filtersApiData.result.filters[14].standard;
                  this.subject = this.filtersApiData.result.filters[15].subject;
              this.year = this.filtersApiData.result.filters[16].year;
              this.price_range = this.filtersApiData.result.filters[17].price_range;
                  }
              }
              if (this.CONFIG.title === "BombayHardware") {
                
                this.facets = this.filtersApiData.result.filters[1].brands;
                this.themes = this.filtersApiData.result.filters[2].themes;
                this.finish = this.filtersApiData.result.filters[3].finish;
                this.features = this.filtersApiData.result.filters[4].features;
                this.prices = this.filtersApiData.result.filters[5].prices;
                this.size = this.filtersApiData.result.filters[6].size;
                this.thickness = this.filtersApiData.result.filters[7].thickness;
                this.color = this.filtersApiData.result.filters[8].color;
                this.type = this.filtersApiData.result.filters[9].type;
                this.material =
                  this.filtersApiData.result.filters[10].product_material;
                  this.age = this.filtersApiData.result.filters[12].age;
                  this.affiliation = this.filtersApiData.result.filters[13].affiliation;
                  this.standard = this.filtersApiData.result.filters[14].standard;
                  this.subject = this.filtersApiData.result.filters[15].subject;
              this.year = this.filtersApiData.result.filters[16].year;
              this.price_range = this.filtersApiData.result.filters[17].price_range;
              }
              if (this.CONFIG.title === "Beaubelle" || this.CONFIG.title === "Carience"|| this.CONFIG.title === "Schift Cosmetics"||this.CONFIG.title === "Vimpro") {
                console.log("trueeeeeeeeeeeee")
                this.categoryList = this.filtersApiData.result.filters[0].categories;
                if(this.CONFIG.title === "Schift Cosmetics"){
                  if (this.categoryList.length > 0) {
                    this.categoryList.forEach((element) => {
                      console.log("this.categoryList",this.categoryList)
                      console.log("this.allInOneData[1]",this.allInOneData[1])
                      console.log("this.element.name",element.name)
                      console.log("this.element",element)
                      if(this.allInOneData[1]==element.name){
                        this.categoryDescription = element.description 
                        this.metaSchiftTitle = element.meta_title
                        console.log("this.categoryDescription",this.categoryDescription)
                        
                      } 
                      else
                      if(element.subcategories){
                        element.subcategories.forEach((ele) => {
                          if(this.allInOneData[1]==ele.name){
                            this.categoryDescription = ele.description 
                            this.metaSchiftTitle = ele.meta_title
                          }
                        })
                      }
                      
                    });
                  }
                  let categoryData = this.categoryList
                  if (categoryData.length > 0) {
                   for(let i=0;i<categoryData.length;i++){
                     if(this.allInOneData[1]==categoryData[i].name){
                       console.log("fffffffffffffffffffffffffffff")
                       this.metadataService.configureMetadata(categoryData[i].meta_description, categoryData[i].meta_keywords, categoryData[i].meta_title)
                       break;
                     } else {
                       console.log("lllllllllllllllllllllllllllllll")
                       this.metadataService.configureMetadata(SEO_VARIABLES.PRODUCT_LIST.DESCRIPTION, SEO_VARIABLES.PRODUCT_LIST.KEYWORDS, SEO_VARIABLES.PRODUCT_LIST.TITLE)
           
                     }
                    }
                  }
                }
                this.facets = this.filtersApiData.result.filters[1].brands;
                this.themes = this.filtersApiData.result.filters[2].themes;
                this.finish = this.filtersApiData.result.filters[3].finish;
                this.features = this.filtersApiData.result.filters[4].features;
                this.prices = this.filtersApiData.result.filters[5].prices;
                this.size = this.filtersApiData.result.filters[6].size;
                this.thickness = this.filtersApiData.result.filters[7].thickness;
                this.color = this.filtersApiData.result.filters[8].color;
                this.type = this.filtersApiData.result.filters[9].type;
                this.material =
                  this.filtersApiData.result.filters[10].product_material;
                  this.age = this.filtersApiData.result.filters[12].age;
              //     this.affiliation = this.filtersApiData.result.filters[13].affiliation;
              //     this.standard = this.filtersApiData.result.filters[14].standard;
              //     this.subject = this.filtersApiData.result.filters[15].subject;
              // this.year = this.filtersApiData.result.filters[16].year;
              // this.price_range = this.filtersApiData.result.filters[17].price_range;
              }
              this.totalItemsOrProducts = this.filtersApiData.result.total.value
                ? this.filtersApiData.result.total.value
                : 0;
  
              //  this.totalLength = this.products ? this.products.totalLength : 0;
              this.totalLength = this.filtersApiData.result.total
                ? this.filtersApiData.result.total
                : 0;
              if (
                this.CONFIG.title === "Aiema" || this.CONFIG.title === "Cle" ||
                this.CONFIG.title === "ShubhCards" ||
                this.CONFIG.title === "BombayHardware" ||
                this.CONFIG.title === "Deera" || this.CONFIG.title === "Babys Pride" || this.CONFIG.title === "Karupattiraja" || this.CONFIG.title === "Schift Cosmetics" || this.CONFIG.title === "LinenRaj"|| this.CONFIG.title === "AvonSeals" || this.CONFIG.title === "KatbookStore" || this.CONFIG.title === "Vistas" || this.CONFIG.title === "Linenraj" || this.CONFIG.title === "SpecialWires" || this.CONFIG.title === "Beaubelle" || this.CONFIG.title === "BestGifts"|| this.CONFIG.title === "Kubendran" ||this.CONFIG.title==="Carience"||this.CONFIG.title==="Vimpro"||this.CONFIG.title==="LushNGreen" || this.CONFIG.title==="Taazah"
              ) {
                this.totalLength = this.totalItemsOrProducts = this.filtersApiData
                  .result.total.value
                  ? this.filtersApiData.result.total.value
                  : 0;
              }
              this.loaderService.emitComplete();
              
            },
            (err) => {
              if (err.error.error.message) {
                console.log(err.error.error.message);
              } else {
                console.log("Something bad happened; Please try again!");
              }
            }
          
          );
        } catch (error) {
          console.log('Error while hitting api: ', error)
        }
  
      }
      

    
  
   

  }
getNewArrival(){
  if(this.currentUrl=="http://localhost:4200/#/productListing-newarrival" && this.CONFIG.title=="KatbookStore"){
    console.log("new pro")
    var req_new_arrival_data = {
      "domain_name": ORG_DETAILS.DOMAIN_NAME,
      "user_id": null,
      "extras": {
        "find": {
        },
        "pagination": true,
        "paginationDetails": {
          "limit": 1,
          "pagesize": 300
        },
        "sorting": true,
        "sortingDetails": {
          "sortfield": "id",
          "sortorder": -1
        }
      }
    }
    this.appService.postApiCall(req_new_arrival_data, ENDPOINTS.GET_NEW_ARRIVAL).subscribe(
      resp => {
        console.log("schift test for feature1")
        // this.newArrivalApiData = resp;
        this.newarrival = resp.result.data;
        this.products=this.newarrival;

        // this.newArrivalKat = this.newArrivalApiData.result.data.slice(0,5);
        // this.newArrivalKatMobile = this.newArrivalApiData.result.data.slice(0,4);
        // console.log(this.newArrivalKat )
     
      console.log(this.newarrival,"newArrival");
      this.filterItemsOfType();
      },
      err => {
        if (err.error.error.message) {
          console.log(err.error.error.message)
        }
        else{
          console.log('Something bad happened; Please try again!')
        }
      })
  }
}
  getFilterByProductAllZToA(event: number) {
    this.combine = "yes";
    this.include = false;
    this.days30 = false;
    this.days90 = false;
    if (this.allInOneData1[2]) {
      this.include = false;
      this.days30 = false;
      this.days90 = false;
      for (var i = 0; i < this.allInOneData1[2].split(",").length; i++) {
        if (this.allInOneData1[2].split(",")[i] == "Include Out of Stock") {
          this.include = true;
        } else if (this.allInOneData1[2].split(",")[i] == "Last 90 days") {
          this.days90 = true;
        } else if (this.allInOneData1[2].split(",")[i] == "Last 30 days") {
          this.days30 = true;
        } else {
          this.include = false;
          this.days30 = false;
          this.days90 = false;
        }
      }
    }

    this.currentPageInPagination = event;
    if (this.allInOneData1.length === 0) {
      this.allInOneData1[0] = "";
      this.allInOneData1[1] = "";
    } else {
      if (this.allInOneData1[1].length === 0) {
        this.allInOneData1[1] = this.cate;
      } else {
        // this.allInOneData1[1]=[this.allInOneData1[1]]
        this.allInOneData1[1] = this.allInOneData1[1];
      }
    }

    if (
      this.CONFIG.title === "BombayHardware" || this.CONFIG.title === "Babys Pride" || this.CONFIG.title === "Karupattiraja" || this.CONFIG.title === "AvonSeals" || this.CONFIG.title === "Vistas" || this.CONFIG.title === "LinenRaj" || this.CONFIG.title === "SpecialWires" || this.CONFIG.title === "BestGifts" || this.CONFIG.title === "Kubendran" ||this.CONFIG.title==="Carience"||this.CONFIG.title==="Vimpro"||this.CONFIG.title==="LushNGreen"
    ) {
      this.req_filter_data3 = {
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: null,
        extras: {
          find: {
            // "brand":this.allInOneData1[0]!="" && this.allInOneData1[0]!=undefined && this.allInOneData1[0]!=null?this.allInOneData1[0]:[],
            brand: this.allInOneData1[0],
            category: this.allInOneData1[1],
            last90days: this.days90,
            last30days: this.days30,
            includeoutofstock: this.include,
            isglobalfilter: true,
          },
          pagination: true,
          paginationDetails: {
            limit: event,
            pagesize: 25,
          },
          sorting: true,
          sortingDetails: {
            sortfield: "id",
            sortorder: +1,
          },
          subcategoryfilter: false,
        },
      };
    } if(this.CONFIG.title === "Deera"){
      this.req_filter_data3 = {
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: null,
        extras: {
          find: {
            // "brand":this.allInOneData1[0]!="" && this.allInOneData1[0]!=undefined && this.allInOneData1[0]!=null?this.allInOneData1[0]:[],
            brand: this.allInOneData1[0],
            category: this.allInOneData1[1],
            last90days: this.days90,
            last30days: this.days30,
            includeoutofstock: this.include,
            isglobalfilter: true,
          },
          pagination: true,
          paginationDetails: {
            limit: event,
            pagesize: 25,
          },
          sorting: true,
          sortingDetails: {
            sortfield: "id",
            sortorder: +1,
          },
          subcategoryfilter: false,
        },
      };
    }
    if (
      this.CONFIG.title === "Beaubelle" ||  this.CONFIG.title === "Schift Cosmetics"
    ) {
      this.req_filter_data3 = {
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: null,
        extras: {
          find: {
            // "brand":this.allInOneData1[0]!="" && this.allInOneData1[0]!=undefined && this.allInOneData1[0]!=null?this.allInOneData1[0]:[],
            brand: this.allInOneData1[0],
            category: this.allInOneData1[1],
            last90days: this.days90,
            last30days: this.days30,
            includeoutofstock: this.include,
            isglobalfilter: false,
            filters_based_on:"brand",
          },
          pagination: true,
          paginationDetails: {
            limit: event,
            pagesize: 25,
          },
          sorting: true,
          sortingDetails: {
            sortfield: "id",
            sortorder: +1,
          },
          subcategoryfilter: false,
        },
      };
    }
    
    else {
      this.req_filter_data3 = {
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: null,
        extras: {
          find: {
            // "brand":this.allInOneData1[0]!="" && this.allInOneData1[0]!=undefined && this.allInOneData1[0]!=null?this.allInOneData1[0]:[],
            brand: this.allInOneData1[0],
            category: this.allInOneData1[1],
            last90days: this.days90,
            last30days: this.days30,
            includeoutofstock: this.include,
          },
          pagination: true,
          paginationDetails: {
            limit: event,
            pagesize: 25,
          },
          sorting: true,
          sortingDetails: {
            sortfield: "id",
            sortorder: +1,
          },
          subcategoryfilter: false,
        },
      };
    }

    this.appService
      .postApiCall(this.req_filter_data3, ENDPOINTS.GET_FILTER_PRODUCTS)
      .subscribe(
        (resp) => {
          this.allInOneData1 = [];
          this.filtersApiData = resp;
          this.products = this.filtersApiData.result.data;
 
          // if(!this.isfilter)
          //  {
          //this.isfilter=true;

          this.categoryList = this.filtersApiData.result.filters[0].categories;
          this.facets = this.filtersApiData.result.filters[1].brands;

          this.themes = this.filtersApiData.result.filters[2].themes;
          this.finish = this.filtersApiData.result.filters[3].finish;
          this.features = this.filtersApiData.result.filters[4].features;
          this.prices = this.filtersApiData.result.filters[5].prices;
          this.size = this.filtersApiData.result.filters[6].size;
          this.thickness = this.filtersApiData.result.filters[7].thickness;
          this.color = this.filtersApiData.result.filters[8].color;
          this.type = this.filtersApiData.result.filters[9].type;
          this.material =
            this.filtersApiData.result.filters[10].product_material;
            this.age = this.filtersApiData.result.filters[12].age;
            this.affiliation = this.filtersApiData.result.filters[13].affiliation;
            this.standard = this.filtersApiData.result.filters[14].standard;
            this.subject = this.filtersApiData.result.filters[15].subject;
            this.year = this.filtersApiData.result.filters[16].year;
            this.price_range = this.filtersApiData.result.filters[17].price_range;
          //}
          
          this.totalNumberOfProducts = this.filtersApiData.result.total;
          this.totalItemsOrProducts = this.filtersApiData.result.total.value
            ? this.filtersApiData.result.total.value
            : 0;
          this.totalLength = this.filtersApiData.result.total
            ? this.filtersApiData.result.total
            : 0;
          if (
            this.CONFIG.title === "Aiema" ||
            this.CONFIG.title === "Cle" ||
            this.CONFIG.title === "ShubhCards" ||
            this.CONFIG.title === "BombayHardware" ||
            this.CONFIG.title === "Deera" || this.CONFIG.title === "Babys Pride" || this.CONFIG.title === "Karupattiraja"|| this.CONFIG.title === "AvonSeals" || this.CONFIG.title === "Schift Cosmetics" || this.CONFIG.title === "Vistas" || this.CONFIG.title === "Linenraj" || this.CONFIG.title === "SpecialWires" || this.CONFIG.title === "Beaubelle" || this.CONFIG.title === "BestGifts" ||this.CONFIG.title==="Carience"||this.CONFIG.title==="Vimpro"||this.CONFIG.title==="LushNGreen" || this.CONFIG.title==="Taazah"
          ) {
            this.totalLength = this.totalItemsOrProducts = this.filtersApiData
              .result.total.value
              ? this.filtersApiData.result.total.value
              : 0;
          }
        },
        (err) => {
          if (err.error.error.message) {
            console.log(err.error.error.message);
          } else {
            console.log("Something bad happened; Please try again!");
          }
        }
      );
  }

  //GET PRODUCTS BY LAST90DAYS
  getProductByLast90Days(event: number) {
    console.log("best111")
    this.currentPageInPagination = event;
    this.last90Days = "yes";

    if (
      this.CONFIG.title === "BombayHardware" || this.CONFIG.title === "Babys pride" || this.CONFIG.title === "Karupattiraja"  || this.CONFIG.title === "AvonSeals" || this.CONFIG.title === "Vistas" || this.CONFIG.title === "LinenRaj" || this.CONFIG.title === "SpecialWires" || this.CONFIG.title === "BestGifts"||this.CONFIG.title === "Kubendran" ||this.CONFIG.title==="Carience"||this.CONFIG.title==="Vimpro"||this.CONFIG.title==="LushNGreen"
    ) {
      if (this.dataFilter == "az") {
        this.req_last90days_product_data = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: null,
          extras: {
            find: {
              brand: [],
              category: [],
              age:[],
              price:[],
              last90days: true,
              last30days: false,
              includeoutofstock: false,
              isglobalfilter: false,
            },
            pagination: true,
            paginationDetails: {
              limit: event,
              pagesize: 25,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "name",
              sortorder: -1,
            },
          },
        };
      } else if (this.dataFilter == "za") {
        console.log("best222")
        this.req_last90days_product_data = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: null,
          extras: {
            find: {
              brand: [],
              category: [],
              age:[],
              price:[],
              last90days: true,
              last30days: false,
              includeoutofstock: false,
              isglobalfilter: false,
            },
            pagination: true,
            paginationDetails: {
              limit: event,
              pagesize: 25,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "name",
              sortorder: +1,
            },
          },
        };
      }
    } 
    if (
      this.CONFIG.title === "Beaubelle" || this.CONFIG.title === "Schift Cosmetics"
    ) {
      if (this.dataFilter == "az") {
        console.log("best333")
        this.req_last90days_product_data = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: null,
          extras: {
            find: {
              brand: [],
              category: [],
              last90days: true,
              last30days: false,
              includeoutofstock: false,
              isglobalfilter: false,
              filters_based_on:"brand",
            },
            pagination: true,
            paginationDetails: {
              limit: event,
              pagesize: 25,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "name",
              sortorder: -1,
            },
          },
        };
      } else if (this.dataFilter == "za") {
        console.log("best444")
        this.req_last90days_product_data = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: null,
          extras: {
            find: {
              brand: [],
              category: [],
              last90days: true,
              last30days: false,
              includeoutofstock: false,
              isglobalfilter: false,
              filters_based_on:"brand",
            },
            pagination: true,
            paginationDetails: {
              limit: event,
              pagesize: 25,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "name",
              sortorder: +1,
            },
          },
        };
      }
    } 
    if(this.CONFIG.title === "Deera"){
      if (this.dataFilter == "az") {
        this.req_last90days_product_data1 = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: null,
          extras: {
            find: {
              brand: [],
              category: [],
              last90days: false,
              last30days: false,
              includeoutofstock: false,
              isglobalfilter: true,
            },
            pagination: true,
            paginationDetails: {
              limit: event,
              pagesize: 25,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "name",
              sortorder: -1,
            },
          },
        };
      } else if (this.dataFilter == "za") {
        this.req_last90days_product_data1 = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: null,
          extras: {
            find: {
              brand: [],
              category: [],
              last90days: false,
              last30days: false,
              includeoutofstock: false,
              isglobalfilter: true,
            },
            pagination: true,
            paginationDetails: {
              limit: event,
              pagesize: 25,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "name",
              sortorder: +1,
            },
          },
        };
      }
    }
    else {
      if (this.dataFilter == "az") {
        console.log("best555")
        this.req_last90days_product_data = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: null,
          extras: {
            find: {
              brand: [],
              category: [],
              age:[],
              price:[],
              last90days: true,
              last30days: false,
              includeoutofstock: false,
            },
            pagination: true,
            paginationDetails: {
              limit: event,
              pagesize: 25,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "name",
              sortorder: -1,
            },
          },
        };
      } else if (this.dataFilter == "za") {
        console.log("best666")
        this.req_last90days_product_data = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: null,
          extras: {
            find: {
              brand: [],
              category: [],
              age:[],
              price:[],
              last90days: true,
              last30days: false,
              includeoutofstock: false,
            },
            pagination: true,
            paginationDetails: {
              limit: event,
              pagesize: 25,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "name",
              sortorder: +1,
            },
          },
        };
      }
    }

    this.appService
      .postApiCall(
        this.req_last90days_product_data,
        ENDPOINTS.GET_FILTER_PRODUCTS
      )
      .subscribe(
        (resp) => {
          this.last90DaysProductsApiData = resp;
          this.products = this.last90DaysProductsApiData.result.data;
          this.totalNumberOfProducts =
            this.last90DaysProductsApiData.result.total;
          //  if(!this.isfilter)
          //  {
          //this.isfilter=true;
          this.categoryList =
            this.last90DaysProductsApiData.result.filters[0].categories;
          this.facets = this.last90DaysProductsApiData.result.filters[1].brands;
          this.themes = this.last90DaysProductsApiData.result.filters[2].themes;
          this.finish = this.last90DaysProductsApiData.result.filters[3].finish;
          this.features =
            this.last90DaysProductsApiData.result.filters[4].features;
          this.prices = this.last90DaysProductsApiData.result.filters[5].prices;
          this.size = this.last90DaysProductsApiData.result.filters[6].size;
          this.thickness =
            this.last90DaysProductsApiData.result.filters[7].thickness;
          this.color = this.last90DaysProductsApiData.result.filters[8].color;
          this.type = this.last90DaysProductsApiData.result.filters[9].type;
          this.material =
            this.last90DaysProductsApiData.result.filters[10].product_material;
            this.age = this.last90DaysProductsApiData.result.filters[12].age;
            this.affiliation = this.last90DaysProductsApiData.result.filters[13].affiliation;
            this.standard = this.last90DaysProductsApiData.result.filters[14].standard;
            this.subject = this.last90DaysProductsApiData.result.filters[15].subject;
            this.year = this.last90DaysProductsApiData.result.filters[16].year;
            this.price_range = this.last90DaysProductsApiData.result.filters[17].price_range;
          //}standard
          
          this.totalItemsOrProducts = this.last90DaysProductsApiData.result
            .total.value
            ? this.last90DaysProductsApiData.result.total.value
            : 0;

          if (
            this.CONFIG.title === "Aiema" || 
            this.CONFIG.title === "Cle" ||
            this.CONFIG.title === "BombayHardware"||  this.CONFIG.title === "Beaubelle" ||  this.CONFIG.title === "Schift Cosmetics"
          ) {
            this.totalItemsOrProducts = this.last90DaysProductsApiData.result
              .total.value
              ? this.last90DaysProductsApiData.result.total.value
              : 0;
          }
          if (this.facets.length > 0) {
            this.facets.forEach((element) => {
              this.brandPush.push(element.name);
            });

            this.productFilterService.updateAdminFormEvent(this.brandPush);
          }
          this.totalLength = this.last90DaysProductsApiData.result.total
            ? this.last90DaysProductsApiData.result.total
            : 0;
          if (
            this.CONFIG.title === "Aiema" || this.CONFIG.title === "Cle" ||
            this.CONFIG.title === "ShubhCards" ||
            this.CONFIG.title === "BombayHardware" || 
            this.CONFIG.title === "Deera" || this.CONFIG.title === "Babys Pride" || this.CONFIG.title === "Karupattiraja"|| this.CONFIG.title === "AvonSeals" || this.CONFIG.title === "Vistas" || this.CONFIG.title === "Linenraj" || this.CONFIG.title === "SpecialWires" || this.CONFIG.title === "Beaubelle" || this.CONFIG.title === "Schift Cosmetics" || this.CONFIG.title === "BestGifts"||this.CONFIG.title === "Kubendran" ||this.CONFIG.title==="Carience"||this.CONFIG.title==="Vimpro"||this.CONFIG.title==="LushNGreen" || this.CONFIG.title==="Taazah"
          ) {
            this.totalLength = this.last90DaysProductsApiData.result.total.value
              ? this.last90DaysProductsApiData.result.total.value
              : 0;
            if (
              this.CONFIG.title === "Aiema" || this.CONFIG.title === "Cle" ||
              this.CONFIG.title === "ShubhCards" ||
              this.CONFIG.title === "BombayHardware" ||
              this.CONFIG.title === "Deera" || this.CONFIG.title === "Babys Pride" || this.CONFIG.title === "Karupattiraja"|| this.CONFIG.title === "AvonSeals" || this.CONFIG.title === "Vistas" || this.CONFIG.title === "Linenraj" || this.CONFIG.title === "SpecialWires" || this.CONFIG.title === "Beaubelle"  || this.CONFIG.title === "Schift Cosmetics" || this.CONFIG.title === "BestGifts"||this.CONFIG.title === "Kubendran" ||this.CONFIG.title==="Carience"||this.CONFIG.title==="Vimpro"||this.CONFIG.title==="LushNGreen" || this.CONFIG.title==="Taazah"
            ) {
              this.totalLength = this.totalItemsOrProducts = this
                .last90DaysProductsApiData.result.total.value
                ? this.last90DaysProductsApiData.result.total.value
                : 0;
            }
          }
        },
        (err) => {
          if (err.error.error.message) {
            console.log(err.error.error.message);
          } else {
            console.log("Something bad happened; Please try again!");
          }
        }
      );
  }

  getAiemaProductByLast90Days(event: number) {
    this.currentPageInPagination = event;
    this.last90Days = "no";

    if (
      this.CONFIG.title === "BombayHardware"  || this.CONFIG.title === "Babys Pride" || this.CONFIG.title === "Karupattiraja" || this.CONFIG.title === "AvonSeals" || this.CONFIG.title === "Vistas" || this.CONFIG.title === "LinenRaj" || this.CONFIG.title === "SpecialWires" || this.CONFIG.title === "BestGifts"||this.CONFIG.title === "Kubendran"||this.CONFIG.title==="LushNGreen"
    ) {
      if (this.dataFilter == "az") {
        this.req_last90days_product_data1 = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: null,
          extras: {
            find: {
              brand: [],
              category: [],
              last90days: false,
              last30days: false,
              includeoutofstock: false,
              isglobalfilter: true,
            },
            pagination: true,
            paginationDetails: {
              limit: event,
              pagesize: 25,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "name",
              sortorder: -1,
            },
          },
        };
      } else if (this.dataFilter == "za") {
        this.req_last90days_product_data1 = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: null,
          extras: {
            find: {
              brand: [],
              category: [],
              last90days: false,
              last30days: false,
              includeoutofstock: false,
              isglobalfilter: true,
            },
            pagination: true,
            paginationDetails: {
              limit: event,
              pagesize: 25,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "name",
              sortorder: +1,
            },
          },
        };
      }
    }
    if(this.CONFIG.title === "Deera"){
      if (this.dataFilter == "az") {
        this.req_last90days_product_data1 = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: null,
          extras: {
            find: {
              brand: [],
              category: [],
              last90days: false,
              last30days: false,
              includeoutofstock: false,
              isglobalfilter: false,
            },
            pagination: true,
            paginationDetails: {
              limit: event,
              pagesize: 25,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "name",
              sortorder: -1,
            },
          },
        };
      } else if (this.dataFilter == "za") {
        this.req_last90days_product_data1 = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: null,
          extras: {
            find: {
              brand: [],
              category: [],
              last90days: false,
              last30days: false,
              includeoutofstock: false,
              isglobalfilter: false,
            },
            pagination: true,
            paginationDetails: {
              limit: event,
              pagesize: 25,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "name",
              sortorder: +1,
            },
          },
        };
      }
    }
    if (
      this.CONFIG.title === "Beaubelle"
    ) {
      if (this.dataFilter == "az") {
        this.req_last90days_product_data1 = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: null,
          extras: {
            find: {
              brand: [],
              category: [],
              last90days: false,
              last30days: false,
              includeoutofstock: false,
              isglobalfilter: false,
              filters_based_on:"brand",
            },
            pagination: true,
            paginationDetails: {
              limit: event,
              pagesize: 25,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "name",
              sortorder: -1,
            },
          },
        };
      } else if (this.dataFilter == "za") {
        this.req_last90days_product_data1 = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: null,
          extras: {
            find: {
              brand: [],
              category: [],
              last90days: false,
              last30days: false,
              includeoutofstock: false,
              isglobalfilter: false,
              filters_based_on:"brand",
            },
            pagination: true,
            paginationDetails: {
              limit: event,
              pagesize: 25,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "name",
              sortorder: +1,
            },
          },
        };
      }
    }
     else {
      if (this.dataFilter == "az") {
        this.req_last90days_product_data1 = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: null,
          extras: {
            find: {
              brand: [],
              category: [],
              last90days: false,
              last30days: false,
              includeoutofstock: false,
            },
            pagination: true,
            paginationDetails: {
              limit: event,
              pagesize: 25,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "name",
              sortorder: -1,
            },
          },
        };
      } else if (this.dataFilter == "za") {
        this.req_last90days_product_data1 = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: null,
          extras: {
            find: {
              brand: [],
              category: [],
              last90days: false,
              last30days: false,
              includeoutofstock: false,
            },
            pagination: true,
            paginationDetails: {
              limit: event,
              pagesize: 25,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "name",
              sortorder: +1,
            },
          },
        };
      }
    }

    this.appService
      .postApiCall(
        this.req_last90days_product_data1,
        ENDPOINTS.GET_FILTER_PRODUCTS
      )
      .subscribe(
        (resp) => {
          this.last90DaysProductsApiData = resp;
          this.products = this.last90DaysProductsApiData.result.data;
          this.totalNumberOfProducts =
            this.last90DaysProductsApiData.result.total;
          //  if(!this.isfilter)
          //  {
          //this.isfilter=true;
          this.categoryList =
            this.last90DaysProductsApiData.result.filters[0].categories;
          this.facets = this.last90DaysProductsApiData.result.filters[1].brands;
          this.themes = this.last90DaysProductsApiData.result.filters[2].themes;
          this.finish = this.last90DaysProductsApiData.result.filters[3].finish;
          this.features =
            this.last90DaysProductsApiData.result.filters[4].features;
          this.prices = this.last90DaysProductsApiData.result.filters[5].prices;
          this.size = this.last90DaysProductsApiData.result.filters[6].size;
          this.thickness =
            this.last90DaysProductsApiData.result.filters[7].thickness;
          this.color = this.last90DaysProductsApiData.result.filters[8].color;
          this.type = this.last90DaysProductsApiData.result.filters[9].type;
          this.material =
            this.last90DaysProductsApiData.result.filters[10].product_material;
            this.age = this.last90DaysProductsApiData.result.filters[12].age;
            this.affiliation = this.last90DaysProductsApiData.result.filters[13].affiliation;
            this.standard = this.last90DaysProductsApiData.result.filters[14].standard;
            this.subject = this.last90DaysProductsApiData.result.filters[15].subject;
            this.year = this.last90DaysProductsApiData.result.filters[16].year;
            this.price_range = this.last90DaysProductsApiData.result.filters[17].price_range;
          //}
          this.totalItemsOrProducts = this.last90DaysProductsApiData.result
            .total.value
            ? this.last90DaysProductsApiData.result.total.value
            : 0;

          if (
            this.CONFIG.title === "Aiema" || this.CONFIG.title === "Cle" ||
            this.CONFIG.title === "BombayHardware" || this.CONFIG.title === "Beaubelle"
          ) {
            this.totalItemsOrProducts = this.last90DaysProductsApiData.result
              .total.value
              ? this.last90DaysProductsApiData.result.total.value
              : 0;
          }
          if (this.facets.length > 0) {
            this.facets.forEach((element) => {
              this.brandPush.push(element.name);
            });

            this.productFilterService.updateAdminFormEvent(this.brandPush);
          }
          this.totalLength = this.last90DaysProductsApiData.result.total
            ? this.last90DaysProductsApiData.result.total
            : 0;
          if (
            this.CONFIG.title === "Aiema" || this.CONFIG.title === "Cle" ||
            this.CONFIG.title === "ShubhCards" ||
            this.CONFIG.title === "BombayHardware" ||
            this.CONFIG.title === "Deera" || this.CONFIG.title === "Babys Pride" || this.CONFIG.title === "Karupattiraja" || this.CONFIG.title === "AvonSeals" || this.CONFIG.title === "Vistas" || this.CONFIG.title === "Linenraj" || this.CONFIG.title === "SpecialWires" || this.CONFIG.title === "Beaubelle"  || this.CONFIG.title === "Schift Cosmetics" || this.CONFIG.title === "BestGifts"||this.CONFIG.title === "Kubendran" ||this.CONFIG.title==="Carience"||this.CONFIG.title==="Vimpro"||this.CONFIG.title==="LushNGreen" || this.CONFIG.title==="Taazah"
          ) {
            this.totalLength = this.last90DaysProductsApiData.result.total.value
              ? this.last90DaysProductsApiData.result.total.value
              : 0;
            if (
              this.CONFIG.title === "Aiema" || this.CONFIG.title === "Cle" ||
              this.CONFIG.title === "ShubhCards" ||
              this.CONFIG.title === "BombayHardware" ||
              this.CONFIG.title === "Deera" || this.CONFIG.title === "Babys Pride" || this.CONFIG.title === "Karupattiraja" || this.CONFIG.title === "AvonSeals" || this.CONFIG.title === "Vistas" || this.CONFIG.title === "Linenraj" || this.CONFIG.title === "SpecialWires" || this.CONFIG.title === "Beaubelle" || this.CONFIG.title === "Schift Cosmetics" || this.CONFIG.title === "BestGifts"||this.CONFIG.title === "Kubendran" ||this.CONFIG.title==="Carience"||this.CONFIG.title==="Vimpro"||this.CONFIG.title==="LushNGreen" || this.CONFIG.title==="Taazah"
            ) {
              this.totalLength = this.totalItemsOrProducts = this
                .last90DaysProductsApiData.result.total.value
                ? this.last90DaysProductsApiData.result.total.value
                : 0;
            }
          }
        },
        (err) => {
          if (err.error.error.message) {
            console.log(err.error.error.message);
          } else {
            console.log("Something bad happened; Please try again!");
          }
        }
      );
  }

  //GET SEARCH RESULT
  getSearchResult(event: number) {
    this.currentPageInPagination = event;
    console.log(this.outletId,'this.outletId')

    this.search = "yes";
    if (
      this.CONFIG.title === "BombayHardware" || this.CONFIG.title === "Deera" || this.CONFIG.title === "Babys Pride" || this.CONFIG.title === "Schift Cosmetics" || this.CONFIG.title === "Karupattiraja"|| this.CONFIG.title === "AvonSeals" || this.CONFIG.title === "Vistas" || this.CONFIG.title === "Linenraj" || this.CONFIG.title === "SpecialWires"  || this.CONFIG.title === "BestGifts"||this.CONFIG.title === "Kubendran" ||this.CONFIG.title==="Carience"||this.CONFIG.title==="Vimpro"||this.CONFIG.title==="LushNGreen" || this.CONFIG.title==="Taazah"
    ) {
      if (this.dataFilter == "az") {
        this.req_search_data = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: null, 
          outlet_id:Number(this.outletId),
          // outlet_id:"",

          extras: {
            find: {
              search: this.searchKey,
            },
            isglobalfilter: false,
            pagination: true,
            paginationDetails: {
              limit: event,
              pagesize: 25,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "name",
              sortorder: -1,
            },
          },
        };
      } else if (this.dataFilter == "za") {
        this.req_search_data = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: null,
          outlet_id:Number(this.outletId),
          // outlet_id:"",
          extras: {
            find: {
              search: this.searchKey,
            },
            isglobalfilter: false,
            pagination: true,
            paginationDetails: {
              limit: event,
              pagesize: 25,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "name",
              sortorder: +1,
            },
          },
        };
      }
    } else if (this.CONFIG.title !== "BombayHardware"&&this.CONFIG.title !== "Vimpro" && this.CONFIG.title !== "Deera" && this.CONFIG.title !== "Babys Pride" && this.CONFIG.title !== "Karupattiraja" && this.CONFIG.title !== "AvonSeals" && this.CONFIG.title !== "Vistas" && this.CONFIG.title !== "LinenRaj" && this.CONFIG.title !== "SpecialWires" && this.CONFIG.title !== "BestGifts"&&this.CONFIG.title!=="LushNGreen"&&this.CONFIG.title!=="Taazah"){
      if (this.dataFilter == "az") {
        this.req_search_data = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: null,
          extras: {
            find: {
              search: this.searchKey,
            },
            pagination: true,
            paginationDetails: {
              limit: event,
              pagesize: 25,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "name",
              sortorder: -1,
            },
          },
        };
      } else if (this.dataFilter == "za") {
        this.req_search_data = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: null,
          extras: {
            find: {
              search: this.searchKey,
            },
            pagination: true,
            paginationDetails: {
              limit: event,
              pagesize: 25,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "name",
              sortorder: +1,
            },
          },
        };
      }
    }
     if (this.CONFIG.title === "Beaubelle" ) {
      if (this.dataFilter == "az") {
        this.req_search_data = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: null,
          extras: {
            find: {
              search: this.searchKey,
              
            },
            isglobalfilter: false,
            filters_based_on:"brand",
            pagination: true,
            paginationDetails: {
              limit: event,
              pagesize: 25,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "name",
              sortorder: -1,
            },
          },
        };
      } else if (this.dataFilter == "za") {
        this.req_search_data = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: null,
          extras: {
            find: {
              search: this.searchKey,
              isglobalfilter: false,
              filters_based_on:"brand",
            },
            pagination: true,
            paginationDetails: {
              limit: event,
              pagesize: 25,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "name",
              sortorder: +1,
            },
          },
        };
      }
    }

    this.appService
      .postApiCall(this.req_search_data, ENDPOINTS.GET_SEARCH_RESULT)
      .subscribe(
        (resp) => {
          this.searchApiData = resp;
          this.products = this.searchApiData.result.data;
          this.totalNumberOfProducts = this.searchApiData.result.total;
          //   if(!this.isfilter)
          //  {
          //this.isfilter=true;
          if(this.CONFIG.title === "Taazah"){
            this.taz_increment = 20;
              if(this.taz_increment>=this.searchApiData.result.total.value){
                this.showMoreOption = false
                             }
                             else{
                              this.showMoreOption = true
                             }
          }
          this.categoryList = this.searchApiData.result.filters[0].categories;
          this.facets = this.searchApiData.result.filters[1].brands;

          this.themes = this.searchApiData.result.filters[2].themes;
          this.finish = this.searchApiData.result.filters[3].finish;
          this.features = this.searchApiData.result.filters[4].features;
          this.prices = this.searchApiData.result.filters[5].prices;
          this.size = this.searchApiData.result.filters[6].size;
          this.thickness = this.searchApiData.result.filters[7].thickness;
          this.color = this.searchApiData.result.filters[8].color;
          this.type = this.searchApiData.result.filters[9].type;
          this.material =
            this.searchApiData.result.filters[10].product_material;
            this.age = this.searchApiData.result.filters[12].age;
            this.affiliation = this.searchApiData.result.filters[13].affiliation;
            this.standard = this.searchApiData.result.filters[14].standard;
            this.subject = this.searchApiData.result.filters[15].subject;
            this.year = this.searchApiData.result.filters[16].year;
            this.price_range = this.searchApiData.result.filters[17].price_range;
          //}
          this.totalItemsOrProducts = this.searchApiData.result.total.value
            ? this.searchApiData.result.total.value
            : 0;
          this.totalLength = this.searchApiData.result.total
            ? this.searchApiData.result.total
            : 0;
          if (
            this.CONFIG.title === "Aiema" || this.CONFIG.title === "Cle" ||
            this.CONFIG.title === "ShubhCards" ||
            this.CONFIG.title === "BombayHardware" ||
            this.CONFIG.title === "Deera" || this.CONFIG.title === "Babys Pride" ||this.CONFIG.title==="LushNGreen" || this.CONFIG.title === "Karupattiraja" || this.CONFIG.title === "AvonSeals" || this.CONFIG.title === "Vistas" || this.CONFIG.title === "LinenRaj" || this.CONFIG.title === "SpecialWires" || this.CONFIG.title === "Beaubelle" || this.CONFIG.title === "BestGifts"||this.CONFIG.title === "Kubendran" ||this.CONFIG.title==="Carience"||this.CONFIG.title==="Vimpro"
          ) {
            this.totalLength = this.totalItemsOrProducts = this.searchApiData
              .result.total.value
              ? this.searchApiData.result.total.value
              : 0;
          }
        },
        (err) => {
          if (err.error.error.message) {
            console.log(err.error.error.message);
          } else {
            console.log("Something bad happened; Please try again!");
          }
        }
      );
  }
  //GET PRODUCTS BY SORT
  getProductByLast90DaysSorting(event: number) {
    this.currentPageInPagination = event;
    if (
      this.CONFIG.title === "BombayHardware"||this.CONFIG.title === "Vimpro" || this.CONFIG.title === "Deera" || this.CONFIG.title === "Babys Pride" || this.CONFIG.title === "Karupattiraja" || this.CONFIG.title === "AvonSeals" || this.CONFIG.title === "Vistas" || this.CONFIG.title === "LinenRaj" || this.CONFIG.title === "SpecialWires" || this.CONFIG.title === "BestGifts"||this.CONFIG.title === "Kubendran"||this.CONFIG.title==="LushNGreen"
    ) {
      console.log("best777")
      this.req_last90days_product_data2 = {
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: null,
        extras: {
          find: {
            brand: [],
            category: [],
            last90days: true,
            last30days: false,
            includeoutofstock: false,
            isglobalfilter: false,
          },
          pagination: true,
          paginationDetails: {
            limit: event,
            pagesize: 25,
          },
          sorting: true,
          sortingDetails: {
            sortfield: "name",
            sortorder: this.dataFilter === "az" ? -1 : +1,
          },
        },
      };
    } 
   else if (
      this.CONFIG.title === "Beaubelle" 
    ) {
      console.log("best888")
      this.req_last90days_product_data2 = {
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: null,
        extras: {
          find: {
            brand: [],
            category: [],
            last90days: true,
            last30days: false,
            includeoutofstock: false,
            isglobalfilter: false,
            filters_based_on:"brand",
          },
          pagination: true,
          paginationDetails: {
            limit: event,
            pagesize: 25,
          },
          sorting: true,
          sortingDetails: {
            sortfield: "name",
            sortorder: this.dataFilter === "az" ? -1 : +1,
          },
        },
      };
    }
    else {
      console.log("best999")
      this.req_last90days_product_data2 = {
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: null,
        extras: {
          find: {
            brand: [],
            category: [],
            last90days: true,
            last30days: false,
            includeoutofstock: false,
          },
          pagination: true,
          paginationDetails: {
            limit: event,
            pagesize: 25,
          },
          sorting: true,
          sortingDetails: {
            sortfield: "name",
            sortorder: this.dataFilter === "az" ? -1 : +1,
          },
        },
      };
    }

    this.appService
      .postApiCall(
        this.req_last90days_product_data2,
        ENDPOINTS.GET_FILTER_PRODUCTS
      )
      .subscribe(
        (resp) => {
          this.last90DaysProductsApiData = resp;
          this.products = this.last90DaysProductsApiData.result.data;
          //  if(!this.isfilter)
          //    {
          //this.isfilter=true;
          this.categoryList =
            this.last90DaysProductsApiData.result.filters[0].categories;
          this.facets = this.last90DaysProductsApiData.result.filters[1].brands;

          this.themes = this.last90DaysProductsApiData.result.filters[2].themes;
          this.finish = this.last90DaysProductsApiData.result.filters[3].finish;
          this.features =
            this.last90DaysProductsApiData.result.filters[4].features;
          this.prices = this.last90DaysProductsApiData.result.filters[5].prices;
          this.size = this.last90DaysProductsApiData.result.filters[6].size;
          this.thickness =
            this.last90DaysProductsApiData.result.filters[7].thickness;
          this.color = this.last90DaysProductsApiData.result.filters[8].color;
          this.type = this.last90DaysProductsApiData.result.filters[9].type;
          this.material =
            this.last90DaysProductsApiData.result.filters[10].product_material;
            this.age = this.last90DaysProductsApiData.result.filters[12].age;
            this.affiliation = this.last90DaysProductsApiData.result.filters[13].affiliation;
            this.standard = this.last90DaysProductsApiData.result.filters[14].standard;
            this.subject = this.last90DaysProductsApiData.result.filters[15].subject;
            this.year = this.last90DaysProductsApiData.result.filters[16].year;
            this.price_range = this.last90DaysProductsApiData.result.filters[17].price_range;
          //}
          this.totalNumberOfProducts =
            this.last90DaysProductsApiData.result.total;
          this.totalItemsOrProducts = this.last90DaysProductsApiData.result
            .total.value
            ? this.last90DaysProductsApiData.result.total.value
            : 0;

          this.totalLength = this.last90DaysProductsApiData.result.total
            ? this.last90DaysProductsApiData.result.total
            : 0;
          if (
            this.CONFIG.title === "Aiema" || this.CONFIG.title === "Cle" ||
            this.CONFIG.title === "ShubhCards" ||
            this.CONFIG.title === "BombayHardware" ||
            this.CONFIG.title === "Deera" || this.CONFIG.title === "Babys Pride" || this.CONFIG.title === "Karupattiraja" || this.CONFIG.title === "AvonSeals" || this.CONFIG.title === "SpecialWires" || this.CONFIG.title === "Beaubelle" || this.CONFIG.title === "BestGifts" || this.CONFIG.title === "Vistas" || this.CONFIG.title === "LinenRaj"||this.CONFIG.title === "Kubendran"||this.CONFIG.title==="Carience"||this.CONFIG.title==="Vimpro"||this.CONFIG.title==="LushNGreen"
          ) {
            this.totalLength = this.totalItemsOrProducts = this
              .last90DaysProductsApiData.result.total.value
              ? this.last90DaysProductsApiData.result.total.value
              : 0;
          }
        },
        (err) => {
          if (err.error.error.message) {
            console.log(err.error.error.message);
          } else {
            console.log("Something bad happened; Please try again!");
          }
        }
      );
  }

  setPage(page: number) {}

  updateFilter(tags: any) {}

  // TO REFRESH ALL PRODUCTS ON CLEAR ALL FUNCTION
  refreshProducts(topCategories) {
    
    this.clearCategoryData = topCategories;
    this.currentPageInPagination = 1;
    if (
      this.CONFIG.title === "BombayHardware"||this.CONFIG.title === "Vimpro" || this.CONFIG.title === "Deera" || this.CONFIG.title === "Babys Pride" || this.CONFIG.title === "Karupattiraja" || this.CONFIG.title === "AvonSeals" || this.CONFIG.title === "Vistas" || this.CONFIG.title === "LinenRaj" || this.CONFIG.title === "SpecialWires" || this.CONFIG.title === "BestGifts"||this.CONFIG.title === "Kubendran"||this.CONFIG.title==="LushNGreen"
    ) {
      
      this.req_filter_data4 = {
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: null,
        extras: {
          find: {
            // "brand":[this.allInOneData[0]],
            category: topCategories,
            last90days: false,
            last30days: false,
            includeoutofstock: false,
            isglobalfilter: false,
          },
          pagination: true,
          paginationDetails: {
            limit: 1,
            pagesize: 25,
          },
          sorting: true,
          sortingDetails: {
            sortfield: "name",
            sortorder: this.dataFilter === "az" ? -1 : +1,
          },
          subcategoryfilter: false,
        },
      };
    } 
    else if (
      this.CONFIG.title === "Beaubelle"
    ) {
      this.req_filter_data4 = {
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: null,
        extras: {
          find: {
            // "brand":[this.allInOneData[0]],
            category: topCategories,
            last90days: false,
            last30days: false,
            includeoutofstock: false,
            isglobalfilter: false,
            filters_based_on:"brand",
          },
          pagination: true,
          paginationDetails: {
            limit: 1,
            pagesize: 25,
          },
          sorting: true,
          sortingDetails: {
            sortfield: "name",
            sortorder: this.dataFilter === "az" ? -1 : +1,
          },
          subcategoryfilter: false,
        },
      };
    }
    else {
      this.req_filter_data4 = {
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: null,
        extras: {
          find: {
            // "brand":[this.allInOneData[0]],
            category: topCategories,
            last90days: false,
            last30days: false,
            includeoutofstock: false,
          },
          pagination: true,
          paginationDetails: {
            limit: 1,
            pagesize: 25,
          },
          sorting: true,
          sortingDetails: {
            sortfield: "name",
            sortorder: this.dataFilter === "az" ? -1 : +1,
          },
          subcategoryfilter: false,
        },
      };
    }

    this.appService
      .postApiCall(this.req_filter_data4, ENDPOINTS.GET_FILTER_PRODUCTS)
      .subscribe(
        (resp) => {
          this.products = resp.result.data;
          this.totalLength = resp.result.total ? resp.result.total : 0;
          //      if(!this.isfilter)
          //  {
          //this.isfilter=true;
          this.categoryList = resp.result.filters[0].categories;
          this.facets = resp.result.filters[1].brands;

          this.themes = resp.result.filters[2].themes;
          this.finish = resp.result.filters[3].finish;
          this.features = resp.result.filters[4].features;
          this.prices = resp.result.filters[5].prices;
          this.size = resp.result.filters[6].size;
          this.thickness = resp.result.filters[7].thickness;
          this.color = resp.result.filters[8].color;
          this.type = resp.result.filters[9].type;
          this.material = resp.result.filters[10].product_material;
          this.age = resp.result.filters[12].age;
          this.affiliation = resp.result.filters[13].affiliation;
          this.standard = resp.result.filters[14].standard;
          this.subject = resp.result.filters[15].subject;
            this.year = resp.result.filters[16].year;
            this.price_range = resp.result.filters[17].price_range;
          //}
          this.totalItemsOrProducts = resp.result.total.value
            ? resp.result.total.value
            : 0;
          this.totalLength = resp.result.total ? resp.result.total : 0;
          if (
            this.CONFIG.title === "Aiema" || this.CONFIG.title === "Cle" ||
            this.CONFIG.title === "ShubhCards" ||
            this.CONFIG.title === "BombayHardware" ||
            this.CONFIG.title === "Deera" || this.CONFIG.title === "Babys Pride" || this.CONFIG.title === "Karupattiraja" || this.CONFIG.title === "AvonSeals" || this.CONFIG.title === "Vistas" || this.CONFIG.title === "LinenRaj" || this.CONFIG.title === "SpecialWires" || this.CONFIG.title === "Beaubelle" || this.CONFIG.title === "BestGifts"||this.CONFIG.title === "Kubendran" ||this.CONFIG.title==="Carience"||this.CONFIG.title==="Vimpro"||this.CONFIG.title==="LushNGreen"
          ) {
            this.totalLength = this.totalItemsOrProducts = resp.result.total
              .value
              ? resp.result.total.value
              : 0;
          }
        },
        (err) => {
          if (err.error.error.message) {
            console.log(err.error.error.message);
          } else {
            console.log("Something bad happened; Please try again!");
          }
        }
      );
  }

  // TO REFRESH ALL PRODUCTS ON CLEAR ALL FUNCTION
  refreshLast90Days(event: number) {
    if(this.CONFIG.title !== "Deera"){
    this.currentPageInPagination = event;
    this.last90Days = "no";
    console.log("ppoapspppsospapp")
    if (
      this.CONFIG.title === "BombayHardware" || this.CONFIG.title === "Babys Pride" || this.CONFIG.title === "Karupattiraja" || this.CONFIG.title === "AvonSeals" || this.CONFIG.title === "Vistas" || this.CONFIG.title === "LinenRaj" || this.CONFIG.title === "SpecialWires" ||this.CONFIG.title === "Kubendran" ||this.CONFIG.title==="Carience"||this.CONFIG.title==="Vimpro"||this.CONFIG.title==="LushNGreen"||this.CONFIG.title==="Taazah"
    ) {
      if (this.dataFilter == "az") {
        console.log("best25")
        this.req_last90days_product_data3 = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          outlet_id:Number(this.outletId),
          // outlet_id:"",
          user_id: null,
          extras: {
            find: {
              brand: [],
              category: [],
              last90days: true,
              last30days: false,
              includeoutofstock: false,
              isglobalfilter: true,
            },
            pagination: true,
            paginationDetails: {
              limit: event,
              pagesize: 25,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "sort_order",
              sortorder: -1,
            },
          },
        };
      } else if (this.dataFilter == "za") {
        console.log("best1001")
        this.req_last90days_product_data3 = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          outlet_id:Number(this.outletId),
          // outlet_id:"",
          user_id: null,
          extras: {
            find: {
              brand: [],
              category: [],
              last90days: true,
              last30days: false,
              includeoutofstock: false,
              isglobalfilter: true,
            },
            pagination: true,
            paginationDetails: {
              limit: event,
              pagesize: 25,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "name",
              sortorder: +1,
            },
          },
        };
      }
    } 
    else if(this.CONFIG.title === "Deera"){
      if (this.dataFilter == "az") {
        console.log("best25")
        this.req_last90days_product_data3 = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          outlet_id:Number(this.outletId),
          // outlet_id:"",
          user_id: null,
          extras: {
            find: {
              brand: [],
              category: [],
              last90days: true,
              last30days: false,
              includeoutofstock: false,
              isglobalfilter: false,
            },
            pagination: true,
            paginationDetails: {
              limit: event,
              pagesize: 25,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "sort_order",
              sortorder: -1,
            },
          },
        };
      } else if (this.dataFilter == "za") {
        console.log("best1001")
        this.req_last90days_product_data3 = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          outlet_id:Number(this.outletId),
          // outlet_id:"",
          user_id: null,
          extras: {
            find: {
              brand: [],
              category: [],
              last90days: true,
              last30days: false,
              includeoutofstock: false,
              isglobalfilter: false,
            },
            pagination: true,
            paginationDetails: {
              limit: event,
              pagesize: 25,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "name",
              sortorder: +1,
            },
          },
        };
      }
    } 
   else if (
      this.CONFIG.title === "Beaubelle" 
    ) {
      if (this.dataFilter == "az") {
        console.log("best1002")
        this.req_last90days_product_data3 = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: null,

          extras: {
            find: {
              brand: [],
              category: [],
              last90days: true,
              last30days: false,
              includeoutofstock: false,
              isglobalfilter: false,
              filters_based_on:"brand",
            },
            pagination: true,
            paginationDetails: {
              limit: event,
              pagesize: 25,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "name",
              sortorder: -1,
            },
          },
        };
      } else if (this.dataFilter == "za") {
        console.log("best1003")
        this.req_last90days_product_data3 = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: null,
          
          extras: {
            find: {
              brand: [],
              category: [],
              last90days: true,
              last30days: false,
              includeoutofstock: false,
              isglobalfilter: false,
            },
            pagination: true,
            paginationDetails: {
              limit: event,
              pagesize: 25,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "name",
              sortorder: +1,
            },
          },
        };
      }
    }
    else {
      if (this.dataFilter == "az") {
        console.log("best1004")
        this.req_last90days_product_data3 = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: null,
          extras: {
            find: {
              brand: [],
              category: [],
              last90days: true,
              last30days: false,
              includeoutofstock: false,
            },
            pagination: true,
            paginationDetails: {
              limit: event,
              pagesize: 25,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "name",
              sortorder: -1,
            },
          },
        };
      } else if (this.dataFilter == "za") {
        console.log("best1005")
        this.req_last90days_product_data3 = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: null,
          extras: {
            find: {
              brand: [],
              category: [],
              last90days: true,
              last30days: false,
              includeoutofstock: false,
            },
            pagination: true,
            paginationDetails: {
              limit: event,
              pagesize: 25,
            },
            sorting: true,
            sortingDetails: {
              sortfield: "name",
              sortorder: +1,
            },
          },
        };
      }
    }

    this.appService
      .postApiCall(
        this.req_last90days_product_data3,
        ENDPOINTS.GET_FILTER_PRODUCTS
      )
      .subscribe(
        (resp) => {
          if(this.CONFIG.title === "Babys Pride" ){
            this.sortingForm.controls['sort_value'].setValue("Recommended");
            this.sortingForm.updateValueAndValidity();
            console.log("this.sortingForm",this.sortingForm.controls['sort_value'].value)
            this.sort_selected = true
            // this.sortingForm.controls['sort_value.value'].setValue("sort")
          }
          if(this.CONFIG.title === "Taazah" ){
            this.sortingForm.controls['sort_value'].setValue("Recommended");
            this.sortingForm.updateValueAndValidity();
            console.log("this.sortingForm",this.sortingForm.controls['sort_value'].value)
            this.sort_selected = true
            // this.sortingForm.controls['sort_value.value'].setValue("sort")
          }
          this.products = resp.result.data;
          //   if(!this.isfilter)
          //  {
          //this.isfilter=true;
          this.categoryList = resp.result.filters[0].categories;
          this.facets = resp.result.filters[1].brands;

          this.themes = resp.result.filters[2].themes;
          this.finish = resp.result.filters[3].finish;
          this.features = resp.result.filters[4].features;
          this.prices = resp.result.filters[5].prices;
          this.size = resp.result.filters[6].size;
          this.thickness = resp.result.filters[7].thickness;
          this.color = resp.result.filters[8].color;
          this.type = resp.result.filters[9].type;
          this.material = resp.result.filters[10].product_material;
          this.age = resp.result.filters[12].age;
          if (this.CONFIG.title !== "Babys Pride" && this.CONFIG.title !== "Cle" && this.CONFIG.title !== "Karupattiraja"){
          this.affiliation = resp.result.filters[13].affiliation;
          this.standard = resp.result.filters[14].standard;
          this.subject = resp.result.filters[15].subject;
            this.year = resp.result.filters[16].year;
            this.price_range = resp.result.filters[17].price_range;
          }
          this.totalItemsOrProducts = resp.result.total.value
            ? resp.result.total.value
            : 0;
          this.totalLength = resp.result.total ? resp.result.total : 0;
          if (
            this.CONFIG.title === "Aiema" || this.CONFIG.title === "Cle" ||
            this.CONFIG.title === "ShubhCards" ||
            this.CONFIG.title === "BombayHardware" ||
            this.CONFIG.title === "Deera" || this.CONFIG.title === "Babys Pride" || this.CONFIG.title==="LushNGreen" || this.CONFIG.title === "Karupattiraja" || this.CONFIG.title === "AvonSeals" || this.CONFIG.title === "Vistas" || this.CONFIG.title === "LinenRaj" || this.CONFIG.title === "SpecialWires" || this.CONFIG.title === "Beaubelle"  || this.CONFIG.title === "BestGifts"||this.CONFIG.title === "Kubendran"||this.CONFIG.title==="Carience"||this.CONFIG.title==="Vimpro"
          ) {
            this.totalLength = this.totalItemsOrProducts = resp.result.total
              .value
              ? resp.result.total.value
              : 0;
          }
         
        },
        (err) => {
          if (err.error.error.message) {
            console.log(err.error.error.message);
          } else {
            console.log("Something bad happened; Please try again!");
          }
        }
      );
    }
  }
  getProductDetails(id){
    return new Promise((resolve, reject) => {
      //this.productDetails = [];
      //productList.forEach(element => {
        
      
      //});
      resolve(this.productDetails)
    })
  }
  onConfirm(items) {
    this.activeMenu = items.option;
  }
  addToCartcarience(item_id)
  {
    let requestData = {
      "domain_name": ORG_DETAILS.DOMAIN_NAME,
      "user_id": ORG_DETAILS.USER_ID,
      "extras":{
        "find":{
          "id":item_id
        },
        "pagination":false,
        "paginationDetails":{
          "limit":0,
          "pageSize":2
        },
        "sorting":true,
        "sortingDetails":{
          "sortfield":"","sortorder":1
        }
      }
    }
    this.checkoutApiService.checkoutAPICall(ENDPOINTS.PRODUCT_DETAILS, requestData).then(
      respData => {
        let res:any = respData;
        if(res.success){
         //return res;
         var data=res.data[0];
         var sale_price=data['pricing']['raw']['sale_price'];
         data['pricing']['raw']['price']=sale_price;
         
         this.addToCart(data);
        }
      }
    )
    
  }
  changeAvonSealsValue(index, event) {
    console.log("index" + index)
    this.eventValue = event.target.value;
    console.log("event.target.value" + event.target.value)
     
    if (this.eventValue==0) {
      console.log("truee")
      this.appService.cartProducts.results.splice(index, 1);
      this.cartData = [];
      for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
        this.cartData.push(
          this.appService.cartProducts.results[i].product_id
        );
      }
      this.appService.totalCartItems = this.cartService.totalCartItems();
      this.cartService.updateCartItem(this.appService.cartProducts.results);
    }
    if (!this.eventValue) {
      console.log("truee")
      this.appService.cartProducts.results.splice(index, 1);
      this.cartData = [];
      for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
        this.cartData.push(
          this.appService.cartProducts.results[i].product_id
        );
      }
      this.appService.totalCartItems = this.cartService.totalCartItems();
      this.cartService.updateCartItem(this.appService.cartProducts.results);
    } else {
      console.log("falsee")
      this.alertService.clear();
      let tempArray = this.appService.cartProducts.results;
      let cartQty = 0;
  
  
      let tempCartQty: number = 0;
      tempArray.forEach((item) => {
        cartQty += item.quantity;
  
        if (item.product.id != this.product.id) {
          tempCartQty += item.quantity
          console.log("item.quantity"+item.quantity)
        }
      });
  
      if (cartQty > Number(this.localService.get("max_cart_qty"))) {
        console.log("truee444444444444")
        console.log("truee")
        this.alertService.error("Maximum allowed quantity in the cart is " + this.localService.get("max_cart_qty") + " only", this.options);
        this.appService.cartProducts.results.splice(index, 1);
        this.cartData = [];
        for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
          this.cartData.push(
            this.appService.cartProducts.results[i].product_id
          );
        }
        this.appService.totalCartItems = this.cartService.totalCartItems();
        this.cartService.updateCartItem(this.appService.cartProducts.results);
      }
   
      if (Number(this.localService.get("max_cart_qty")) < cartQty) {
        this.showAlerts = true;
        window.scrollTo(0, 0);
        this.maxValuetemp = Number(this.localService.get("max_cart_qty"))
        
       if (config.title === "AvonSeals") {
          tempArray[index].quantity = Number(this.localService.get("max_cart_qty")) - tempCartQty
          event.srcElement.value = String(Number(this.localService.get("max_cart_qty")) - tempCartQty)
          event.srcElement.blur()
          // this.alertService.error("Maximum allowed quantity in the cart is " + this.localService.get("max_cart_qty") + " only", this.options);
        } else {
          // this.alertService.error(
          //   "Maximum allowed quantity is " +
          //   this.localService.get("max_cart_qty") +
          //   " only",
          //   this.options
          // );
        }
        return;
      }
      if (
        this.appService.cartProducts.results[index].quantity <
        tempArray[index].product.pricing.raw.minimumorderquantity
      ) {
        this.appService.cartProducts.results.splice(index, 1);
        this.cartData = [];
        for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
          this.cartData.push(this.appService.cartProducts.results[i].product_id);
        }
        this.appService.totalCartItems = this.cartService.totalCartItems();
        this.cartService.updateCartItem(this.appService.cartProducts.results);
        return;
      }
    }
  }
  selectOptionLinenraj(value, id, index) {
    console.log(this.linenRajOption, 'products')
    console.log(this.linenRajOption.length)
    console.log(this.linenRajOption[0])
    //for(let i=0;i<=this.product.length;i++){
    //if(this.product[i].id == id){
    //this.products[i].size[0]=value;
    //this.products[i].subname = this.products[i].name + " - " + value
    // this.selectColour(this.product.variant.option_values[0].child[0].color, this.product.id, 0)
    //}
    //}
    this.current_index = index
    this.selectedOption1 = value;
    console.log(index,"index11")
    
    for (let j = 0; j < this.linenRajOption.variant.option_values.length; j++) {
      console.log(this.linenRajOption.variant.option_values[index],"index22")
      console.log(this.linenRajOption.variant.option_values[j],"j")
      this.linenRajOption.variant.option_values[j].is_default = false
      // this.product.variant.option_values[j].is_default = false
      // if (index == j) {
        // this.product.variant.option_values[index].is_default = true;
      // } 
      if (this.linenRajOption.variant.option_values[j].id===this.linenRajOption.variant.option_values[index].id) {
        console.log("truee")
        this.linenRajOption.variant.option_values[index].is_default = true;
        this.LinenPrice = this.linenRajOption.variant.option_values[index].pricing.raw.price;
        this.LinenName = this.linenRajOption.name + " " + this.linenRajOption.variant.option_values[index].option
        // this.LinenDescription = this.linenRajOption.variant.option_values[index].description;
        // this.LinenWeight = this.linenRajOption.variant.option_values[index].weight;
      }
    }
   
   
  }
  changeSpecial1Value(index, event) {
    this.alertService.clear();
    let tempArray = this.appService.cartProducts.results;
    let cartQty = 0;
    let tempCartQty: number = 0;
    tempArray.forEach((item) => {
      cartQty += item.quantity;
      let count = 0;
      if(item != tempArray[index]) {
        tempCartQty += item.quantity
      }
    });
    this.eventValue = event.target.value;
    console.log("event.target.value" + event.target.value)
    if (this.eventValue==0) {
      console.log("truee")
      this.appService.cartProducts.results.splice(index, 1);
      this.cartData = [];
      for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
        this.cartData.push(
          this.appService.cartProducts.results[i].product_id
        );
      }
      this.appService.totalCartItems = this.cartService.totalCartItems();
      this.cartService.updateCartItem(this.appService.cartProducts.results);
    }
    if (Number(this.localService.get("max_cart_qty")) < cartQty) {
      this.showAlerts = true;
      window.scrollTo(0, 0);

      if (this.CONFIG.title === "SpecialWires") {
        this.appService.cartProducts.results[index].quantity = Number(this.localService.get("max_cart_qty")) - tempCartQty;
        event.srcElement.value = String(Number(this.localService.get("max_cart_qty")) - tempCartQty)
        event.srcElement.blur()
        this.alertService.error(
          "Maximum allowed quantity in the cart is " +
            this.localService.get("max_cart_qty") +
            " only",
          this.options
        );
      } else {
        this.alertService.error(
          "Maximum allowed quantity is " +
            this.localService.get("max_cart_qty") +
            " only",
          this.options
        );
      }
      return;
    }
    //tempArray[index].quantity = (Number(tempArray[index].quantity) + 1)
    // let tempArray = this.appService.cartProducts.results;
    if (
      this.appService.cartProducts.results[index].quantity <
      tempArray[index].product.pricing.raw.minimumorderquantity
    ) {
      this.appService.cartProducts.results.splice(index, 1);
      this.cartData = [];
      for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
        this.cartData.push(this.appService.cartProducts.results[i].product_id);
      }
      this.appService.totalCartItems = this.cartService.totalCartItems();
      this.cartService.updateCartItem(this.appService.cartProducts.results);
      if (this.CONFIG.title === "SpecialWires") {
        let cartItemsString = JSON.stringify(
          this.appService.cartProducts.results
        );
        this.localService.set("cart", cartItemsString);
      }
      return;
    }

    // tempArray[index].quantity = (Number(tempArray[index].quantity) - 1)
    tempArray[index].sub_total =
      Number(tempArray[index].quantity) * Number(tempArray[index].cost);
    if (this.CONFIG.title === "SpecialWires") {
      //let tempArray = this.appService.cartProducts.results;
      let obj = {
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: ORG_DETAILS.USER_ID,
        extras: {
          find: {
            product_id: Number(tempArray[index].product_id),
            product_cost: Number(tempArray[index].cost),
            quantity: Number(tempArray[index].quantity),
            weight: Number(tempArray[index].product.shipping.weight_to_consider) * Number(tempArray[index].quantity),
            weight_to_consider:true
          },
        },
      };

      this.appService.postApiCall(obj, ENDPOINTS.STRUCTURED_PROMOTION).subscribe(
        (resp) => {
          if (resp) {
            if (resp.success === 1 && resp.status_code === 200) {
              for (let j = 0; j < this.appService.cartProducts.results.length;j++) {
                if (
                  this.appService.cartProducts.results[j].product_id === tempArray[index].id
                  
                )
                console.log("resp.result.data.discount_summary[0].discount_amount",resp.result.data.discount_summary[0].discount_amount);
                 {                      
                    this.appService.cartProducts.results[j]["discount_amount"] =
                      resp.result.data.discount_summary[0].discount_amount;
             
                  this.appService.cartProducts.results[j][
                    "after_dicount_price"
                  ] = resp.result.data.discount_summary[0].after_dicount_price;
                  console.log(
                    "this.appService.cartProducts.results[i].product.fixed_amount" +
                    this.appService.cartProducts.results[j].
                      after_dicount_price
                  );
                  this.cartService.updateCartItem(
                    this.appService.cartProducts.results
                  );
                  console.log(
                    "this.appService.cartProducts.results[i].product.fixed_amount" +
                      this.appService.cartProducts.results[j].discount_amount
                  );
                }
              }
              this.cartService.updateCartItem(
                this.appService.cartProducts.results
              );

              console.log(
                "tempArray[index].product.discount_value" +
                  tempArray[index].product.discount_value
              );
            } else if (resp.success === 0) {
              if (resp.message) {
                //this.alertService.error(resp.message, this.options);
              }
            } else if (resp.message && resp.status_code !== 200) {
              //this.alertService.error(resp.message, this.options);
            } else {
              //this.alertService.error('Something bad happened. Please try again!', this.options);
            }
          }
        },
        (err) => {
          if (err.error.statusCode === 403) {
            //this.alertService.error('Session Time Out! Please login Again', this.options)
          } else if (err.error.error.message) {
            //this.alertService.error(err.error.error.message, this.options)
          } else {
            //this.alertService.error('Something bad happened. Please try again!', this.options);
          }
        }
      );
      tempArray[index].sub_total =
        Number(tempArray[index].quantity) * Number(tempArray[index].cost);
      this.appService.cartProducts.results = tempArray;
      this.appService.totalCartItems = this.cartService.totalCartItems();
      this.cartService.updateCartItem(this.appService.cartProducts.results);
      if (this.CONFIG.title === "SpecialWires") {
        let cartItemsString = JSON.stringify(
          this.appService.cartProducts.results
        );
        this.localService.set("cart", cartItemsString);
      }
    }
  }
  addtocartVistas(item)
  {
    console.log("daytaaaaaaaaaaaaaa")

    let cartQty = 0;
    let tempArray = this.appService.cartProducts.results;
    tempArray.forEach((item) => {
      cartQty += item.quantity;
    });
    var max_cart_qty=(Number(this.localService.get("max_cart_qty")));
    if(max_cart_qty<=cartQty||max_cart_qty<cartQty+(item.pricing.raw.minimumorderquantity!=0&&item.pricing.raw.minimumorderquantity!=null?item.pricing.raw.minimumorderquantity:1) ) {
      this.alertService.error(
        "Maximum allowed quantity is " +
          this.localService.get("max_cart_qty") +
          " only",
        this.options
      );
      return
       
    }
    if (ORG_DETAILS.NAME === "Vistas") {
      let userId = this.localService.get('UserId');
      let obj =
      {
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: ORG_DETAILS.USER_ID,
        extras: {
          find: {
            product_id: Number(item.id),
            product_cost: Number(item.pricing.raw.price),
            quantity: 1,
            customer_id: Number(userId),
            
          },
        },
      };

    this.appService.postApiCall(obj, ENDPOINTS.STRUCTURED_PROMOTION).subscribe(
      (resp) => {
        if (resp) {
          if (resp.success === 1 && resp.status_code === 200) {
            for (let j = 0; j < this.appService.cartProducts.results.length;j++) {
              if (
                this.appService.cartProducts.results[j].product_id === item.id
              ) {                      
                  this.appService.cartProducts.results[j]["discount_amount"] =
                    resp.result.data.discount_summary[0].discount_amount;
           
                this.appService.cartProducts.results[j][
                  "after_dicount_price"
                ] = resp.result.data.discount_summary[0].after_dicount_price;
                console.log(
                  "this.appService.cartProducts.results[i].product.fixed_amount" +
                  this.appService.cartProducts.results[j].
                    after_dicount_price
                );
                this.cartService.updateCartItem(
                  this.appService.cartProducts.results
                );
                console.log(
                  "this.appService.cartProducts.results[i].discount_amount" +
                    this.appService.cartProducts.results[j].discount_amount
                );
              }
            }
            let cartItemsString = JSON.stringify(
              this.appService.cartProducts.results
            );
            this.localService.set("cart", cartItemsString);
          } else if (resp.success === 0) {
            if (resp.message) {
            }
          } else if (resp.message && resp.status_code !== 200) {
          } else {
          }
        }
      },
      (err) => {
        if (err.error.statusCode === 403) {
        } else if (err.error.error.message) {
        } else {
        }
      }
    );
      }
    
      this.cartService.addToCart(item);
  
    }
  changeVistas1Value(index, event) {
    let userId = this.localService.get('UserId');
    this.alertService.clear();
    let tempArray = this.appService.cartProducts.results;
    let cartQty = 0;
    let tempCartQty: number = 0;
    tempArray.forEach((item) => {
      cartQty += item.quantity;
      let count = 0;
      if(item != tempArray[index]) {
        tempCartQty += item.quantity
      }
    });
    this.eventValue = event.target.value;
    console.log("event.target.value" + event.target.value)
    if (this.eventValue==0) {
      console.log("truee")
      this.appService.cartProducts.results.splice(index, 1);
      this.cartData = [];
      for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
        this.cartData.push(
          this.appService.cartProducts.results[i].product_id
        );
      }
      this.appService.totalCartItems = this.cartService.totalCartItems();
      this.cartService.updateCartItem(this.appService.cartProducts.results);
    }
    if (Number(this.localService.get("max_cart_qty")) < cartQty) {
      this.showAlerts = true;
      window.scrollTo(0, 0);

        this.appService.cartProducts.results[index].quantity = Number(this.localService.get("max_cart_qty")) - tempCartQty;
        event.srcElement.value = String(Number(this.localService.get("max_cart_qty")) - tempCartQty)
        event.srcElement.blur()
        this.alertService.error(
          "Maximum allowed quantity in the cart is " +
            this.localService.get("max_cart_qty") +
            " only",
          this.options
        );

      return;
    }
    //tempArray[index].quantity = (Number(tempArray[index].quantity) + 1)
    // let tempArray = this.appService.cartProducts.results;
    if (
      this.appService.cartProducts.results[index].quantity <
      tempArray[index].product.pricing.raw.minimumorderquantity
    ) {
      this.appService.cartProducts.results.splice(index, 1);
      this.cartData = [];
      for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
        this.cartData.push(this.appService.cartProducts.results[i].product_id);
      }
      this.appService.totalCartItems = this.cartService.totalCartItems();
      this.cartService.updateCartItem(this.appService.cartProducts.results);

        let cartItemsString = JSON.stringify(
          this.appService.cartProducts.results
        );
        this.localService.set("cart", cartItemsString);
      return;
    }

    // tempArray[index].quantity = (Number(tempArray[index].quantity) - 1)
    tempArray[index].sub_total =
      Number(tempArray[index].quantity) * Number(tempArray[index].cost);
   
    if (ORG_DETAILS.NAME === "Vistas"){
      let obj = {
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: ORG_DETAILS.USER_ID,
        extras: {
          find: {
            product_id: Number(tempArray[index].product_id),
            product_cost: Number(tempArray[index].cost),
            quantity: Number(event.srcElement.value),
            customer_id: Number(userId),
            weight: Number(tempArray[index].product.shipping.weight_to_consider) * Number(tempArray[index].quantity),
            weight_to_consider:true
          },
        },
      };

      try {
        this.appService
          .postApiCall(obj, ENDPOINTS.STRUCTURED_PROMOTION)
          .subscribe(
            (resp) => {
              if (resp) {
                if (resp.success === 1 && resp.status_code === 200) {
                  this.appService.cartProducts.results[index]["discount_amount"] =
                resp.result.data.discount_summary[0].discount_amount;
       
            this.appService.cartProducts.results[index][
              "after_dicount_price"
            ] = resp.result.data.discount_summary[0].after_dicount_price;
                  this.cartService.updateCartItem(
                    this.appService.cartProducts.results
                  );
                } else if (resp.success === 0) {
                  if (resp.message) {
                    //this.alertService.error(resp.message, this.options);
                  }
                } else if (resp.message && resp.status_code !== 200) {
                  //this.alertService.error(resp.message, this.options);
                } else {
                  //this.alertService.error('Something bad happened. Please try again!', this.options);
                }
              }
            },
            (err) => {
              if (err.error.statusCode === 403) {
                //this.alertService.error('Session Time Out! Please login Again', this.options)
              } else if (err.error.error.message) {
                //this.alertService.error(err.error.error.message, this.options)
              } else {
                //this.alertService.error('Something bad happened. Please try again!', this.options);
              }
            }
          );
      } catch (err) {
        console.log("ERROR IN ADDING ITEM: ", err);
      }
    }
    tempArray[index].sub_total =
    Number(tempArray[index].quantity) * Number(tempArray[index].cost);
  this.appService.cartProducts.results = tempArray;
  this.appService.totalCartItems = this.cartService.totalCartItems();
  this.cartService.updateCartItem(this.appService.cartProducts.results);
  if (ORG_DETAILS.NAME === "Vistas") {
    let cartItemsString = JSON.stringify(
      this.appService.cartProducts.results
    );
    this.localService.set("cart", cartItemsString);
  }
  }
changeVistasValue(index, event) {
  this.alertService.clear();
    let tempArray = this.appService.cartProducts.results;
    let cartQty = 0;
    let tempCartQty: number = 0;
    tempArray.forEach((item) => {
      cartQty += item.quantity;
      let count = 0;
      if(item != tempArray[index]) {
        tempCartQty += item.quantity
      }
    });
    this.eventValue = event.target.value;
    console.log("event.target.value" + event.target.value)
    // if (this.eventValue==0) {
    //   console.log("truee")
    //   this.appService.cartProducts.results.splice(index, 1);
    //   this.cartData = [];
    //   for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
    //     this.cartData.push(
    //       this.appService.cartProducts.results[i].product_id
    //     );
    //   }
    //   this.appService.totalCartItems = this.cartService.totalCartItems();
    //   this.cartService.updateCartItem(this.appService.cartProducts.results);
    // }
  if (Number(this.localService.get("max_cart_qty")) < cartQty) {
    this.showAlerts = true;
    window.scrollTo(0, 0);

    // if (this.CONFIG.title === "Vistas") {
      this.appService.cartProducts.results[index].quantity = Number(this.localService.get("max_cart_qty")) - tempCartQty;
      event.srcElement.value = String(Number(this.localService.get("max_cart_qty")) - tempCartQty)
      event.srcElement.blur()
      this.alertService.error(
        "Maximum allowed quantity in the cart is " +
          this.localService.get("max_cart_qty") +
          " only",
        this.options
      );
    // } else {
    //   this.alertService.error(
    //     "Maximum allowed quantity is " +
    //       this.localService.get("max_cart_qty") +
    //       " only",
    //     this.options
    //   );
    // }
    return;
  }
  // if (ORG_DETAILS.NAME === "Vistas") {
    let userId = this.localService.get('UserId');

    let obj = {
      domain_name: ORG_DETAILS.DOMAIN_NAME,
      user_id: ORG_DETAILS.USER_ID,
      extras: {
        find: {
          customer_id: Number(userId),
          product_id: Number(tempArray[index].product_id),
          product_cost: Number(tempArray[index].cost),
          quantity: tempArray[index].quantity,
          weight: Number(tempArray[index].product.shipping.weight_to_consider) * Number(tempArray[index].quantity),
            weight_to_consider:true
        },
      },
    };
    this.appService.postApiCall(obj, ENDPOINTS.STRUCTURED_PROMOTION).subscribe(
      (resp) => {
        if (resp) {
          if (resp.success === 1 && resp.status_code === 200) {
            for (let j = 0; j < this.appService.cartProducts.results.length;j++) {
              if (
                this.appService.cartProducts.results[j].product_id === tempArray[index].id
                
              )
              console.log("resp.result.data.discount_summary[0].discount_amount",resp.result.data.discount_summary[0].discount_amount);
               {                      
                  this.appService.cartProducts.results[j]["discount_amount"] =
                    resp.result.data.discount_summary[0].discount_amount;
           
                this.appService.cartProducts.results[j][
                  "after_dicount_price"
                ] = resp.result.data.discount_summary[0].after_dicount_price;
                console.log(
                  "this.appService.cartProducts.results[i].product.fixed_amount" +
                  this.appService.cartProducts.results[j].
                    after_dicount_price
                );
                this.cartService.updateCartItem(
                  this.appService.cartProducts.results
                );
                console.log(
                  "this.appService.cartProducts.results[i].product.fixed_amount" +
                    this.appService.cartProducts.results[j].discount_amount
                );
              }
            }
            let cartItemsString = JSON.stringify(
              this.appService.cartProducts.results
            );
            this.localService.set("cart", cartItemsString);
          } else if (resp.success === 0) {
            if (resp.message) {
            }
          } else if (resp.message && resp.status_code !== 200) {
          } else {
          }
        }
      },
      (err) => {
        if (err.error.statusCode === 403) {
        } else if (err.error.error.message) {
        } else {
        }
      }
    );
    // }
}
   changeSpecialValue(index, event) {
    console.log("index" + index)
    this.eventValue = event.target.value;
    console.log("event.target.value" + event.target.value)
     
    if (this.eventValue==0) {
      console.log("truee")
      this.appService.cartProducts.results.splice(index, 1);
      this.cartData = [];
      for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
        this.cartData.push(
          this.appService.cartProducts.results[i].product_id
        );
      }
      this.appService.totalCartItems = this.cartService.totalCartItems();
      this.cartService.updateCartItem(this.appService.cartProducts.results);
    }
    if (!this.eventValue) {
      console.log("truee")
      this.appService.cartProducts.results.splice(index, 1);
      this.cartData = [];
      for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
        this.cartData.push(
          this.appService.cartProducts.results[i].product_id
        );
      }
      this.appService.totalCartItems = this.cartService.totalCartItems();
      this.cartService.updateCartItem(this.appService.cartProducts.results);
    } else {
      console.log("falsee")
      this.alertService.clear();
      let tempArray = this.appService.cartProducts.results;
      let cartQty = 0;
  
  
      let tempCartQty: number = 0;
      tempArray.forEach((item) => {
        cartQty += item.quantity;
        let count = 0;
        if(item != tempArray[index]) {
          tempCartQty += item.quantity
        }
      });
  
      if (cartQty > Number(this.localService.get("max_cart_qty"))) {
        console.log("truee444444444444")
        console.log("truee")
        // this.alertService.error("Maximum allowed quantity in the cart is " + this.localService.get("max_cart_qty") + " only", this.options);
        // this.appService.cartProducts.results.splice(index, 1);
        // this.cartData = [];
        // for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
        //   this.cartData.push(
        //     this.appService.cartProducts.results[i].product_id
        //   );
        // }
        // this.appService.totalCartItems = this.cartService.totalCartItems();
        // this.cartService.updateCartItem(this.appService.cartProducts.results);
        this.appService.cartProducts.results[index].quantity = Number(this.localService.get("max_cart_qty")) - tempCartQty;
        event.srcElement.value = String(Number(this.localService.get("max_cart_qty")) - tempCartQty)
        event.srcElement.blur()
        this.alertService.error(
          "Maximum allowed quantity in the cart is " +
            this.localService.get("max_cart_qty") +
            " only",
          this.options
        );
      }
   
      if (Number(this.localService.get("max_cart_qty")) < cartQty) {
        this.showAlerts = true;
        window.scrollTo(0, 0);
        this.maxValuetemp = Number(this.localService.get("max_cart_qty"))
        
      //  if (config.title === "SpecialWires") {
      //     tempArray[index].quantity = Number(this.localService.get("max_cart_qty")) - tempCartQty
      //     event.srcElement.value = String(Number(this.localService.get("max_cart_qty")) - tempCartQty)
      //     event.srcElement.blur()
      //   } else {
      //     this.alertService.error(
      //       "Maximum allowed quantity is " +
      //       this.localService.get("max_cart_qty") +
      //       " only",
      //       this.options
      //     );
      //   }
      //   return this.eventValue;
      }
      else {
        this.alertService.clear();
        let tempArray = this.appService.cartProducts.results;
    
        let cartQty = 0
        console.log("insidee")
        let tempId: number = 0
        let tempCartQty: number = 0;
        tempArray.forEach((item) => {
          cartQty += item.quantity;
          let count = 0;
          if(item != tempArray[index]) {
            tempCartQty += item.quantity
          }
        });
    
        if(Number(this.localService.get('max_cart_qty')) <= cartQty)
        {
          this.showAlerts = true;
          window.scrollTo(0,0);
      //  if(this.CONFIG.name==='SpecialWires'){
      //       tempArray[index].quantity = String(Number(this.localService.get('max_cart_qty')) - tempCartQty);
      //       event.srcElement.value = String(Number(this.localService.get('max_cart_qty')) - tempCartQty);
      //       console.log("insidee11")
    
      //       event.srcElement.blur();
      //       this.alertService.error("Maximum allowed quantity is " +this.localService.get('max_cart_qty') +" only",this.options)
      //     }
      //     else {
      //       this.alertService.error("Maximum allowed quantity is " +this.localService.get('max_cart_qty') +" only",this.options)
      //     }
        }
      if (
        this.appService.cartProducts.results[index].quantity <
        tempArray[index].product.pricing.raw.minimumorderquantity
      )
       {
        this.appService.cartProducts.results.splice(index, 1);
        this.cartData = [];
        for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
          this.cartData.push(this.appService.cartProducts.results[i].product_id);
        }
        this.appService.totalCartItems = this.cartService.totalCartItems();
        this.cartService.updateCartItem(this.appService.cartProducts.results);
        return;
      }
    }
    }
  }
   get_count(id)
  {
    var filter= this.appService.cartProducts.results.filter(element=>{
      return element.product.parent.id==id
     
    })

    return filter.length;
  }
  get_prod(id)
  {
    var filter= this.appService.cartProducts.results.filter(element=>{
      return element.product.parent.id==id
     
    })

    return filter;
  }
  specialalert(){

  }
  addToCartSpecialWires(item_id) {
    let userId = this.localService.get('UserId');
    
    if(userId){
      let maxorderedquantity=this.appService.cartProducts.results.reduce((partialSum, a) => partialSum + a.quantity, 0)
      if(maxorderedquantity>=Number(this.localService.get('max_cart_qty')))
      {
        this.alertService.error("Maximum allowed quantity is " + this.localService.get('max_cart_qty') + " only", this.options)
            return false;
      }
//       if(this.product['current_index']=-1){
// alert("Select Size");
//       }
//       else{
      let requestData = {
        "domain_name": ORG_DETAILS.DOMAIN_NAME,
        "user_id": ORG_DETAILS.USER_ID,
        "extras": {
          "find": {
            "id": item_id
          },
          "pagination": false,
          "paginationDetails": {
            "limit": 0,
            "pageSize": 2
          },
          "sorting": true,
          "sortingDetails": {
            "sortfield": "", "sortorder": 1
          }
        }
      }
      this.checkoutApiService.checkoutAPICall(ENDPOINTS.PRODUCT_DETAILS, requestData).then(
        respData => {
          let res: any = respData;
          if (res.success) {
            // this.newProductDetails=res.data[0];
            //return res;
            let tempArray = this.appService.cartProducts.results;
            let cartQty = 0;
  
            tempArray.forEach((item) => {
              cartQty += item.quantity;
            });
            var data = res.data[0];
            var sale_price = data['pricing']['raw']['sale_price'];
            data['pricing']['raw']['price'] = sale_price;
            data['pricing']['raw']['cost']=sale_price;
  
            this.cartService.addToCart(data);

  console.log("datayadddddddddddddddd",data)

          let obj =
            {
              domain_name: ORG_DETAILS.DOMAIN_NAME,
              user_id: ORG_DETAILS.USER_ID,
              extras: {
                find: {
                  product_id: Number(data.id),
                  product_cost: Number(data['pricing']['raw']['cost']),
                  quantity: Number(data['pricing']['raw']['minimumorderquantity']),
                  customer_id: Number(userId),
                  weight: Number(data['shipping']['weight_to_consider'])*Number(data['pricing']['raw']['minimumorderquantity']),
                  weight_to_consider:true
                },
              },
            };
  
          this.appService.postApiCall(obj, ENDPOINTS.STRUCTURED_PROMOTION).subscribe(
            (resp) => {
              if (resp) {
                if (resp.success === 1 && resp.status_code === 200) {
                  for (let j = 0; j < this.appService.cartProducts.results.length;j++) {
                    if (
                      this.appService.cartProducts.results[j].product_id === data.id
                    ) {                      
                        this.appService.cartProducts.results[j]["discount_amount"] =
                          resp.result.data.discount_summary[0].discount_amount;
                 
                      this.appService.cartProducts.results[j][
                        "after_dicount_price"
                      ] = resp.result.data.discount_summary[0].after_dicount_price;
                      console.log(
                        "this.appService.cartProducts.results[i].product.fixed_amount" +
                        this.appService.cartProducts.results[j].
                          after_dicount_price
                      );
                      this.cartService.updateCartItem(
                        this.appService.cartProducts.results
                      );
                      console.log(
                        "this.appService.cartProducts.results[i].product.fixed_amount" +
                          this.appService.cartProducts.results[j].discount_amount
                      );
                    }
                  }
                  let cartItemsString = JSON.stringify(
                    this.appService.cartProducts.results
                  );
                  this.localService.set("cart", cartItemsString);
                } else if (resp.success === 0) {
                  if (resp.message) {
                  }
                } else if (resp.message && resp.status_code !== 200) {
                } else {
                }
              }
            },
            (err) => {
              if (err.error.statusCode === 403) {
              } else if (err.error.error.message) {
              } else {
              }
            }
          );
          }
          this.localService.get('cartQty')
        }
      )
      
    } 
    else {
      this.router.navigate(["/login-new"], {
        queryParams: { "forLogin": ""},
        relativeTo: this.route,
        skipLocationChange: false,
      });
    }


  }
  addToCartSchift(item) {
    let tempArray = this.appService.cartProducts.results;
    let cartQty = 0;

    tempArray.forEach((item) => {
      cartQty += item.quantity;
    });

    if (Number(this.localService.get('max_cart_qty')) <= cartQty) {
      this.showAlerts = true;
      window.scrollTo(0, 0);
      // this.alertService.error("Maximum allowed quantity is " +this.localService.get('max_cart_qty') +" only",this.options)
  if (config.title === 'Schift Cosmetics') {
        this.alertService.error("Maximum allowed quantity is " + this.localService.get('max_cart_qty') + " only", this.options)
      }

      return
    } else {
  
            this.cartService.addToCart(item);
            if(this.CONFIG.title === 'Schift Cosmetics'){
              this.openbagForSchift()
            
          }
      
    }

  }
  addToCartLinenraj(item_id) {
    let tempArray = this.appService.cartProducts.results;
    let cartQty = 0;

    tempArray.forEach((item, i) => {
      cartQty += item.quantity;
    });

    if (Number(this.localService.get('max_cart_qty')) <= cartQty) {
      this.showAlerts = true;
      window.scrollTo(0, 0);
      // this.alertService.error("Maximum allowed quantity is " +this.localService.get('max_cart_qty') +" only",this.options)
  if (config.title === 'LinenRaj') {
        this.alertService.error("Maximum allowed quantity is " + this.localService.get('max_cart_qty') + " only", this.options)
      }

      return
    } else {
      let requestData = {
        "domain_name": ORG_DETAILS.DOMAIN_NAME,
        "user_id": ORG_DETAILS.USER_ID,
        "extras": {
          "find": {
            "id": item_id
          },
          "pagination": false,
          "paginationDetails": {
            "limit": 0,
            "pageSize": 2
          },
          "sorting": true,
          "sortingDetails": {
            "sortfield": "", "sortorder": 1
          }
        }
      }
      this.checkoutApiService.checkoutAPICall(ENDPOINTS.PRODUCT_DETAILS, requestData).then(
        respData => {
          let res: any = respData;
          if (res.success) {
            // this.newProductDetails=res.data[0];
            //return res;
            // let tempArray = this.appService.cartProducts.results;
            // let cartQty = 0;
  
            // tempArray.forEach((item) => {
            //   cartQty += item.quantity;
            // });
            // var data = res.data[0];
            var data = res.data[0];
            // var sale_price = data['pricing']['raw']['sale_price'];
            // data['pricing']['raw']['price'] = sale_price;
  
            this.cartService.addToCart(data);
            if(this.CONFIG.title === 'LinenRaj'){
              this.openbagForLinenRaja()
            }
          }
        }
      )
    }

  }
  //Applies moq against max allowed qty
  async addtocartKarupatti(item)
  {
   await  this.getProfileDetails(this.localService.get('UserId')!=null?Number(this.localService.get('UserId')):'');
    console.log("daytaaaaaaaaaaaaaa")
    if(String(this.approved)!=='Approved'&&ORG_DETAILS.NAME === "Karupattiraja")
  {
    this.logout();
  }
  else{
    if(this.CONFIG.name === "Vimpro")
    {
      let requestData = {
        "domain_name": ORG_DETAILS.DOMAIN_NAME,
        "user_id": ORG_DETAILS.USER_ID,
        "extras":{
          "find":{
            "id":item
          },
          "pagination":false,
          "paginationDetails":{
            "limit":0,
            "pageSize":2
          },
          "sorting":true,
          "sortingDetails":{
            "sortfield":"","sortorder":1
          }
        }
      }
      this.checkoutApiService.checkoutAPICall(ENDPOINTS.PRODUCT_DETAILS, requestData).then(
        respData => {
          let res:any = respData;
          if(res.success){
           //return res;
           var data=res.data[0];
           var sale_price=data['pricing']['raw']['sale_price'];
           data['pricing']['raw']['price']=sale_price;
           
           //this.addToCart(data);
           let cartQty = 0;
      let tempArray = this.appService.cartProducts.results;
      tempArray.forEach((item) => {
        cartQty += item.quantity;
      });
      var max_cart_qty=(Number(this.localService.get("max_cart_qty")));
      if(max_cart_qty<=cartQty||max_cart_qty<cartQty+(data.pricing.raw.minimumorderquantity!=0&&data.pricing.raw.minimumorderquantity!=null?data.pricing.raw.minimumorderquantity:1) ) {
        this.alertService.error(
          "Maximum allowed quantity is " +
            this.localService.get("max_cart_qty") +
            " only",
          this.options
        );
        return
      
    }
    
    this.cartService.addToCart(data);
          }
        }
      )
      
    }
   
     
    
    else{




 


let cartQty = 0;
let tempArray = this.appService.cartProducts.results;
tempArray.forEach((item) => {
  cartQty += item.quantity;
});
var max_cart_qty=(Number(this.localService.get("max_cart_qty")));
if(max_cart_qty<=cartQty||max_cart_qty<cartQty+(item.pricing.raw.minimumorderquantity!=0&&item.pricing.raw.minimumorderquantity!=null?item.pricing.raw.minimumorderquantity:1) ) {
  this.alertService.error(
    "Maximum allowed quantity is " +
      this.localService.get("max_cart_qty") +
      " only",
    this.options
  );
  
  return


       
    }
    if (ORG_DETAILS.NAME === "Vistas") {
      // let userId = this.localService.get('UserId');

      // let obj = {
      //   domain_name: ORG_DETAILS.DOMAIN_NAME,
      //   user_id: ORG_DETAILS.USER_ID,
      //   extras: {
      //     find: {
      //       customer_id: Number(userId),
      //       product_id: Number(item.id),
      //       product_cost: Number(item.pricing.raw.price),
      //       quantity: 1,
      //     },
      //   },
      // };
      // this.appService.postApiCall(obj, ENDPOINTS.STRUCTURED_PROMOTION).subscribe(
      //   (resp) => {
      //     if (resp) {
      //       if (resp.success === 1 && resp.status_code === 200) {
      //         for (let j = 0; j < this.appService.cartProducts.results.length;j++) {
      //           if (
      //             this.appService.cartProducts.results[j].product_id === item.id
                  
      //           )
      //           console.log("resp.result.data.discount_summary[0].discount_amount",resp.result.data.discount_summary[0].discount_amount);
      //            {                      
      //               this.appService.cartProducts.results[j]["discount_amount"] =
      //                 resp.result.data.discount_summary[0].discount_amount;
             
      //             this.appService.cartProducts.results[j][
      //               "after_dicount_price"
      //             ] = resp.result.data.discount_summary[0].after_dicount_price;
      //             console.log(
      //               "this.appService.cartProducts.results[i].product.fixed_amount" +
      //               this.appService.cartProducts.results[j].
      //                 after_dicount_price
      //             );
      //             this.cartService.updateCartItem(
      //               this.appService.cartProducts.results
      //             );
      //             console.log(
      //               "this.appService.cartProducts.results[i].product.fixed_amount" +
      //                 this.appService.cartProducts.results[j].discount_amount
      //             );
      //           }
      //         }
      //         let cartItemsString = JSON.stringify(
      //           this.appService.cartProducts.results
      //         );
      //         this.localService.set("cart", cartItemsString);
      //       } else if (resp.success === 0) {
      //         if (resp.message) {
      //         }
      //       } else if (resp.message && resp.status_code !== 200) {
      //       } else {
      //       }
      //     }
      //   },
      //   (err) => {
      //     if (err.error.statusCode === 403) {
      //     } else if (err.error.error.message) {
      //     } else {
      //     }
      //   }
      // );
      let userId = this.localService.get('UserId');
      let obj =
      {
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: ORG_DETAILS.USER_ID,
        extras: {
          find: {
            product_id: Number(item.id),
            product_cost: Number(item.pricing.raw.price),
            quantity: 1,
            customer_id: Number(userId),
            weight: Number(item.shipping.weight_to_consider) * Number(item.quantity),
            weight_to_consider:true
          },
        },
      };

    this.appService.postApiCall(obj, ENDPOINTS.STRUCTURED_PROMOTION).subscribe(
      (resp) => {
        if (resp) {
          if (resp.success === 1 && resp.status_code === 200) {
            for (let j = 0; j < this.appService.cartProducts.results.length;j++) {
              if (
                this.appService.cartProducts.results[j].product_id === item.id
              ) {                      
                  this.appService.cartProducts.results[j]["discount_amount"] =
                    resp.result.data.discount_summary[0].discount_amount;
           
                this.appService.cartProducts.results[j][
                  "after_dicount_price"
                ] = resp.result.data.discount_summary[0].after_dicount_price;
                console.log(
                  "this.appService.cartProducts.results[i].product.fixed_amount" +
                  this.appService.cartProducts.results[j].
                    after_dicount_price
                );
                this.cartService.updateCartItem(
                  this.appService.cartProducts.results
                );
                console.log(
                  "this.appService.cartProducts.results[i].discount_amount" +
                    this.appService.cartProducts.results[j].discount_amount
                );
              }
            }
            let cartItemsString = JSON.stringify(
              this.appService.cartProducts.results
            );
            this.localService.set("cart", cartItemsString);
          } else if (resp.success === 0) {
            if (resp.message) {
            }
          } else if (resp.message && resp.status_code !== 200) {
          } else {
          }
        }
      },
      (err) => {
        if (err.error.statusCode === 403) {
        } else if (err.error.error.message) {
        } else {
        }
      }
    );
      }
      this.cartService.addToCart(item); }
    
}
    
    
  }
    

    logout()
    {
      this.appService.userLoggedIn = false;
    this.appService.userName = "";
    console.log( this.appService.userName,"login user")

    this.appService.loggedin_user = false;
    this.localService.remove('accessToken');
    this.localService.remove('refreshToken');
    this.localService.remove('expireTime');
    this.localService.remove('UserName');
    this.localService.remove('UserId');
    this.localService.remove('CleIECode');
    this.localService.remove('CleCusomerid');
    this.localService.remove('CompanyName');
    this.localService.remove('CompanyEmail');
    this.localService.remove('CompanyTelephone');
    this.localService.remove('CompanyMobileNumber');
    this.localService.remove('CompanyFOBValue');
    this.localService.remove('customerGroup');
    this.localService.remove('domainName');
    this.localService.remove('rexpireTime');
    this.localService.remove('AiemaUserName');
    this.localService.remove('couponCode');
    this.localService.remove('company_name');
    this.localService.remove('gst_number');
    this.localService.remove('company_address');
    this.appService.removeSession();
    this.LoginService.updateAdminFormEvent({name: "alert_error"});
      this.checkoutLocalStorageService.clearDataonLogout();
    this.checkoutLocalStorageService.removeOrderId();
    this.router.navigate([`/login-new`], { skipLocationChange: false });

                              
    }
   async  getProfileDetails(id) {
    return new Promise((resolve, reject) => {
      let requestBody = {
        "domain_name": ORG_DETAILS.DOMAIN_NAME,
        "user_id": ORG_DETAILS.USER_ID,
        "extras": {
          "find": {
            "id" : id
          }
        }
      }
      // MAKE A SERVICE CALL HERE...
      this.appService.postApiCall(requestBody,ENDPOINTS.GET_CUSTOMER,).subscribe(
        resp => {
          if (resp) {
         
            this.approved= resp.result.data[0]!=null?resp.result.data[0].status:'';
            
           
         
          }
          else{
            this.approved="";
          }
          resolve(true);
        },
        err => {
         resolve(false);
          // if (err.error.statusCode === 403) {
          //   this.alertService.error('Session Time Out! Please login Again', this.options)
          //   this.router.navigate([`/login-new`], { skipLocationChange: false });
          // }
          // else if (err.error.message) {
          //   this.alertService.error(err.error.message, this.options)
          // }
          // else {
          //   this.alertService.error('Something bad happened. Please try again!', this.options);
          // }
        }
      )
    })
   
  }
async decreasekarupattiitem(index)
{
  await  this.getProfileDetails(this.localService.get('UserId')!=null?Number(this.localService.get('UserId')):'');
  console.log("daytaaaaaaaaaaaaaa")
  if(String(this.approved)!=='Approved'&&ORG_DETAILS.NAME === "Karupattiraja")
{
  this.logout();
}
else{

  let tempArray = this.appService.cartProducts.results;
if(tempArray[index].quantity<=tempArray[index].product.pricing.raw.minimumorderquantity)
{
  tempArray[index].quantity =Number(tempArray[index].quantity)-tempArray[index].product.pricing.raw.minimumorderquantity;
}
else {
  if(tempArray[index].product.pricing.raw.decrementvalue>0)
  {
    console.log("trueeeeeee")
    tempArray[index].quantity = Number(tempArray[index].quantity) - Number(tempArray[index].product.pricing.raw.decrementvalue);
  } else {
    tempArray[index].quantity = Number(tempArray[index].quantity) - 1;
  }
  // tempArray[index].quantity=Number(tempArray[index].quantity)-1;
}
if(tempArray[index].quantity<=0)
{
  this.appService.cartProducts.results.splice(index, 1);
}

  this.appService.totalCartItems = this.cartService.totalCartItems();
  this.cartService.updateCartItem(this.appService.cartProducts.results);


}
 

}
  addToCart(item) {
    console.log(item,"item")
    
    let cartQty = 0;
    let tempArray = this.appService.cartProducts.results;
    tempArray.forEach((item) => {
      cartQty += item.quantity;
    });

    if((Number(this.localService.get("max_cart_qty")) <= cartQty) ) {
      this.alertService.error(
        "Maximum allowed quantity is " +
          this.localService.get("max_cart_qty") +
          " only",
        this.options
      );
      return
    } else {
      this.cartService.addToCart(item);
      for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
        if(this.CONFIG.title==="Deera" || this.CONFIG.title === "Babys Pride" ||this.CONFIG.title==="LushNGreen" || this.CONFIG.title === "AvonSeals"  || this.CONFIG.title === "Vistas" || this.CONFIG.title === "LinenRaj" || this.CONFIG.title === "SpecialWires"){
          if(this.appService.cartProducts.results[i].product_id===item.id){
            this.appService.cartProducts.results[i].product.per_quantity_amount = item.pricing.raw.price
          }
        }
        this.cartData.push(this.appService.cartProducts.results[i].product_id);
      }

      if (this.CONFIG.name === "Deera" || this.CONFIG.title === "Babys Pride" || this.CONFIG.title==="LushNGreen" || this.CONFIG.name==="Beaubelle"|| this.CONFIG.title === "AvonSeals" || this.CONFIG.title === "Vistas" || this.CONFIG.title === "LinenRaj" || this.CONFIG.title === "SpecialWires") {
        let tempArray = this.appService.cartProducts.results;
        let obj =
          // {
          //     "domain_name": ORG_DETAILS.DOMAIN_NAME,
          //     "user_id": ORG_DETAILS.USER_ID,
          //     "extras": {
          //         "find": {
          //           "product_id": Number(this.appService.cartProducts.results[i].product_id),
          //           "product_cost": Number(this.appService.cartProducts.results[i].cost),
          //           "quantity": Number(this.appService.cartProducts.results[i].quantity)
          //         }
          //     }
          //   }

          {
            domain_name: ORG_DETAILS.DOMAIN_NAME,
            user_id: ORG_DETAILS.USER_ID,
            extras: {
              find: {
                product_id: Number(item.id),
                product_cost: Number(item.pricing.raw.cost),
                quantity: 1,
              },
            },
          };

        this.appService.postApiCall(obj, ENDPOINTS.QUANTITY_PROMOTION).subscribe(
          (resp) => {
            if (resp) {
              if (resp.success === 1 && resp.status_code === 200) {
                for (let j = 0; j < this.appService.cartProducts.results.length;j++) {
                  if (
                    this.appService.cartProducts.results[j].product_id === item.id
                  ) {
                    this.appService.cartProducts.results[
                      j
                    ].product.discount_value =
                      resp.result.data.discount_applied_to_product_value;
                      this.appService.cartProducts.results[j].product.per_quantity_amount = resp.result.data.per_quantity_amount;

                    this.appService.cartProducts.results[
                      j
                    ].product.discount_amount = resp.result.data.discount_amount;
                    this.appService.cartProducts.results[j].product.fixed_amount =
                      resp.result.data.fixed_amount;
                    this.appService.cartProducts.results[
                      j
                    ].product.discount_percentage =
                      resp.result.data.discount_percentage;
                    if (resp.result.data.discount_percentage > 0) {
                      this.appService.cartProducts.results[j]["fixed_amount"] =
                        resp.result.data.discount_amount;
                    } else {
                      this.appService.cartProducts.results[j]["fixed_amount"] =
                        resp.result.data.fixed_amount;
                    }
                    this.appService.cartProducts.results[j][
                      "discount_percentage"
                    ] = resp.result.data.discount_percentage;
                    console.log(
                      "this.appService.cartProducts.results[i].product.fixed_amount" +
                        this.appService.cartProducts.results[j].product
                          .fixed_amount
                    );
                    this.cartService.updateCartItem(
                      this.appService.cartProducts.results
                    );
                    console.log(
                      "this.appService.cartProducts.results[i].product.fixed_amount" +
                        this.appService.cartProducts.results[j].product
                          .fixed_amount
                    );
                  }
                }
                let cartItemsString = JSON.stringify(
                  this.appService.cartProducts.results
                );
                this.localService.set("cart", cartItemsString);
              } else if (resp.success === 0) {
                if (resp.message) {
                }
              } else if (resp.message && resp.status_code !== 200) {
              } else {
              }
            }
          },
          (err) => {
            if (err.error.statusCode === 403) {
            } else if (err.error.error.message) {
            } else {
            }
          }
        );
      }
    }
    // if(this.CONFIG.title === 'Deera') {
    //   this.getPromotionBanner(item);
    // }

    if(this.CONFIG.title === 'LinenRaj'){
      this.openbagForLinenRaja()



    }
  }

  async increaseItem(index) {
    await  this.getProfileDetails(this.localService.get('UserId')!=null?Number(this.localService.get('UserId')):'');
    console.log("daytaaaaaaaaaaaaaa")
    if(String(this.approved)!=='Approved'&&ORG_DETAILS.NAME === "Karupattiraja")
  {
    this.logout();
  }
  else{

    this.alertService.clear();
    let tempArray = this.appService.cartProducts.results;
    let cartQty = 0;

    let increment;
    tempArray.forEach((item) => {
      cartQty += item.quantity;
    });

    if (this.CONFIG.name === "ShubhCards") {
      tempArray[index].quantity =
        Number(tempArray[index].quantity) +
        tempArray[index].product.pricing.raw.incrementvalue;
    } else {
      if (Number(this.localService.get("max_cart_qty")) <= cartQty) {
        this.showAlerts = true;
        window.scrollTo(0, 0);

        if (this.CONFIG.name === "BombayHardware") {
          //this.alertService.error("Maximum allowed quantity is 10 only",this.options);
        this.alertService.error("Maximum allowed quantity is " +this.localService.get("max_cart_qty") +" only",this.options);
        } else if (this.CONFIG.name === "Deera" || this.CONFIG.title === "Babys Pride" || this.CONFIG.title==="LushNGreen" || this.CONFIG.name==="Beaubelle" || this.CONFIG.name==="BestGifts" || this.CONFIG.title === "AvonSeals" || this.CONFIG.title === "Vistas" || this.CONFIG.title === "LinenRaj" || this.CONFIG.title === "SpecialWires") {
          // tempArray[index].quantity = Number(this.localService.get("max_cart_qty")) - cartQty;
          this.alertService.error(
            "Maximum allowed quantity in the cart is " +
              this.localService.get("max_cart_qty") +
              " only",
            this.options
          );
        } else {
          this.alertService.error(
            "Maximum allowed quantity is " +
              this.localService.get("max_cart_qty") +
              " only",
            this.options
          );
        }
        return;
      }
      console.log("tempArray[index]tempArray[index]"+JSON.stringify(tempArray[index]))
      if(tempArray[index].product.pricing.raw.incrementvalue>0)
      {
        tempArray[index].quantity = (Number(tempArray[index].quantity) + Number(tempArray[index].product.pricing.raw.incrementvalue));
      } else {
        tempArray[index].quantity = (Number(tempArray[index].quantity) + 1);
      }
      
    }

    if (this.CONFIG.name === "Deera" || this.CONFIG.title === "Babys Pride" || this.CONFIG.title==="LushNGreen" || this.CONFIG.name==="Beaubelle" || this.CONFIG.title === "AvonSeals") {
      let userId = this.localService.get('UserId');
      let obj = {
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: ORG_DETAILS.USER_ID,
        extras: {
          find: {
            customer_id: Number(userId),
            product_id: Number(tempArray[index].product_id),
            product_cost: Number(tempArray[index].cost),
            quantity: Number(tempArray[index].quantity),
          },
        },
      };

      try {
        this.appService
          .postApiCall(obj, ENDPOINTS.QUANTITY_PROMOTION)
          .subscribe(
            (resp) => {
              if (resp) {
                if (resp.success === 1 && resp.status_code === 200) {
                  tempArray[index].product.discount_value =
                    resp.result.data.discount_applied_to_product_value;
                    tempArray[index].product.per_quantity_amount = resp.result.data.per_quantity_amount;
                  console.log("tempArray[index].product.per_quantity_amount"+tempArray[index].product.per_quantity_amount)
                  tempArray[index].product.discount_amount =
                    resp.result.data.discount_amount;
                  tempArray[index].product.fixed_amount =
                    resp.result.data.fixed_amount;
                  tempArray[index].product.discount_percentage =
                    resp.result.data.discount_percentage;
                    // this.percentageValue = Number(resp.result.data.discount_percentage);
                    // this.fixedAmount = Number(resp.result.data.fixed_amount);
                    // this.discountValue = Number(resp.result.data.discount_applied_to_product_value);
                    // this.promotionType = resp.result.data.promotion_type;
                    // this.productQuantity = Number(tempArray[index].quantity);
                    // this.productQuantity1 = true;
                  if (resp.result.data.discount_percentage > 0) {
                    this.appService.cartProducts.results[index][
                      "fixed_amount"
                    ] = resp.result.data.discount_amount;
                  } else {
                    this.appService.cartProducts.results[index][
                      "fixed_amount"
                    ] = resp.result.data.fixed_amount;
                  }
                  this.cartService.updateCartItem(
                    this.appService.cartProducts.results
                  );
                } else if (resp.success === 0) {
                  if (resp.message) {
                    //this.alertService.error(resp.message, this.options);
                  }
                } else if (resp.message && resp.status_code !== 200) {
                  //this.alertService.error(resp.message, this.options);
                } else {
                  //this.alertService.error('Something bad happened. Please try again!', this.options);
                }
              }
            },
            (err) => {
              if (err.error.statusCode === 403) {
                //this.alertService.error('Session Time Out! Please login Again', this.options)
              } else if (err.error.error.message) {
                //this.alertService.error(err.error.error.message, this.options)
              } else {
                //this.alertService.error('Something bad happened. Please try again!', this.options);
              }
            }
          );
      } catch (err) {
        console.log("ERROR IN ADDING ITEM: ", err);
      }
    }
    // if (ORG_DETAILS.NAME === "Vistas") {
    //   let userId = this.localService.get('UserId');

    //   let obj = {
    //     domain_name: ORG_DETAILS.DOMAIN_NAME,
    //     user_id: ORG_DETAILS.USER_ID,
    //     extras: {
    //       find: {
    //         customer_id: Number(userId),
    //         product_id: Number(tempArray[index].product_id),
    //         product_cost: Number(tempArray[index].cost),
    //         quantity: tempArray[index].quantity,
    //       },
    //     },
    //   };
    //   this.appService.postApiCall(obj, ENDPOINTS.STRUCTURED_PROMOTION).subscribe(
    //     (resp) => {
    //       if (resp) {
    //         if (resp.success === 1 && resp.status_code === 200) {
    //           for (let j = 0; j < this.appService.cartProducts.results.length;j++) {
    //             if (
    //               this.appService.cartProducts.results[j].product_id === tempArray[index].id
                  
    //             )
    //             console.log("resp.result.data.discount_summary[0].discount_amount",resp.result.data.discount_summary[0].discount_amount);
    //              {                      
    //                 this.appService.cartProducts.results[j]["discount_amount"] =
    //                   resp.result.data.discount_summary[0].discount_amount;
             
    //               this.appService.cartProducts.results[j][
    //                 "after_dicount_price"
    //               ] = resp.result.data.discount_summary[0].after_dicount_price;
    //               console.log(
    //                 "this.appService.cartProducts.results[i].product.fixed_amount" +
    //                 this.appService.cartProducts.results[j].
    //                   after_dicount_price
    //               );
    //               this.cartService.updateCartItem(
    //                 this.appService.cartProducts.results
    //               );
    //               console.log(
    //                 "this.appService.cartProducts.results[i].product.fixed_amount" +
    //                   this.appService.cartProducts.results[j].discount_amount
    //               );
    //             }
    //           }
    //           let cartItemsString = JSON.stringify(
    //             this.appService.cartProducts.results
    //           );
    //           this.localService.set("cart", cartItemsString);
    //         } else if (resp.success === 0) {
    //           if (resp.message) {
    //           }
    //         } else if (resp.message && resp.status_code !== 200) {
    //         } else {
    //         }
    //       }
    //     },
    //     (err) => {
    //       if (err.error.statusCode === 403) {
    //       } else if (err.error.error.message) {
    //       } else {
    //       }
    //     }
    //   );
    //   }
    //tempArray[index].quantity = (Number(tempArray[index].quantity) + 2)
    tempArray[index].sub_total =
      Number(tempArray[index].quantity) * Number(tempArray[index].cost);
    this.appService.cartProducts.results = tempArray;
    this.appService.totalCartItems = this.cartService.totalCartItems();
    this.cartService.updateCartItem(this.appService.cartProducts.results);
    if (this.CONFIG.name === "Deera" || this.CONFIG.title === "Babys Pride" || this.CONFIG.title==="LushNGreen" || this.CONFIG.name==="Beaubelle" || this.CONFIG.title === "AvonSeals" || this.CONFIG.title === "Vistas" || this.CONFIG.title === "LinenRaj") {
      let cartItemsString = JSON.stringify(
        this.appService.cartProducts.results
      );
      this.localService.set("cart", cartItemsString);
    }


  }
   
  }

  increaseItemNew(index) {
    this.alertService.clear();
    let userId = this.localService.get('UserId');
    let tempArray = this.appService.cartProducts.results;
    let cartQty = 0;
console.log("4554444", tempArray[index].product.shipping.weight_to_consider);
    let increment;
    tempArray.forEach((item) => {
      cartQty += item.quantity;
    });

    if (this.CONFIG.name === "ShubhCards") {
      tempArray[index].quantity =
        Number(tempArray[index].quantity) +
        tempArray[index].product.pricing.raw.incrementvalue;
    } else {
      if (Number(this.localService.get("max_cart_qty")) <= cartQty) {
        this.showAlerts = true;
        window.scrollTo(0, 0);

        if (this.CONFIG.name === "BombayHardware") {
          //this.alertService.error("Maximum allowed quantity is 10 only",this.options);
        this.alertService.error("Maximum allowed quantity is " +this.localService.get("max_cart_qty") +" only",this.options);
        } else if (this.CONFIG.name === "Deera" || this.CONFIG.title === "Babys Pride" || this.CONFIG.title==="LushNGreen" || this.CONFIG.name==="Beaubelle" || this.CONFIG.name==="BestGifts" || this.CONFIG.title === "AvonSeals" || this.CONFIG.title === "Vistas" || this.CONFIG.title === "LinenRaj" || this.CONFIG.title === "SpecialWires") {
          // tempArray[index].quantity = Number(this.localService.get("max_cart_qty")) - cartQty;
          this.alertService.error(
            "Maximum allowed quantity in the cart is " +
              this.localService.get("max_cart_qty") +
              " only",
            this.options
          );
        } else {
          this.alertService.error(
            "Maximum allowed quantity is " +
              this.localService.get("max_cart_qty") +
              " only",
            this.options
          );
        }
        return;
      }
      if (this.CONFIG.name !== "SpecialWires") {
      tempArray[index].quantity = (Number(tempArray[index].quantity) + 1);
      }
      if (this.CONFIG.name === "SpecialWires") {
        tempArray[index].quantity = (Number(tempArray[index].quantity) + Number(tempArray[index].product.pricing.raw.incrementvalue));
        }
    }
    console.log("55553333333", tempArray[index].product.shipping.weight_to_consider);
    if (this.CONFIG.name === "SpecialWires" || this.CONFIG.name === "Vistas") {
      let obj = {
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: ORG_DETAILS.USER_ID,
        extras: {
          find: {
            product_id: Number(tempArray[index].product_id),
            product_cost: Number(tempArray[index].cost),
            quantity: Number(tempArray[index].quantity),
            customer_id: Number(userId),
            weight: Number(tempArray[index].product.shipping.weight_to_consider) * Number(tempArray[index].quantity),
            weight_to_consider:true
          },
        },
      };

      try {
        this.appService
          .postApiCall(obj, ENDPOINTS.STRUCTURED_PROMOTION)
          .subscribe(
            (resp) => {
              if (resp) {
                if (resp.success === 1 && resp.status_code === 200) {
                  for (let j = 0; j < this.appService.cartProducts.results.length;j++) {
                    if (
                      this.appService.cartProducts.results[j].product_id === tempArray[index].id
                      
                    )
                    console.log("resp.result.data.discount_summary[0].discount_amount",resp.result.data.discount_summary[0].discount_amount);
                     {                      
                        this.appService.cartProducts.results[j]["discount_amount"] =
                          resp.result.data.discount_summary[0].discount_amount;
                 
                      this.appService.cartProducts.results[j][
                        "after_dicount_price"
                      ] = resp.result.data.discount_summary[0].after_dicount_price;
                      console.log(
                        "this.appService.cartProducts.results[i].product.fixed_amount" +
                        this.appService.cartProducts.results[j].
                          after_dicount_price
                      );
                      this.cartService.updateCartItem(
                        this.appService.cartProducts.results
                      );
                      console.log(
                        "this.appService.cartProducts.results[i].product.fixed_amount" +
                          this.appService.cartProducts.results[j].discount_amount
                      );
                    }
                  }
                  this.cartService.updateCartItem(
                    this.appService.cartProducts.results
                  );
    
                  console.log(
                    "tempArray[index].product.discount_value" +
                      tempArray[index].product.discount_value
                  );
                } else if (resp.success === 0) {
                  if (resp.message) {
                    //this.alertService.error(resp.message, this.options);
                  }
                } else if (resp.message && resp.status_code !== 200) {
                  //this.alertService.error(resp.message, this.options);
                } else {
                  //this.alertService.error('Something bad happened. Please try again!', this.options);
                }
              }
            },
            (err) => {
              if (err.error.statusCode === 403) {
                //this.alertService.error('Session Time Out! Please login Again', this.options)
              } else if (err.error.error.message) {
                //this.alertService.error(err.error.error.message, this.options)
              } else {
                //this.alertService.error('Something bad happened. Please try again!', this.options);
              }
            }
          );
      } catch (err) {
        console.log("ERROR IN ADDING ITEM: ", err);
      }
    }

    //tempArray[index].quantity = (Number(tempArray[index].quantity) + 2)
    tempArray[index].sub_total =
      Number(tempArray[index].quantity) * Number(tempArray[index].cost);
    this.appService.cartProducts.results = tempArray;
    this.appService.totalCartItems = this.cartService.totalCartItems();
    this.cartService.updateCartItem(this.appService.cartProducts.results);
    if (this.CONFIG.title === "SpecialWires" || this.CONFIG.title === "Vistas") {
      let cartItemsString = JSON.stringify(
        this.appService.cartProducts.results
      );
      this.localService.set("cart", cartItemsString);
    }
  }
  loadExistingCart()
  {
    this.existingCartProduts= [];
    this.appService.cartProducts.results.forEach(value=>
      {
        this.existingCartProduts.push(value.product_id);
      })
  }
  ChangeValue(index) {
    this.alertService.clear();
    let tempArray = this.appService.cartProducts.results;
    var moq = tempArray[index].product.pricing.raw.minimumorderquantity;
    if (this.CONFIG.name === "ShubhCards") {
      //let tempArray = this.appService.cartProducts.results;
      if (
        this.appService.cartProducts.results[index].quantity <
        tempArray[index].product.pricing.raw.minimumorderquantity
      ) {
        this.appService.cartProducts.results.splice(index, 1);
        this.cartData = [];
        for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
          this.cartData.push(
            this.appService.cartProducts.results[i].product_id
          );
        }
        this.appService.totalCartItems = this.cartService.totalCartItems();
        this.cartService.updateCartItem(this.appService.cartProducts.results);
        this.showAlerts = true;

        this.alertService.error(
          "Minimum Order Quantity for this product is " + moq,
          this.options
        );
        return;
      }
      tempArray[index].quantity = Number(tempArray[index].quantity);
      tempArray[index].sub_total =
        Number(tempArray[index].quantity) * Number(tempArray[index].cost);
      this.appService.cartProducts.results = tempArray;
      this.appService.totalCartItems = this.cartService.totalCartItems();
      this.cartService.updateCartItem(this.appService.cartProducts.results);
    }
  }

  changeDeeraVarValue(index, event) {
    this.alertService.clear();
  let tempArray = this.appService.cartProducts.results;
  let cartQty = 0;
  let tempCartQty: number = 0;
  tempArray.forEach((item) => {
    cartQty += item.quantity;
    let count = 0;
    if(item != tempArray[index]) {
      tempCartQty += item.quantity
    }
  });
  if (Number(this.localService.get("max_cart_qty")) < cartQty) {
    this.showAlerts = true;
    window.scrollTo(0, 0);
  if (this.CONFIG.title === "Deera" || this.CONFIG.title === "Babys Pride") {
    this.appService.cartProducts.results[index].quantity = Number(this.localService.get("max_cart_qty")) - tempCartQty;
    event.srcElement.value = String(Number(this.localService.get("max_cart_qty")) - tempCartQty)
    event.srcElement.blur()
    this.alertService.error(
      "Maximum allowed quantity in the cart is " +
        this.localService.get("max_cart_qty") +
        " only",
      this.options
    );
  } else {
    this.alertService.error(
      "Maximum allowed quantity is " +
        this.localService.get("max_cart_qty") +
        " only",
      this.options
    );
  }
  return;
}
  //tempArray[index].quantity = (Number(tempArray[index].quantity) + 1)
  // let tempArray = this.appService.cartProducts.results;
  if (
    this.appService.cartProducts.results[index].quantity <
    tempArray[index].product.pricing.raw.minimumorderquantity
  ) {
    this.appService.cartProducts.results.splice(index, 1);
    this.cartData = [];
    for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
      this.cartData.push(this.appService.cartProducts.results[i].product_id);
    }
    this.appService.totalCartItems = this.cartService.totalCartItems();
    this.cartService.updateCartItem(this.appService.cartProducts.results);
    if (this.CONFIG.name === "Deera" || this.CONFIG.title === "Babys Pride") {
      let cartItemsString = JSON.stringify(
        this.appService.cartProducts.results
      );
      this.localService.set("cart", cartItemsString);
    }
    return;
  }

  // tempArray[index].quantity = (Number(tempArray[index].quantity) - 1)
  tempArray[index].sub_total =
    Number(tempArray[index].quantity) * Number(tempArray[index].cost);
  if (this.CONFIG.name === "Deera") {
    //let tempArray = this.appService.cartProducts.results;
    let obj = {
      domain_name: ORG_DETAILS.DOMAIN_NAME,
      user_id: ORG_DETAILS.USER_ID,
      extras: {
        find: {
          product_id: Number(tempArray[index].product_id),
          product_cost: Number(tempArray[index].cost),
          quantity: Number(tempArray[index].quantity),
        },
      },
    };

    this.appService.postApiCall(obj, ENDPOINTS.QUANTITY_PROMOTION).subscribe(
      (resp) => {
        if (resp) {
          if (resp.success === 1 && resp.status_code === 200) {
            console.log(
              "tempArray[index].quantity" + tempArray[index].product.id
            );
            console.log(
              "tempArray[index].quantity" + tempArray[index].product.id
            );
            console.log(
              "resp.result.data.discount_applied_to_product_value" +
                resp.result.data.discount_applied_to_product_value
            );
            tempArray[index].product.discount_value =
              resp.result.data.discount_applied_to_product_value;
              tempArray[index].product.per_quantity_amount = resp.result.data.per_quantity_amount;
            tempArray[index].product.discount_amount =
              resp.result.data.discount_amount;
            tempArray[index].product.fixed_amount =
              resp.result.data.fixed_amount;
            tempArray[index].product.discount_percentage =
              resp.result.data.discount_percentage;
              // this.percentageValue = Number(
              //   resp.result.data.discount_percentage
              // );
              // this.fixedAmount = Number(resp.result.data.fixed_amount);
              // this.discountValue = Number(
              //   resp.result.data.discount_applied_to_product_value
              // );
              // this.promotionType = resp.result.data.promotion_type;
              // this.productQuantity = Number(tempArray[index].quantity);
              // console.log(
              //   "Number(tempArray[index].quantity)" +
              //     Number(tempArray[index].quantity)
              // );
              // console.log("productQuantity" + this.productQuantity);
              // this.productQuantity1 = true;
            if (resp.result.data.discount_percentage > 0) {
              this.appService.cartProducts.results[index]["fixed_amount"] =
                resp.result.data.discount_amount;
            } else {
              this.appService.cartProducts.results[index]["fixed_amount"] =
                resp.result.data.fixed_amount;
            }
            this.cartService.updateCartItem(
              this.appService.cartProducts.results
            );

            console.log(
              "tempArray[index].product.discount_value" +
                tempArray[index].product.discount_value
            );
          } else if (resp.success === 0) {
            if (resp.message) {
              //this.alertService.error(resp.message, this.options);
            }
          } else if (resp.message && resp.status_code !== 200) {
            //this.alertService.error(resp.message, this.options);
          } else {
            //this.alertService.error('Something bad happened. Please try again!', this.options);
          }
        }
      },
      (err) => {
        if (err.error.statusCode === 403) {
          //this.alertService.error('Session Time Out! Please login Again', this.options)
        } else if (err.error.error.message) {
          //this.alertService.error(err.error.error.message, this.options)
        } else {
          //this.alertService.error('Something bad happened. Please try again!', this.options);
        }
      }
    );

    // tempArray[index].quantity = (Number(tempArray[index].quantity));
    // tempArray[index].sub_total = (Number(tempArray[index].quantity) * Number(tempArray[index].cost))
    // this.appService.cartProducts.results = tempArray;
    // this.appService.totalCartItems = this.cartService.totalCartItems();
    // this.cartService.updateCartItem(this.appService.cartProducts.results);
    // tempArray[index].quantity = (Number(tempArray[index].quantity));
    tempArray[index].sub_total =
      Number(tempArray[index].quantity) * Number(tempArray[index].cost);
    this.appService.cartProducts.results = tempArray;
    this.appService.totalCartItems = this.cartService.totalCartItems();
    this.cartService.updateCartItem(this.appService.cartProducts.results);
    if (this.CONFIG.name === "Deera" || this.CONFIG.title === "Babys Pride") {
      let cartItemsString = JSON.stringify(
        this.appService.cartProducts.results
      );
      this.localService.set("cart", cartItemsString);
    }
  }
}
changeBabyVarValue(index, event) {
  this.alertService.clear();
let tempArray = this.appService.cartProducts.results;
let cartQty = 0;
let tempCartQty: number = 0;
tempArray.forEach((item) => {
  cartQty += item.quantity;
  let count = 0;
  if(item != tempArray[index]) {
    tempCartQty += item.quantity
  }
});
if (Number(this.localService.get("max_cart_qty")) < cartQty) {
  this.showAlerts = true;
  window.scrollTo(0, 0);
if (this.CONFIG.title === "Babys Pride") {
  this.appService.cartProducts.results[index].quantity = Number(this.localService.get("max_cart_qty")) - tempCartQty;
  event.srcElement.value = String(Number(this.localService.get("max_cart_qty")) - tempCartQty)
  event.srcElement.blur()
  this.alertService.error(
    "Maximum allowed quantity in the cart is " +
      this.localService.get("max_cart_qty") +
      " only",
    this.options
  );
} else {
  this.alertService.error(
    "Maximum allowed quantity is " +
      this.localService.get("max_cart_qty") +
      " only",
    this.options
  );
}
return;
}
//tempArray[index].quantity = (Number(tempArray[index].quantity) + 1)
// let tempArray = this.appService.cartProducts.results;
if (
  this.appService.cartProducts.results[index].quantity < 1) {
  this.appService.cartProducts.results.splice(index, 1);
  this.cartData = [];
  for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
    this.cartData.push(this.appService.cartProducts.results[i].product_id);
  }
  this.appService.totalCartItems = this.cartService.totalCartItems();
  this.cartService.updateCartItem(this.appService.cartProducts.results);
  if (this.CONFIG.title === "Babys Pride") {
    let cartItemsString = JSON.stringify(
      this.appService.cartProducts.results
    );
    this.localService.set("cart", cartItemsString);
  }
  return;
}

// tempArray[index].quantity = (Number(tempArray[index].quantity) - 1)
tempArray[index].sub_total =
  Number(tempArray[index].quantity) * Number(tempArray[index].cost);
}
  changeDeeraValue(index, productId: string, event) {
    this.alertService.clear();
    let tempArray = this.appService.cartProducts.results;
    let cartQty = 0;
    let tempCartQty: number = 0;
    tempArray.forEach((item) => {
      cartQty += item.quantity;

      if(item.product.id != productId) {
        tempCartQty += item.quantity
      }
    });
    if (Number(this.localService.get("max_cart_qty")) < cartQty) {
      this.showAlerts = true;
      window.scrollTo(0, 0);

      if (this.CONFIG.name === "BombayHardware") {
        //this.alertService.error("Maximum allowed quantity is 10 only",this.options);
        this.alertService.error("Maximum allowed quantity is " +this.localService.get("max_cart_qty") +" only",this.options);
      } else if (this.CONFIG.name === "Deera" || this.CONFIG.title === "Babys Pride" || this.CONFIG.name==="Beaubelle" || this.CONFIG.title === "AvonSeals" || this.CONFIG.title === "Vistas" || this.CONFIG.title === "SpecialWires") {
        this.appService.cartProducts.results[index].quantity = Number(this.localService.get("max_cart_qty")) - tempCartQty;
        event.srcElement.value = String(Number(this.localService.get("max_cart_qty")) - tempCartQty)
        event.srcElement.blur()
        this.alertService.error(
          "Maximum allowed quantity in the cart is " +
            this.localService.get("max_cart_qty") +
            " only",
          this.options
        );
      } else {
        this.alertService.error(
          "Maximum allowed quantity is " +
            this.localService.get("max_cart_qty") +
            " only",
          this.options
        );
      }
      return;
    }
    //tempArray[index].quantity = (Number(tempArray[index].quantity) + 1)
    // let tempArray = this.appService.cartProducts.results;
    if (
      this.appService.cartProducts.results[index].quantity <
      tempArray[index].product.pricing.raw.minimumorderquantity
    ) {
      this.appService.cartProducts.results.splice(index, 1);
      this.cartData = [];
      for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
        this.cartData.push(this.appService.cartProducts.results[i].product_id);
      }
      this.appService.totalCartItems = this.cartService.totalCartItems();
      this.cartService.updateCartItem(this.appService.cartProducts.results);
      if (this.CONFIG.name === "Deera" || this.CONFIG.title === "Babys Pride" || this.CONFIG.name==="Beaubelle" || this.CONFIG.title === "AvonSeals" || this.CONFIG.title === "Vistas" || this.CONFIG.title === "SpecialWires" || this.CONFIG.name==="LinenRaj") {
        let cartItemsString = JSON.stringify(
          this.appService.cartProducts.results
        );
        this.localService.set("cart", cartItemsString);
      }
      return;
    }

    // tempArray[index].quantity = (Number(tempArray[index].quantity) - 1)
    tempArray[index].sub_total =
      Number(tempArray[index].quantity) * Number(tempArray[index].cost);
    if (this.CONFIG.name === "Deera" || this.CONFIG.title === "Babys Pride" || this.CONFIG.name==="Beaubelle" || this.CONFIG.title === "AvonSeals" || this.CONFIG.title === "Vistas" || this.CONFIG.title === "SpecialWires") {
      //let tempArray = this.appService.cartProducts.results;
      let obj = {
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: ORG_DETAILS.USER_ID,
        extras: {
          find: {
            product_id: Number(tempArray[index].product_id),
            product_cost: Number(tempArray[index].cost),
            quantity: Number(tempArray[index].quantity),
          },
        },
      };

      this.appService.postApiCall(obj, ENDPOINTS.QUANTITY_PROMOTION).subscribe(
        (resp) => {
          if (resp) {
            if (resp.success === 1 && resp.status_code === 200) {
              console.log(
                "tempArray[index].quantity" + tempArray[index].product.id
              );
              console.log(
                "tempArray[index].quantity" + tempArray[index].product.id
              );
              console.log(
                "resp.result.data.discount_applied_to_product_value" +
                  resp.result.data.discount_applied_to_product_value
              );
              tempArray[index].product.discount_value =
                resp.result.data.discount_applied_to_product_value;
                tempArray[index].product.per_quantity_amount = resp.result.data.per_quantity_amount;
              tempArray[index].product.discount_amount =
                resp.result.data.discount_amount;
              tempArray[index].product.fixed_amount =
                resp.result.data.fixed_amount;
              tempArray[index].product.discount_percentage =
                resp.result.data.discount_percentage;
                // this.percentageValue = Number(
                //   resp.result.data.discount_percentage
                // );
                // this.fixedAmount = Number(resp.result.data.fixed_amount);
                // this.discountValue = Number(
                //   resp.result.data.discount_applied_to_product_value
                // );
                // this.promotionType = resp.result.data.promotion_type;
                // this.productQuantity = Number(tempArray[index].quantity);
                // console.log(
                //   "Number(tempArray[index].quantity)" +
                //     Number(tempArray[index].quantity)
                // );
                // console.log("productQuantity" + this.productQuantity);
                // this.productQuantity1 = true;
              if (resp.result.data.discount_percentage > 0) {
                this.appService.cartProducts.results[index]["fixed_amount"] =
                  resp.result.data.discount_amount;
              } else {
                this.appService.cartProducts.results[index]["fixed_amount"] =
                  resp.result.data.fixed_amount;
              }
              this.cartService.updateCartItem(
                this.appService.cartProducts.results
              );

              console.log(
                "tempArray[index].product.discount_value" +
                  tempArray[index].product.discount_value
              );
            } else if (resp.success === 0) {
              if (resp.message) {
                //this.alertService.error(resp.message, this.options);
              }
            } else if (resp.message && resp.status_code !== 200) {
              //this.alertService.error(resp.message, this.options);
            } else {
              //this.alertService.error('Something bad happened. Please try again!', this.options);
            }
          }
        },
        (err) => {
          if (err.error.statusCode === 403) {
            //this.alertService.error('Session Time Out! Please login Again', this.options)
          } else if (err.error.error.message) {
            //this.alertService.error(err.error.error.message, this.options)
          } else {
            //this.alertService.error('Something bad happened. Please try again!', this.options);
          }
        }
      );

      // tempArray[index].quantity = (Number(tempArray[index].quantity));
      // tempArray[index].sub_total = (Number(tempArray[index].quantity) * Number(tempArray[index].cost))
      // this.appService.cartProducts.results = tempArray;
      // this.appService.totalCartItems = this.cartService.totalCartItems();
      // this.cartService.updateCartItem(this.appService.cartProducts.results);
      // tempArray[index].quantity = (Number(tempArray[index].quantity));
      tempArray[index].sub_total =
        Number(tempArray[index].quantity) * Number(tempArray[index].cost);
      this.appService.cartProducts.results = tempArray;
      this.appService.totalCartItems = this.cartService.totalCartItems();
      this.cartService.updateCartItem(this.appService.cartProducts.results);
      if (this.CONFIG.name === "Deera" || this.CONFIG.title === "Babys Pride" || this.CONFIG.name==="Beaubelle" || this.CONFIG.title === "AvonSeals" || this.CONFIG.title === "Vistas" || this.CONFIG.title === "SpecialWires" || this.CONFIG.title === "LinenRaj") {
        let cartItemsString = JSON.stringify(
          this.appService.cartProducts.results
        );
        this.localService.set("cart", cartItemsString);
      }
    }
  }
  
  decreaseItem(index) {
    console.log("dataaaaaa")
    let tempArray = this.appService.cartProducts.results;
    if (this.CONFIG.name === "ShubhCards") {
      //let tempArray = this.appService.cartProducts.results;
      if (
        this.appService.cartProducts.results[index].quantity -
          tempArray[index].product.pricing.raw.decrementvalue <
        tempArray[index].product.pricing.raw.minimumorderquantity
      ) {
        this.appService.cartProducts.results.splice(index, 1);
        this.cartData = [];
        for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
          this.cartData.push(
            this.appService.cartProducts.results[i].product_id
          );
        }
        this.appService.totalCartItems = this.cartService.totalCartItems();
        this.cartService.updateCartItem(this.appService.cartProducts.results);
        this.showAlerts = true;
        return;
      }

      tempArray[index].quantity =
        Number(tempArray[index].quantity) -
        tempArray[index].product.pricing.raw.decrementvalue;
      tempArray[index].sub_total =
        Number(tempArray[index].quantity) * Number(tempArray[index].cost);
      this.appService.cartProducts.results = tempArray;
      this.appService.totalCartItems = this.cartService.totalCartItems();
      this.cartService.updateCartItem(this.appService.cartProducts.results);
    } 
    else {
      if( this.CONFIG.title === "Babys Pride"){
        if (
          this.appService.cartProducts.results[index].quantity -
            tempArray[index].product.pricing.raw.decrementvalue <=
          tempArray[index].product.pricing.raw.minimumorderquantity
        ) {
          console.log("testdec")
          this.appService.cartProducts.results.splice(index, 1);
          this.cartData = [];
          for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
            this.cartData.push(
              this.appService.cartProducts.results[i].product_id
            );
          }
          this.appService.totalCartItems = this.cartService.totalCartItems();
          this.cartService.updateCartItem(this.appService.cartProducts.results);
          this.showAlerts = true;
          return;
        }
        tempArray[index].quantity =
        Number(tempArray[index].quantity) -
        tempArray[index].product.pricing.raw.decrementvalue;
      tempArray[index].sub_total =
        Number(tempArray[index].quantity) * Number(tempArray[index].cost);
      this.appService.cartProducts.results = tempArray;
      this.appService.totalCartItems = this.cartService.totalCartItems();
      this.cartService.updateCartItem(this.appService.cartProducts.results);
      }
      if (
        this.appService.cartProducts.results[index].quantity === 1 ||
        this.appService.cartProducts.results[index].quantity <
          tempArray[index].product.pricing.raw.minimumorderquantity
      ) {
        this.appService.cartProducts.results.splice(index, 1);
        this.cartData = [];
        if (this.CONFIG.title === "AvonSeals" || this.CONFIG.title === "Vistas" || this.CONFIG.title === "LinenRaj" || this.CONFIG.title === "SpecialWires") {
          // this.appService.cartProducts.results[index].quantity = 0;
          // this.appService.cartProducts.results[index].discount_value = 0;
          // this.appService.cartProducts.results[index].discount_percentage = 0;
          // this.appService.cartProducts.results[index].discount_amount = 0;
          // this.appService.cartProducts.results[index].fixed_amount = 0;
          // this.upsellBanner = "";
          // this.percentageValue = 0;
          // this.fixedAmount = 0;
          // this.discountValue = 0;
          // this.promotionType = 0;
          // this.productQuantity = 0;
        }
        for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
          this.cartData.push(
            this.appService.cartProducts.results[i].product_id
          );
        }
        this.appService.totalCartItems = this.cartService.totalCartItems();
        this.cartService.updateCartItem(this.appService.cartProducts.results);
        if (this.CONFIG.name === "Deera" || this.CONFIG.title === "Babys Pride" || this.CONFIG.name==="Beaubelle" || this.CONFIG.title === "AvonSeals" || this.CONFIG.title === "Vistas" || this.CONFIG.title === "LinenRaj" || this.CONFIG.title === "SpecialWires") {
          let cartItemsString = JSON.stringify(
            this.appService.cartProducts.results
          );
          this.localService.set("cart", cartItemsString);
        }
        return;
      }
     
       tempArray[index].quantity = Number(tempArray[index].quantity) - 1;
      tempArray[index].sub_total =
        Number(tempArray[index].quantity) * Number(tempArray[index].cost);
      
      if (this.CONFIG.name === "Deera" || this.CONFIG.title === "Babys Pride" || this.CONFIG.name==="Beaubelle" || this.CONFIG.title === "AvonSeals" || this.CONFIG.title === "SpecialWires") {
        let obj = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: ORG_DETAILS.USER_ID,
          extras: {
            find: {
              product_id: Number(tempArray[index].product_id),
              product_cost: Number(tempArray[index].cost),
              quantity: Number(tempArray[index].quantity),
            },
          },
        };

        this.appService
          .postApiCall(obj, ENDPOINTS.QUANTITY_PROMOTION)
          .subscribe(
            (resp) => {
              if (resp) {
                if (resp.success === 1 && resp.status_code === 200) {
                  console.log(
                    "tempArray[index].quantity" + tempArray[index].product.id
                  );
                  tempArray[index].product.discount_value = 
                    resp.result.data.discount_applied_to_product_value;
                    console.log(
                      "tempArray[index].product.discount_value" +
                      tempArray[index].product.discount_value
                    );
                  tempArray[index].product.per_quantity_amount = resp.result.data.per_quantity_amount;
                  tempArray[index].product.discount_amount =
                  resp.result.data.discount_amount;
                  tempArray[index].product.fixed_amount =
                  resp.result.data.fixed_amount;
                  tempArray[index].product.discount_percentage =
                  resp.result.data.discount_percentage;
                    // this.percentageValue = Number(
                    //   resp.result.data.discount_percentage
                    // );
                    // this.fixedAmount = Number(resp.result.data.fixed_amount);
                    // this.discountValue = Number(
                    //   resp.result.data.discount_applied_to_product_value
                    // );
                    // this.promotionType = resp.result.data.promotion_type;
                    // this.productQuantity = Number(tempArray[index].quantity);
                    // console.log(
                    //   "Number(tempArray[index].quantity)" +
                    //     Number(tempArray[index].quantity)
                    // );
                    // console.log("productQuantity" + this.productQuantity);
                    // this.productQuantity1 = true;
                  this.cartService.updateCartItem(
                    this.appService.cartProducts.results
                  );
                  console.log(
                    "tempArray[index].product.discount_value" +
                      tempArray[index].product.discount_value
                  );
                } else if (resp.success === 0) {
                  if (resp.message) {
                    //this.alertService.error(resp.message, this.options);
                  }
                } else if (resp.message && resp.status_code !== 200) {
                  //this.alertService.error(resp.message, this.options);
                } else {
                  //this.alertService.error('Something bad happened. Please try again!', this.options);
                }
              }
            },
            (err) => {
              if (err.error.statusCode === 403) {
                //this.alertService.error('Session Time Out! Please login Again', this.options)
              } else if (err.error.error.message) {
                //this.alertService.error(err.error.error.message, this.options)
              } else {
                //this.alertService.error('Something bad happened. Please try again!', this.options);
              }
            }
          );
      }
      if (ORG_DETAILS.NAME === "Vistas") {
        let userId = this.localService.get('UserId');
  
        let obj = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: ORG_DETAILS.USER_ID,
          extras: {
            find: {
              customer_id: Number(userId),
              product_id: Number(tempArray[index].product_id),
              product_cost: Number(tempArray[index].cost),
              quantity: tempArray[index].quantity,
              weight: Number(tempArray[index].product.shipping.weight_to_consider) * Number(tempArray[index].quantity),
            weight_to_consider:true
            },
          },
        };
        this.appService.postApiCall(obj, ENDPOINTS.STRUCTURED_PROMOTION).subscribe(
          (resp) => {
            if (resp) {
              if (resp.success === 1 && resp.status_code === 200) {
                for (let j = 0; j < this.appService.cartProducts.results.length;j++) {
                  if (
                    this.appService.cartProducts.results[j].product_id === tempArray[index].id
                    
                  )
                  console.log("resp.result.data.discount_summary[0].discount_amount",resp.result.data.discount_summary[0].discount_amount);
                   {                      
                      this.appService.cartProducts.results[j]["discount_amount"] =
                        resp.result.data.discount_summary[0].discount_amount;
               
                    this.appService.cartProducts.results[j][
                      "after_dicount_price"
                    ] = resp.result.data.discount_summary[0].after_dicount_price;
                    console.log(
                      "this.appService.cartProducts.results[i].product.fixed_amount" +
                      this.appService.cartProducts.results[j].
                        after_dicount_price
                    );
                    this.cartService.updateCartItem(
                      this.appService.cartProducts.results
                    );
                    console.log(
                      "this.appService.cartProducts.results[i].product.fixed_amount" +
                        this.appService.cartProducts.results[j].discount_amount
                    );
                  }
                }
                let cartItemsString = JSON.stringify(
                  this.appService.cartProducts.results
                );
                this.localService.set("cart", cartItemsString);
              } else if (resp.success === 0) {
                if (resp.message) {
                }
              } else if (resp.message && resp.status_code !== 200) {
              } else {
              }
            }
          },
          (err) => {
            if (err.error.statusCode === 403) {
            } else if (err.error.error.message) {
            } else {
            }
          }
        );
        }
      this.appService.cartProducts.results = tempArray;
      this.appService.totalCartItems = this.cartService.totalCartItems();
      this.cartService.updateCartItem(this.appService.cartProducts.results);
      if (this.CONFIG.name === "Deera" || this.CONFIG.title === "Babys Pride" || this.CONFIG.name==="Beaubelle" || this.CONFIG.title === "AvonSeals" || this.CONFIG.title === "Vistas" || this.CONFIG.title === "SpecialWires" || this.CONFIG.title === "LinenRaj") {
        let cartItemsString = JSON.stringify(
          this.appService.cartProducts.results
        );
        this.localService.set("cart", cartItemsString);
      }
    }
  }

  decreaseItemNew(index) {
    console.log("dataaaaaa")
    let userId = this.localService.get('UserId');
    let tempArray = this.appService.cartProducts.results;
    if (this.CONFIG.name === "ShubhCards") {
      //let tempArray = this.appService.cartProducts.results;
      if (
        this.appService.cartProducts.results[index].quantity -
          tempArray[index].product.pricing.raw.decrementvalue <
        tempArray[index].product.pricing.raw.minimumorderquantity
      ) {
        this.appService.cartProducts.results.splice(index, 1);
        this.cartData = [];
        for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
          this.cartData.push(
            this.appService.cartProducts.results[i].product_id
          );
        }
        this.appService.totalCartItems = this.cartService.totalCartItems();
        this.cartService.updateCartItem(this.appService.cartProducts.results);
        this.showAlerts = true;
        return;
      }

      tempArray[index].quantity =
        Number(tempArray[index].quantity) -
        tempArray[index].product.pricing.raw.decrementvalue;
      tempArray[index].sub_total =
        Number(tempArray[index].quantity) * Number(tempArray[index].cost);
      this.appService.cartProducts.results = tempArray;
      this.appService.totalCartItems = this.cartService.totalCartItems();
      this.cartService.updateCartItem(this.appService.cartProducts.results);
    } else {
      if(this.CONFIG.name!="SpecialWires"){
      if (
        this.appService.cartProducts.results[index].quantity === 1 ||
        this.appService.cartProducts.results[index].quantity <
          tempArray[index].product.pricing.raw.minimumorderquantity
      ) {
        this.appService.cartProducts.results.splice(index, 1);
        this.cartData = [];
   
        for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
          this.cartData.push(
            this.appService.cartProducts.results[i].product_id
          );
        }
        this.appService.totalCartItems = this.cartService.totalCartItems();
        this.cartService.updateCartItem(this.appService.cartProducts.results);
        if (this.CONFIG.name === "Deera" || this.CONFIG.title === "Babys Pride" || this.CONFIG.name==="Beaubelle" || this.CONFIG.title === "AvonSeals" || this.CONFIG.title === "Vistas" || this.CONFIG.title === "LinenRaj" || this.CONFIG.title === "SpecialWires") {
          let cartItemsString = JSON.stringify(
            this.appService.cartProducts.results
          );
          this.localService.set("cart", cartItemsString);
        }
        return;
      }
    }
      if(this.CONFIG.name="SpecialWires"){
      let tempArray = this.appService.cartProducts.results;
if(tempArray[index].quantity<=tempArray[index].product.pricing.raw.minimumorderquantity)
{
  tempArray[index].quantity =Number(tempArray[index].quantity)-tempArray[index].product.pricing.raw.minimumorderquantity;
}
else {
  if(tempArray[index].product.pricing.raw.decrementvalue>0)
  {
    console.log("trueeeeeee")
    tempArray[index].quantity = Number(tempArray[index].quantity) - Number(tempArray[index].product.pricing.raw.decrementvalue);
  } 
  // else {
  //   tempArray[index].quantity = Number(tempArray[index].quantity) - 1;
  // }
  // tempArray[index].quantity=Number(tempArray[index].quantity)-1;
}
if(tempArray[index].quantity<=0)
{
  this.appService.cartProducts.results.splice(index, 1);
}
}
  this.appService.totalCartItems = this.cartService.totalCartItems();
  this.cartService.updateCartItem(this.appService.cartProducts.results);


  if (this.CONFIG.title !== "SpecialWires" ){
    tempArray[index].quantity = Number(tempArray[index].quantity) - 1;
  }
  // if (this.CONFIG.title === "SpecialWires" ){
  //     tempArray[index].quantity = Number(tempArray[index].quantity) - tempArray[index].product.pricing.raw.decrementvalue;
  // }
      tempArray[index].sub_total =
        Number(tempArray[index].quantity) * Number(tempArray[index].cost);
      if (this.CONFIG.title === "SpecialWires" || this.CONFIG.name === "Vistas") {
        let obj = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: ORG_DETAILS.USER_ID,
          extras: {
            find: {
              product_id: Number(tempArray[index].product_id),
              product_cost: Number(tempArray[index].cost),
              quantity: Number(tempArray[index].quantity),
              customer_id: Number(userId),
              weight: Number(tempArray[index].product.shipping.weight_to_consider) * Number(tempArray[index].quantity),
            weight_to_consider:true
            },
          },
        };

        this.appService
          .postApiCall(obj, ENDPOINTS.STRUCTURED_PROMOTION)
          .subscribe(
            (resp) => {
              if (resp) {
                if (resp.success === 1 && resp.status_code === 200) {
           
                    this.appService.cartProducts.results[index]["discount_amount"] =
                    resp.result.data.discount_summary[0].discount_amount;
           
                this.appService.cartProducts.results[index][
                  "after_dicount_price"
                ] = resp.result.data.discount_summary[0].after_dicount_price;
                   
                   
                  this.cartService.updateCartItem(
                    this.appService.cartProducts.results
                  );
                  console.log(
                    "tempArray[index].product.discount_value" +
                      tempArray[index].product.discount_value
                  );
                } else if (resp.success === 0) {
                  if (resp.message) {
                    //this.alertService.error(resp.message, this.options);
                  }
                } else if (resp.message && resp.status_code !== 200) {
                  //this.alertService.error(resp.message, this.options);
                } else {
                  //this.alertService.error('Something bad happened. Please try again!', this.options);
                }
              }
            },
            (err) => {
              if (err.error.statusCode === 403) {
                //this.alertService.error('Session Time Out! Please login Again', this.options)
              } else if (err.error.error.message) {
                //this.alertService.error(err.error.error.message, this.options)
              } else {
                //this.alertService.error('Something bad happened. Please try again!', this.options);
              }
            }
          );
      }
      this.appService.cartProducts.results = tempArray;
      this.appService.totalCartItems = this.cartService.totalCartItems();
      this.cartService.updateCartItem(this.appService.cartProducts.results);
      if (this.CONFIG.title === "SpecialWires" || this.CONFIG.title === "Vistas") {
        let cartItemsString = JSON.stringify(
          this.appService.cartProducts.results
        );
        this.localService.set("cart", cartItemsString);
      }
    }
  }

  getPromotionBanner(item) {
    let obj = {
      domain_name: ORG_DETAILS.DOMAIN_NAME,
      user_id: ORG_DETAILS.USER_ID,
      extras: {
        find: {},
      },
    };

    this.appService.postApiCall(obj, ENDPOINTS.PROMOTIONS_BANNER).subscribe(
      (resp) => {
        if (resp) {
          if (resp.success === 1 && resp.status_code === 200) {
            this.banner = resp.result.data[0]["eligible_banner_message"];
            if (this.CONFIG.title === "Deera" || this.CONFIG.title === "Babys Pride" || this.CONFIG.title === "Karupattiraja" || this.CONFIG.title === "AvonSeals" || this.CONFIG.title === "Vistas" || this.CONFIG.title === "LinenRaj" || this.CONFIG.title === "SpecialWires") {
              this.promotionData = resp.result.data;
              // let tempArray = this.appService.cartProducts.results;

              // this.appService.cartProducts.results.forEach((item)=>
              // {

              this.promotionData.forEach((data) => {
                
                // this.productData = data.product_discount.amount_or_percentage.product_details;
                console.log(
                  "productnnnn" +
                    data.product_discount.amount_or_percentage
                      .product_details[0].product_name
                );
                data.product_discount.amount_or_percentage.product_details.forEach(
                  (data1) => {
                    console.log("data1.product_name" + data1.product_name);
                    console.log("item.product_name" + item.name);
                    if (data1.product_name === item.name) {
                      this.executionData.push(data1.order_execution);
                      let max = this.executionData.reduce(
                        (op, item) => (op = op > item ? op : item),
                        0
                      );
                      console.log("max" + max);
                      if (max === data1.order_execution) {
                        if (
                          data.product_discount.amount_or_percentage
                            .discounted_percentage !== 0
                        ) {
                          console.log("truwwwwwww");
                          function minusPercent(n, p) {
                            return n - n * (p / 100);
                          }
                          // let price = minusPercent(475,20);
                          let price = minusPercent(
                            item.pricing.raw.price,
                            data.product_discount.amount_or_percentage
                              .discounted_percentage
                          );
                          // item.pricing.raw.price = price;
                          console.log("price" + price);
                          this.appService.cartProducts.results.forEach(
                            (item1) => {
                              if (item.name === item1.product_name) {
                                item1.cost = price;
                                this.calculateTotal();
                                this.cartService.updateCartItem(
                                  this.appService.cartProducts.results
                                );
                              }
                            }
                          );
                        } else if (
                          data.product_discount.amount_or_percentage
                            .discounted_amount !== 0
                        ) {
                          console.log(
                            "item.pricing.raw.price" + item.pricing.raw.price
                          );
                          console.log(
                            "discounted_amount" +
                              data.product_discount.amount_or_percentage
                                .discounted_amount
                          );
                          let price =
                            item.pricing.raw.price -
                            data.product_discount.amount_or_percentage
                              .discounted_amount;
                          //  item.pricing.raw.price = price;
                          console.log("price" + price);
                          this.appService.cartProducts.results.forEach(
                            (item1) => {
                              if (item.name === item1.product_name) {
                                item1.cost = price;
                                this.calculateTotal();
                                this.cartService.updateCartItem(
                                  this.appService.cartProducts.results
                                );
                              }
                            }
                          );
                        }
                      }
                    }
                  }
                );
              });
              // })
            }
          } else if (resp.success === 0) {
            if (resp.message) {
              //this.alertService.error(resp.message, this.options);
            }
          } else if (resp.message && resp.status_code !== 200) {
            //this.alertService.error(resp.message, this.options);
          } else {
            //this.alertService.error('Something bad happened. Please try again!', this.options);
          }
        }
      },
      (err) => {
        if (err.error.statusCode === 403) {
          //this.alertService.error('Session Time Out! Please login Again', this.options)
        } else if (err.error.error.message) {
          //this.alertService.error(err.error.error.message, this.options)
        } else {
          //this.alertService.error('Something bad happened. Please try again!', this.options);
        }
      }
    );
  }

  calculateTotal() {
    if (this.appService.cartProducts.results.length > 0) {
      this.totalPrice = 0;
      this.appService.cartProducts.results.forEach((obj) => {
        this.totalPrice += obj.cost * obj.quantity;
      });
    } else {
      this.totalPrice = 0;
    }
  }

  clearAll() {
    this.productfilter.clearAll();
  }
  onConfirm1(product,items, id , index) {
    this.current_index = index
    console.log(index, id ,"index11")
    console.log("121111",this.DeeraOption)
    this.DeeraOption = product;
    // for(let i=0;i<this.DeeraOption.length;i++){
      // if(this.products[i].product_type == "Variable"){
    for (let j = 0; j < this.DeeraOption.variant.option_values.length; j++) {
      console.log("index222222222",index)
      
      console.log(this.DeeraOption.variant.option_values[j].id,"j")
      console.log(this.DeeraOption.variant.option_values[index].id, "i")
      this.DeeraOption.variant.option_values[j].is_default = false
      // this.products[i].variant.option_values[j].is_default = false
      // this.product.variant.option_values[j].is_default = false
      // if (index == j) {
        // this.product.variant.option_values[index].is_default = true; 
      // } 
      if (this.DeeraOption.variant.option_values[j].id===this.DeeraOption.variant.option_values[index].id) {
        console.log("truee")
        // this.router.navigate(["/product-details", this.product.variant.option_values[j].id], {
        //   relativeTo: this.route,
        //   skipLocationChange: false,
        // });
        this.DeeraOption.variant.option_values[index].is_default = true;
      }
    // }
  }
  // }
    this.sizeVariable = items;
    this.isValid = true;
    this.showPrice = true;
    this.isDisabled = false;
    this.activeMenu = items.option;
    this.checkVariantInCart = items.id;
    this.priceOfVariant = items.pricing.raw.price;
  }
  addToCartDeera(item_id,product){
    console.log("test123")
    let tempArray = this.appService.cartProducts.results;
      let cartQty = 0;
      tempArray.forEach((item, i) => {
        cartQty += item.quantity;
      });
  
      if (Number(this.localService.get('max_cart_qty')) <= cartQty) {
        this.showAlerts = true;
        window.scrollTo(0, 0);
         this.alertService.error("Maximum allowed quantity is " +this.localService.get('max_cart_qty') +" only",this.options)
        return
      }
      else{
    // console.log("2222")
    //     this.cartService.addToCart(this.newProductDetails);
    //     this.addCart = true;
    //   for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
    //     this.cartData.push(this.appService.cartProducts.results[i].option_values[].id);
    //   }
    let requestData = {
      "domain_name": ORG_DETAILS.DOMAIN_NAME,
      "user_id": ORG_DETAILS.USER_ID,
      "extras": {
        "find": {
          "id": item_id
        },
        "pagination": false,
        "paginationDetails": {
          "limit": 0,
          "pageSize": 2
        },
        "sorting": true,
        "sortingDetails": {
          "sortfield": "", "sortorder": 1
        }
      }
    }
    this.checkoutApiService.checkoutAPICall(ENDPOINTS.PRODUCT_DETAILS, requestData).then(
      respData => {
        let res: any = respData;
        if (res.success) {
          var data = res.data[0];
          this.deera_price_data = data;
          console.log("this.deera_price_data", this.deera_price_data)
          this.cartService.addToCart(data);
          for(let j = 0; j < this.appService.cartProducts.results.length; j++ ){
            if(Number(this.appService.cartProducts.results[j].product_id) === Number(data.id)){
              console.log("this.appService.cartProducts.results[j].quality",this.appService.cartProducts.results[j])
              console.log("hhfg",this.appService.cartProducts.results[this.appService.productIdinCart.indexOf(data.id)])
              // this.appService.cartProducts.results[j].product.quantity = data.pricing.raw.minimumorderquantity
              this.appService.cartProducts.results[j].quantity = data.pricing.raw.minimumorderquantity
              console.log("this.appService.cartProducts.results[j].quality11",this.appService.cartProducts.results[j])
            }
          }
          this.cartService.updateCartItem(
            this.appService.cartProducts.results
          );
            let obj =
            {
              domain_name: ORG_DETAILS.DOMAIN_NAME,
              user_id: ORG_DETAILS.USER_ID,
              extras: {
                find: {
                 product_id: item_id,
                product_cost: Number(res.data[0].pricing.raw.price),
                  quantity: 1,
                },
              },
            };
  
          this.appService.postApiCall(obj, ENDPOINTS.QUANTITY_PROMOTION).subscribe(
            (resp) => {
              if (resp) {
                if (resp.success === 1 && resp.status_code === 200) {
                  for (let j = 0; j < this.appService.cartProducts.results.length;j++) {
                    if (
                      this.appService.cartProducts.results[j].product_id === item_id
                    ) {
                      this.appService.cartProducts.results[
                        j
                      ].product.discount_value =
                        resp.result.data.discount_applied_to_product_value;
                        this.appService.cartProducts.results[j].product.per_quantity_amount = resp.result.data.per_quantity_amount;
  
                      this.appService.cartProducts.results[
                        j
                      ].product.discount_amount = resp.result.data.discount_amount;
                      this.appService.cartProducts.results[j].product.fixed_amount =
                        resp.result.data.fixed_amount;
                      this.appService.cartProducts.results[
                        j
                      ].product.discount_percentage =
                        resp.result.data.discount_percentage;
                      if (resp.result.data.discount_percentage > 0) {
                        this.appService.cartProducts.results[j]["fixed_amount"] =
                          resp.result.data.discount_amount;
                      } else {
                        this.appService.cartProducts.results[j]["fixed_amount"] =
                          resp.result.data.fixed_amount;
                      }
                      this.appService.cartProducts.results[j][
                        "discount_percentage"
                      ] = resp.result.data.discount_percentage;
                      console.log(
                        "this.appService.cartProducts.results[i].product.fixed_amount" +
                          this.appService.cartProducts.results[j].product
                            .fixed_amount
                      );
                      this.cartService.updateCartItem(
                        this.appService.cartProducts.results
                      );
                      console.log(
                        "this.appService.cartProducts.results[i].product.fixed_amount" +
                          this.appService.cartProducts.results[j].product
                            .fixed_amount
                      );
                    }
                  }
                  let cartItemsString = JSON.stringify(
                    this.appService.cartProducts.results
                  );
                  this.localService.set("cart", cartItemsString);
                } else if (resp.success === 0) {
                  if (resp.message) {
                  }
                } else if (resp.message && resp.status_code !== 200) {
                } else {
                }
              }
            },
            (err) => {
              if (err.error.statusCode === 403) {
              } else if (err.error.error.message) {
              } else {
              }
            }
          );
          
        }
        
      }
    )
      console.log("this.appService.cartProducts.results",this.appService.cartProducts.results)
      
    }
  }
  addToCartBaby(item_id,product){
    console.log("test123")
    let tempArray = this.appService.cartProducts.results;
      let cartQty = 0;
      tempArray.forEach((item, i) => {
        cartQty += item.quantity;
      });
  
      if (Number(this.localService.get('max_cart_qty')) <= cartQty) {
        this.showAlerts = true;
        window.scrollTo(0, 0);
         this.alertService.error("Maximum allowed quantity is " +this.localService.get('max_cart_qty') +" only",this.options)
        return
      }
      else{
    // console.log("2222")
    //     this.cartService.addToCart(this.newProductDetails);
    //     this.addCart = true;
    //   for (let i = 0; i < this.appService.cartProducts.results.length; i++) {
    //     this.cartData.push(this.appService.cartProducts.results[i].option_values[].id);
    //   }
    let requestData = {
      "domain_name": ORG_DETAILS.DOMAIN_NAME,
      "user_id": ORG_DETAILS.USER_ID,
      "extras": {
        "find": {
          "id": item_id
        },
        "pagination": false,
        "paginationDetails": {
          "limit": 0,
          "pageSize": 2
        },
        "sorting": true,
        "sortingDetails": {
          "sortfield": "", "sortorder": 1
        }
      }
    }
    this.checkoutApiService.checkoutAPICall(ENDPOINTS.PRODUCT_DETAILS, requestData).then(
      respData => {
        let res: any = respData;
        if (res.success) {
          var data = res.data[0];
          this.deera_price_data = data;
          console.log("this.deera_price_data", this.deera_price_data)
          this.cartService.addToCart(data);
          for(let j = 0; j < this.appService.cartProducts.results.length; j++ ){
            if(Number(this.appService.cartProducts.results[j].product_id) === Number(data.id)){
              console.log("this.appService.cartProducts.results[j].quality",this.appService.cartProducts.results[j])
              console.log("hhfg",this.appService.cartProducts.results[this.appService.productIdinCart.indexOf(data.id)])
              // this.appService.cartProducts.results[j].product.quantity = data.pricing.raw.minimumorderquantity
              this.appService.cartProducts.results[j].quantity = 1
              console.log("this.appService.cartProducts.results[j].quality11",this.appService.cartProducts.results[j])
            }
          }
          this.cartService.updateCartItem(
            this.appService.cartProducts.results
          );
            // let obj =
            // {
            //   domain_name: ORG_DETAILS.DOMAIN_NAME,
            //   user_id: ORG_DETAILS.USER_ID,
            //   extras: {
            //     find: {
            //      product_id: item_id,
            //     product_cost: Number(res.data[0].pricing.raw.price),
            //       quantity: 1,
            //     },
            //   },
            // };
  
          // this.appService.postApiCall(obj, ENDPOINTS.QUANTITY_PROMOTION).subscribe(
          //   (resp) => {
          //     if (resp) {
          //       if (resp.success === 1 && resp.status_code === 200) {
          //         for (let j = 0; j < this.appService.cartProducts.results.length;j++) {
          //           if (
          //             this.appService.cartProducts.results[j].product_id === item_id
          //           ) {
          //             this.appService.cartProducts.results[
          //               j
          //             ].product.discount_value =
          //               resp.result.data.discount_applied_to_product_value;
          //               this.appService.cartProducts.results[j].product.per_quantity_amount = resp.result.data.per_quantity_amount;
  
          //             this.appService.cartProducts.results[
          //               j
          //             ].product.discount_amount = resp.result.data.discount_amount;
          //             this.appService.cartProducts.results[j].product.fixed_amount =
          //               resp.result.data.fixed_amount;
          //             this.appService.cartProducts.results[
          //               j
          //             ].product.discount_percentage =
          //               resp.result.data.discount_percentage;
          //             if (resp.result.data.discount_percentage > 0) {
          //               this.appService.cartProducts.results[j]["fixed_amount"] =
          //                 resp.result.data.discount_amount;
          //             } else {
          //               this.appService.cartProducts.results[j]["fixed_amount"] =
          //                 resp.result.data.fixed_amount;
          //             }
          //             this.appService.cartProducts.results[j][
          //               "discount_percentage"
          //             ] = resp.result.data.discount_percentage;
          //             console.log(
          //               "this.appService.cartProducts.results[i].product.fixed_amount" +
          //                 this.appService.cartProducts.results[j].product
          //                   .fixed_amount
          //             );
          //             this.cartService.updateCartItem(
          //               this.appService.cartProducts.results
          //             );
          //             console.log(
          //               "this.appService.cartProducts.results[i].product.fixed_amount" +
          //                 this.appService.cartProducts.results[j].product
          //                   .fixed_amount
          //             );
          //           }
          //         }
          //         let cartItemsString = JSON.stringify(
          //           this.appService.cartProducts.results
          //         );
          //         this.localService.set("cart", cartItemsString);
          //       } else if (resp.success === 0) {
          //         if (resp.message) {
          //         }
          //       } else if (resp.message && resp.status_code !== 200) {
          //       } else {
          //       }
          //     }
          //   },
          //   (err) => {
          //     if (err.error.statusCode === 403) {
          //     } else if (err.error.error.message) {
          //     } else {
          //     }
          //   }
          // );
          
        }
        
      }
    )
      console.log("this.appService.cartProducts.results",this.appService.cartProducts.results)
      
    }
  }
  productDetails_vimpro(id,child_id) {
    
      this.router.navigate(["/product-details", id], {
        relativeTo: this.route,
        skipLocationChange: false,
      });
      this.localService.set('redirected_from_cart',child_id);
  }
  productDetailsWithName(id,name){
    if (this.CONFIG.title === "Schift Cosmetics"){
      console.log(this.allInOneData,"this.allInOneData[1]chw=")
      // this.router.navigate(['/product-details'], { queryParams: { url:name,id, },relativeTo:this.route,  skipLocationChange: false })
      this.router.navigate(['/product-details/name/2'], )

}
  }
  productDetails(id) {
    console.log("111")
    if (this.CONFIG.title === "Schift Cosmetics"){
      console.log(this.allInOneData,"this.allInOneData[1]")
      this.router.navigate(['/product-details'], { queryParams: { url:this.allInOneData[1],id, },relativeTo:this.route,  skipLocationChange: false })

}
    else if (this.CONFIG.title === "Aiema" || this.CONFIG.title === "Cle") {
      this.router.navigate(["/company-details1", id], {
        relativeTo: this.route,
        skipLocationChange: false, 
      });
    }
    
    else {
      console.log("1111")
      this.router.navigate(["/product-details", id], {
        relativeTo: this.route,
        skipLocationChange: false,
      });
    }
  }
   submitEnquiry_accel(product) {
    console.log("this.memberId"+this.memberId);
    // this.enquiryForm.controls['category'].setValue(this.product.categories[0].categories)
    // document.getElementById('launch-model').click();

    let userId = this.localService.get('UserId');
    console.log("userid", userId)
    console.log("this.appService.userName", this.appService.userName)
    let beaubelleUserName = this.appService.userName;
    this.memberId = product.memberId;
    this.companyName = product.name;
    if (userId) {
      this.enquiryForm.reset({ name: "", message: "", })
      if (beaubelleUserName) {
        this.enquiryForm.controls['name'].setValue(beaubelleUserName)
       }
      this.enquiryForm.controls['email'].setValue(this.customerLoginStorageService.getCustomerData().email)
      this.enquiryForm.controls['phone_number'].setValue(this.customerLoginStorageService.getCustomerData().mobileNo)
      this.enquiryForm.controls['category'].setValue(product.categories[0].categories)
      document.getElementById('launch-model-accel').click();

    } else {
      this.router.navigate(['/login-new'], { queryParams: { productId: product.id, }, relativeTo: this.route, skipLocationChange: false })
    }
  }
  productSubDetails(id,subname,size) {
      // this.subProductArray.push(subname)
      this.localService.set("subProduct",subname)
      this.localService.set("option1",size[0])
      this.localService.set("option2",size[1])
      this.router.navigate(["/product-details", id], {
        relativeTo: this.route,
        skipLocationChange: false,
      });
  }
  mouseEnter(id) {
    document.getElementById(id).click();
  }

  mouseLeave(id) {
    document.getElementById(id).click();
  }

  filterItemsOfType() {
    if (this.CONFIG.title === "Aiema" || this.CONFIG.title === "Cle") {
      // return this.products
      //  return this.products.filter(x => x.status != 'Rejected' || x.status != 'Approve');
      // return this.products.filter(x => x.status != 'Rejected' && x.status != 'Approve');
      // return this.products.filter(x => x.status === 'Approved');
      return this.products;
    }
    else if(this.CONFIG.title === 'ShubhCards' || this.CONFIG.title === "Babys Pride"||this.CONFIG.title === "BombayHardware" || this.CONFIG.title === "Deera"|| this.CONFIG.title === "KatbookStore" || this.CONFIG.title === "Karupattiraja" || this.CONFIG.title === "AvonSeals" || this.CONFIG.title === "Vistas" || this.CONFIG.title === "SpecialWires" || this.CONFIG.title === "LinenRaj"|| this.CONFIG.title === "Beaubelle" || this.CONFIG.title === "BestGifts"|| this.CONFIG.title === "Carience"){
      
      return this.products
      
     
      
    }
    else{
      return this.products.filter(x => x.type != 'Variation');
    }
    
}

brandName(brandName){
  return brandName.length > 13 ? brandName.substring(0,11) + '...' : brandName;
}
prodName(prodName){
  return prodName.length > 24 ? prodName.substring(0,23) + ' ...' : prodName;
}
viewDetail(){
  document.getElementById("closemodal").click()
  
  
  this.router.navigate(["/product-details/1"])
  //location.reload();

}
  saveForm() {
    // if (/\S/.test(this.enquiryForm.value.message)) {
    //   this.validateForm = false;
    
      
    // }
    // else{
    //   this.validateForm = true;
    
    // }


    if (this.enquiryForm.controls.name.value === "") {
      this.validateForm = true;
    } else if (this.enquiryForm.controls.message.value === "") {
      this.validateForm = true;
    } else if (this.enquiryForm.controls.email.value === "") {
      this.validateForm = true;
    } else if (this.enquiryForm.controls.phone_number.value === "") {
      this.validateForm = true;
    }
    

    if (this.enquiryForm.valid && (/\S/.test(this.enquiryForm.value.message) ) ){
      this.validateForm = false;
      var formData = {};
      var formDataJson;
      let session_id = this.localService.get("session_id");

      // let _key = enc.Utf8.parse("@NcRfUjXn2r5u7x!A%D*G-KaPdSgVkYp");
      // let _iv =  enc.Utf8.parse('\x00\x01\x02\x03\x04\x05\x06\x07\x08\x09\x0a\x0b\x0c\x0d\x0e\x0f');
      // let encrypted =AES.encrypt (
      // JSON.stringify({
      //   "domain_name": ORG_DETAILS.DOMAIN_NAME,
      //   "user_id": ORG_DETAILS.USER_ID,
      //   "timestamp": new Date().getTime(),
      //   "payload": {
      //     "order_creation":{
      //     "name":this.enquiryForm.value.name,
      //     "email":this.enquiryForm.value.email,
      //     "phone_number":this.enquiryForm.value.phone_number,
      //     "category":this.enquiryForm.value.category,
      //     "message":this.enquiryForm.value.message,
      //     "member_id":this.memberId,
      //     "status":"New",
      //     "system_label":"New"
      //   }
      //   },
      //   "extras": {
      //     "find": {
      //       "id": ""
      //     }
      //   }
      // }), _key, {
      //     iv: _iv,
      //     format: crypto.format.Hex,
      //     mode: crypto.mode.CTR,
      //     padding: crypto.pad.NoPadding
      // }).toString();
      // let requestData = {
      //   payload: encrypted
      // }
      let userId = this.localService.get('UserId')
      let enquiry = {
        name: this.enquiryForm.value.name,
        email: this.enquiryForm.value.email,
        customer_id: Number(userId),
        phone_number: this.enquiryForm.value.phone_number,
        category: this.enquiryForm.value.category,
        message: this.enquiryForm.value.message,
        e_length: this.enquiryForm.value.e_length,
        diameter: this.enquiryForm.value.diameter,
        quantity: this.enquiryForm.value.quantity,
        member_id: this.memberId,
        status: "New",
        system_label: "New",
        companyName: this.companyName,
        enquiry_status:true,
      };
      let requestData = {
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: ORG_DETAILS.USER_ID,
        payload: {
          order_creation: enquiry,
        },
        extras: {
          find: {
            id: "",
          },
        },
      };
console.log(this.enquiryForm.value.message.length,"test123")
//console.log(this.enquiryForm.value.message.trim(),"test123")

console.log(this.enquiryForm.value.message[0],"test123")




if (/\S/.test(this.enquiryForm.value.message)) {
  console.log("1")

  //console.log(this.enquiryForm.value.message[0]== null,"test123")
  // string is not empty and not just whitespace
}
else{
  console.log("0")
}



// console.log(this.enquiryForm.value.message[0] === "space","test123")
// console.log(this.enquiryForm.value.message[0]=== 'space',"test123")
      // let requestData = {
      //   payload: encrypted
      // }
      this.checkoutApiService
        .checkoutAPICall(ENDPOINTS.ORDER_UPDATION, requestData)
        .then((respData) => {
          let res: any = respData;
          if (res.success) {
            let OrderId = res.data[0].id;
            this.closeModal.nativeElement.click();
            this.checkoutLocalStorageService.setOrderId({ orderId: OrderId });
            this.alertService.success("Request Submitted", this.options);
            this.enquiryForm.reset({
              name: "",
              email: "",
              phone_number: "",
              category: "",
              message: "",
            });
            this.checkoutLocalStorageService.removeOrderId();

          }
        });
    }

    // formData["name"] = this.enquiryForm.value.name;
    // formData["email"] = this.enquiryForm.value.email;
    // formData["phone_number"] = this.enquiryForm.value.phone_number;
    // formData["category"] = this.enquiryForm.value.category;
    // formData["message"] = this.enquiryForm.value.message;
    // formData["member_id"] = this.memberId;
    // formData['status'] = 'New'
    // formDataJson = {
    //   domain_name: ORG_DETAILS.DOMAIN_NAME,
    //   user_id: ORG_DETAILS.USER_ID,
    //   payload: {
    //     enquiry_creation: formData
    //   }
    // }
    // MAKE A SERVICE CALL HERE...
    // this.appService.postApiCall(formDataJson, ENDPOINTS.ADD_ENQUIRY).subscribe(
    //   resp => {
    //     if (resp) {
    //       if (resp.success === 1 && resp.status_code === 200) {
    //         this.alertService.success('Request Received', this.options);
    //         window.scrollTo({top: 0, behavior: 'smooth'});

    //       }
    //       else if (resp.success === 0) {
    //         if (resp.message) {
    //           this.alertService.error(resp.message, this.options);
    //           window.scrollTo({top: 0, behavior: 'smooth'});
    //         }
    //       }
    //       else if (resp.message && resp.status_code !== 200) {
    //         this.alertService.error(resp.message, this.options);
    //         window.scrollTo({top: 0, behavior: 'smooth'});
    //       }
    //       else {
    //         this.alertService.error('Something bad happened. Please try again!', this.options);
    //         window.scrollTo({top: 0, behavior: 'smooth'});
    //       }
    //     }
    //   },
    //   err => {
    //     if (err.error.statusCode === 403) {
    //       this.alertService.error('Session Time Out! Please login Again', this.options)
    //       this.router.navigate([`/login-new`], { skipLocationChange: false });
    //     }
    //     else if (err.error.message) {
    //       this.alertService.error(err.error.message, this.options)
    //       window.scrollTo({top: 0, behavior: 'smooth'});
    //     }
    //     else if (err.error.error.message) {
    //       this.alertService.error(err.error.error.message, this.options)
    //       window.scrollTo({top: 0, behavior: 'smooth'});
    //     }
    //     else {
    //       this.alertService.error('Something bad happened. Please try again!', this.options);
    //       window.scrollTo({top: 0, behavior: 'smooth'});
    //     }
    //   }
    // )
    //   ;
  }
  saveForm_vimpro() {
    // if (/\S/.test(this.enquiryForm.value.message)) {
    //   this.validateForm = false;
    
      
    // }
    // else{
    //   this.validateForm = true;
    
    // }


    if (this.enquiryForm_vimpro.controls.name.value === "") {
      this.validateForm = true;
    } else if (this.enquiryForm_vimpro.controls.message.value === "") {
      this.validateForm = true;
    } else if (this.enquiryForm_vimpro.controls.email.value === "") {
      this.validateForm = true;
    } else if (this.enquiryForm_vimpro.controls.phone_number.value === "") {
      this.validateForm = true;
    }
    // else if (this.enquiryForm_vimpro.controls.thickness.value === "") {
    //   this.validateForm = true;
    // }else if (this.enquiryForm_vimpro.controls.length.value === "") {
    //   this.validateForm = true;
    // }else if (this.enquiryForm_vimpro.controls.height.value === "") {
    //   this.validateForm = true;
    // }
    // else if (this.enquiryForm_vimpro.controls.quantity.value === "") {
    //   this.validateForm = true;
    // }
    

    if (this.enquiryForm_vimpro.valid && (/\S/.test(this.enquiryForm_vimpro.value.message) ) ){
      this.validateForm = false;
      var formData = {};
      var formDataJson;
      let session_id = this.localService.get("session_id");

      // let _key = enc.Utf8.parse("@NcRfUjXn2r5u7x!A%D*G-KaPdSgVkYp");
      // let _iv =  enc.Utf8.parse('\x00\x01\x02\x03\x04\x05\x06\x07\x08\x09\x0a\x0b\x0c\x0d\x0e\x0f');
      // let encrypted =AES.encrypt (
      // JSON.stringify({
      //   "domain_name": ORG_DETAILS.DOMAIN_NAME,
      //   "user_id": ORG_DETAILS.USER_ID,
      //   "timestamp": new Date().getTime(),
      //   "payload": {
      //     "order_creation":{
      //     "name":this.enquiryForm.value.name,
      //     "email":this.enquiryForm.value.email,
      //     "phone_number":this.enquiryForm.value.phone_number,
      //     "category":this.enquiryForm.value.category,
      //     "message":this.enquiryForm.value.message,
      //     "member_id":this.memberId,
      //     "status":"New",
      //     "system_label":"New"
      //   }
      //   },
      //   "extras": {
      //     "find": {
      //       "id": ""
      //     }
      //   }
      // }), _key, {
      //     iv: _iv,
      //     format: crypto.format.Hex,
      //     mode: crypto.mode.CTR,
      //     padding: crypto.pad.NoPadding
      // }).toString();
      // let requestData = {
      //   payload: encrypted
      // }

      let enquiry = {
        name: this.enquiryForm_vimpro.value.name,
        email: this.enquiryForm_vimpro.value.email,
        phone_number: this.enquiryForm_vimpro.value.phone_number,
        category: this.enquiryForm_vimpro.value.category,
        message: this.enquiryForm_vimpro.value.message,
        product_name: this.enquiryForm_vimpro.value.product_name,
        e_length: this.enquiryForm_vimpro.value.length,
       thickness: this.enquiryForm_vimpro.value.thickness,
       height: this.enquiryForm_vimpro.value.height,
       width: this.enquiryForm_vimpro.value.width,
       quantity:this.enquiryForm_vimpro.value.quantity,
      material: this.enquiryForm_vimpro.value.material,
      color: this.enquiryForm_vimpro.value.color,
      usage: this.enquiryForm_vimpro.value.usage,
        member_id: this.memberId,
        status: "New",
        system_label: "New",
        companyName: this.companyName,
        enquiry_status:true,
      };
      let requestData = {
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: ORG_DETAILS.USER_ID,
        payload: {
          order_creation: enquiry,
        },
        extras: {
          find: {
            id: "",
          },
        },
      };
console.log(this.enquiryForm_vimpro.value.message.length,"test123")
//console.log(this.enquiryForm.value.message.trim(),"test123")

console.log(this.enquiryForm_vimpro.value.message[0],"test123")




if (/\S/.test(this.enquiryForm_vimpro.value.message)) {
  console.log("1")

  //console.log(this.enquiryForm.value.message[0]== null,"test123")
  // string is not empty and not just whitespace
}
else{
  console.log("0")
}



// console.log(this.enquiryForm.value.message[0] === "space","test123")
// console.log(this.enquiryForm.value.message[0]=== 'space',"test123")
      // let requestData = {
      //   payload: encrypted
      // }
      this.checkoutApiService
        .checkoutAPICall(ENDPOINTS.ORDER_UPDATION, requestData)
        .then((respData) => {
          let res: any = respData;
          if (res.success) {
            let OrderId = res.data[0].id;
            this.closeModal.nativeElement.click();
            this.checkoutLocalStorageService.setOrderId({ orderId: OrderId });
            this.alertService.success("Request Submitted", this.options);
            this.enquiryForm_vimpro.reset({
              name: "",
              email: "",
              phone_number: "",
              category: "",
              message: "",
            });
          }
        });
    }

    // formData["name"] = this.enquiryForm.value.name;
    // formData["email"] = this.enquiryForm.value.email;
    // formData["phone_number"] = this.enquiryForm.value.phone_number;
    // formData["category"] = this.enquiryForm.value.category;
    // formData["message"] = this.enquiryForm.value.message;
    // formData["member_id"] = this.memberId;
    // formData['status'] = 'New'
    // formDataJson = {
    //   domain_name: ORG_DETAILS.DOMAIN_NAME,
    //   user_id: ORG_DETAILS.USER_ID,
    //   payload: {
    //     enquiry_creation: formData
    //   }
    // }
    // MAKE A SERVICE CALL HERE...
    // this.appService.postApiCall(formDataJson, ENDPOINTS.ADD_ENQUIRY).subscribe(
    //   resp => {
    //     if (resp) {
    //       if (resp.success === 1 && resp.status_code === 200) {
    //         this.alertService.success('Request Received', this.options);
    //         window.scrollTo({top: 0, behavior: 'smooth'});

    //       }
    //       else if (resp.success === 0) {
    //         if (resp.message) {
    //           this.alertService.error(resp.message, this.options);
    //           window.scrollTo({top: 0, behavior: 'smooth'});
    //         }
    //       }
    //       else if (resp.message && resp.status_code !== 200) {
    //         this.alertService.error(resp.message, this.options);
    //         window.scrollTo({top: 0, behavior: 'smooth'});
    //       }
    //       else {
    //         this.alertService.error('Something bad happened. Please try again!', this.options);
    //         window.scrollTo({top: 0, behavior: 'smooth'});
    //       }
    //     }
    //   },
    //   err => {
    //     if (err.error.statusCode === 403) {
    //       this.alertService.error('Session Time Out! Please login Again', this.options)
    //       this.router.navigate([`/login-new`], { skipLocationChange: false });
    //     }
    //     else if (err.error.message) {
    //       this.alertService.error(err.error.message, this.options)
    //       window.scrollTo({top: 0, behavior: 'smooth'});
    //     }
    //     else if (err.error.error.message) {
    //       this.alertService.error(err.error.error.message, this.options)
    //       window.scrollTo({top: 0, behavior: 'smooth'});
    //     }
    //     else {
    //       this.alertService.error('Something bad happened. Please try again!', this.options);
    //       window.scrollTo({top: 0, behavior: 'smooth'});
    //     }
    //   }
    // )
    //   ;
  }
  saveForm_special() {


    if (this.enquiryForm_special.controls.name.value === "") {
      this.validateForm = true;
    } else if (this.enquiryForm_special.controls.message.value === "") {
      this.validateForm = true;
    } else if (this.enquiryForm_special.controls.email.value === "") {
      this.validateForm = true;
    } else if (this.enquiryForm_special.controls.phone_number.value === "") {
      this.validateForm = true;
    }

    if (this.enquiryForm_special.valid && (/\S/.test(this.enquiryForm_special.value.message) ) ){
      this.validateForm = false;
      var formData = {};
      var formDataJson;
      var deleteVariable=[];
      let session_id = this.localService.get("session_id");
      let formData_imageCate = new FormData()
      let headers = new HttpHeaders().set("source", "Product").set("domain_name", ORG_DETAILS.DOMAIN_NAME);
      let enquiry = {
        name: this.enquiryForm_special.value.name,
        email: this.enquiryForm_special.value.email,
        phone_number: this.enquiryForm_special.value.phone_number,
        category: this.enquiryForm_special.value.category,
        message: this.enquiryForm_special.value.message,
        product_name: this.enquiryForm_special.value.product_name,
        quantity:this.enquiryForm_special.value.quantity,
        diameter: this.enquiryForm_special.value.diameter,
        e_length: this.enquiryForm_special.value.e_length,
        member_id: this.memberId,
        status: "New",
        system_label: "New",
        companyName: this.companyName,
        enquiry_status:true,
      };

console.log(this.enquiryForm_special.value.message,"test13")

console.log(this.enquiryForm_special.value.message[0],"test123")

if (/\S/.test(this.enquiryForm_special.value.message)) {
  console.log("1")
}
else{
  console.log("0")
}
if(this.imgFile!==''){
  formData_imageCate.append('upload',this.imgFile)
}
this.appService.sendImage(formData_imageCate,headers).subscribe(resp=>
  {
    if(resp && resp.success===1 && resp.status_code===200){

        let imgVariable=resp.result.data[0];
        if(this.enquiryForm_special.value.imageFile!==''){
          enquiry["imageFile"]=imgVariable.location;
            deleteVariable.push(imgVariable.bucket + '/' + imgVariable.key)
        }
        let requestData = {
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: ORG_DETAILS.USER_ID,
          payload: {
            order_creation: enquiry,
          },
          extras: {
            find: {
              id: "",
            },
          },
        };
      
      this.checkoutApiService
        .checkoutAPICall(ENDPOINTS.ORDER_UPDATION, requestData)
        .then((respData) => {
          let res: any = respData;
          if (res.success) {
            let OrderId = res.data[0].id;
            this.closeModal.nativeElement.click();
            this.checkoutLocalStorageService.setOrderId({ orderId: OrderId });
            this.alertService.success("Request Submitted", this.options);
            this.enquiryForm_special.reset({
              name: "",
              email: "",
              phone_number: "",
              category: "",
              message: "",
              e_length: "",
              diameter: "",
              quantity: ""
            });
          }
        });
      }
    });
    }
  }
    openNavkub() {
      document.getElementById("myfruits").style.width = "0";
      document.getElementById("myvegetables").style.width = "0";
      //document.getElementById("myothers").style.width = "0";
      document.getElementById("mySidenav1").style.width = "60%";
    
  }
  closeNavkub() {
    document.getElementById("openfilter").style.width = "0";
  }
  imageupload(event : any) : void
    {
        
        let dragEvent = false
        let file_data = {name : "",size: 0}
        //CHECKING DRAG EVENT OR UPLOAD EVENT
        if (event.target && event.target.files && event.target.files[0]) {
            
            file_data = event.target.files[0]
        }
        else
        {
            file_data = event.dataTransfer.files[0]
            dragEvent = true
        }

        var reader = new FileReader();

        this.imageName = file_data.name
    
        
        let splitFileName =this.imageName.split(".")
        //CHECKING FILE NAME
        if (splitFileName.length ==0 )
        {
            this.enquiryForm_special.controls['imageFile'].setErrors({'invalid': true});
            return
        }
        
        if(file_data.size == 0)
        {
            this.enquiryForm_special.controls['imageFile'].setErrors({'sizezero': true});
            return
        }
        
        if(Math.round((file_data.size/1000)) > 2000)
        {
            this.enquiryForm_special.controls['imageFile'].setErrors({'sizehigh': true});
            return
        }
        
        //CHECKING FILE TYPE
        if (!["jpg","jpeg","png","gif","JPG","JPEG","PNG","GIF"].includes(splitFileName[splitFileName.length -1]))
        {
            this.enquiryForm_special.controls['imageFile'].setErrors({'type': true});
            return
        }
        this.enquiryForm_special.controls['imageFile'].setErrors({'invalid': false});
        this.enquiryForm_special.controls['imageFile'].setErrors({'type': false});
        this.enquiryForm_special.controls['imageFile'].setErrors({'sizehigh': false});
        this.enquiryForm_special.controls['imageFile'].setErrors({'sizezero': false}); 
        
        reader.onload = (evt:any)=>{
            this.previewImgUrl = evt.target.result;
            this.enquiryForm_special.controls['imageFile'].setValue(evt.target.result)
            // this.imgFile=event.target.files[0];
        }

        //BASED ON EVENT READ FILE 
        if(!dragEvent)
        {
        reader.readAsDataURL(event.target.files[0]);
        this.imgFile=event.target.files[0];
        }
        else
        {
         reader.readAsDataURL(event.dataTransfer.files[0]);
         this.imgFile=event.dataTransfer.files[0];
        }
    }
submitEnquiry(product){
  let userId = this.localService.get('UserId');
    let aiemaUserName = this.appService.userName;
    this.memberId = product.memberId;
    this.companyName = product.name;
    if (userId) {
      this.enquiryForm.reset({ name: "", message: "" });
      this.enquiryForm.controls['name'].setValue(aiemaUserName)
      this.enquiryForm.controls["email"].setValue(
        this.customerLoginStorageService.getCustomerData().email
      );
      this.enquiryForm.controls["phone_number"].setValue(
        this.customerLoginStorageService.getCustomerData().mobileNo
      );
      this.enquiryForm.controls["category"].setValue(
        product.categories[0].categories
      );

      document.getElementById("launch-model").click();
    } else {
      this.router.navigate(["/login-new"], {
        queryParams: { productId: product.id },
        relativeTo: this.route,
        skipLocationChange: false,
      });
    }
  }

  submitEnquiryForVimpro(product){
    this.vimpro_pro_name=product.name;
    let userId = this.localService.get('UserId');
      let aiemaUserName = this.appService.userName;
      this.memberId = product.memberId;
      this.companyName = product.name;
      if (userId) {
        this.enquiryForm_vimpro.reset({ name: "", message: "" });
        this.enquiryForm_vimpro.controls['name'].setValue(aiemaUserName)
        this.enquiryForm_vimpro.controls["email"].setValue(
          this.customerLoginStorageService.getCustomerData().email
        );
        this.enquiryForm_vimpro.controls["phone_number"].setValue(
          this.customerLoginStorageService.getCustomerData().mobileNo
        );
        this.enquiryForm_vimpro.controls["category"].setValue(
          product.categories[0].categories
        );
        this.enquiryForm_vimpro.controls["product_name"].setValue(
          product.name
          
        );
        
        this.material_vimpro=[];
        product.product_material.forEach(element => {
          this.material_vimpro.push(element.name)
        });
        this.color_vimpro=[];
        product.color.forEach(element => {
          if(element.name.toLowerCase().includes('standard'))
          {
            this.color_vimpro.push('Black')
            this.color_vimpro.push('White')
            this.color_vimpro.push('Green')
          }
          else{
            this.color_vimpro.push(element.name)
          }
          
        });
        // if(product.color==null||product.color==undefined){
        //   this.color_vimpro.push('Black')
        //   this.color_vimpro.push('White')
        //   this.color_vimpro.push('Green')
        // }
        this.enquiryForm_vimpro.controls['material'].setValue( this.material_vimpro[0], {onlySelf: true});
        this.enquiryForm_vimpro.controls['color'].setValue( this.color_vimpro[0], {onlySelf: true});
        this.enquiryForm_vimpro.controls['usage'].setValue( this.usage_vimpro[0], {onlySelf: true});
        document.getElementById("launch-model-vimpro").click();
      } else {
        this.router.navigate(["/login-new"], {
          queryParams: { productId: product.id },
          relativeTo: this.route,
          skipLocationChange: false,
        });
      }
    }
    submitEnquiryForSpecial(product){
      this.special_pro_name=product.name;
      let userId = this.localService.get('UserId');
        let aiemaUserName = this.appService.userName;
        this.memberId = product.memberId;
        this.companyName = product.name;
        console.log("ppppaoappp")
        if (userId) {
        console.log("ttttttttt")

          this.enquiryForm_special.reset({ name: "", message: "" });
          this.enquiryForm_special.controls['name'].setValue(aiemaUserName)
          this.enquiryForm_special.controls["email"].setValue(
            this.customerLoginStorageService.getCustomerData().email
          );
          this.enquiryForm_special.controls["phone_number"].setValue(
            this.customerLoginStorageService.getCustomerData().mobileNo
          );
          this.enquiryForm_special.controls["category"].setValue(
            product.categories[0].categories
          );
          this.enquiryForm_special.controls["product_name"].setValue(
            product.name
            
          );
          document.getElementById("launch-model-special").click();
        } else {
          this.router.navigate(["/login-new"], {
            relativeTo: this.route,
            skipLocationChange: false,
          });
        }
      }
  getLowtoHighProducts(event: number){
    console.log("this.allInOneData[1]",this.allInOneData[1])
    console.log("this.allInOneData[12]",this.allInOneData[12])
    console.log("this.allInOneData[6]",this.allInOneData[6])
    if(this.allInOneData[1]!=null || this.allInOneData[1]!=undefined || this.allInOneData[1]!="" ){
     
if(this.CONFIG.title === "Babys Pride"){
  var req_filter_data2 = {
    
    domain_name: ORG_DETAILS.DOMAIN_NAME,
    user_id: null,
    "extras": {
      "find": {
          "brand": [],
          "category":this.allInOneData[1],
          "age":this.allInOneData[12],
          "price":this.allInOneData[6],
          "last30days": false,
          "includeoutofstock": false
      },
      "pagination": true,
      "paginationDetails": {
          "limit": event,
          "pagesize": 25
      },
      "sorting": true,
      "sortingDetails": {
          "sortfield": "pricing.raw.price",
          "sortorder": -1
      },
      "subcategoryfilter": false
  }
  };
  this.appService
  .postApiCall( req_filter_data2, ENDPOINTS.GET_FILTER_PRODUCTS)
  .subscribe(
    (resp) => {
      this.filtersApiData = resp;
      this.products = this.filtersApiData.result.data;
      this.totalLength = this.filtersApiData.result.total
        ? this.filtersApiData.result.total
        : 0;
        this.totalLength = this.totalItemsOrProducts = this.filtersApiData
          .result.total.value
          ? this.filtersApiData.result.total.value
          : 0;
          console.log(this.totalLength,"bestgifts1")
          if(this.CONFIG.title === "Babys Pride" ){
            this.sortingForm.controls['sort_value'].setValue("sort")
          }
      }
     
 
      

   
  );
}
      else{
        var req_filter_dataTaz = {
    
          domain_name: ORG_DETAILS.DOMAIN_NAME,
          user_id: null,
          "extras": {
            "find": {
                "brand": [],
                "category":this.allInOneData[1],
                "age":[],
                "price":[],
                "last30days": false,
                "includeoutofstock": false
            },
            "pagination": true,
            "paginationDetails": {
                "limit": event,
                "pagesize": 20
            },
            "sorting": true,
            "sortingDetails": {
                "sortfield": "pricing.raw.price",
                "sortorder": -1
            },
            "subcategoryfilter": false
        }
        };
        this.appService
        .postApiCall( req_filter_dataTaz, ENDPOINTS.GET_FILTER_PRODUCTS)
        .subscribe(
          (resp) => {
            this.filtersApiData = resp;
            this.products = this.filtersApiData.result.data;
            this.totalLength = this.filtersApiData.result.total
              ? this.filtersApiData.result.total
              : 0;
              this.totalLength = this.totalItemsOrProducts = this.filtersApiData
                .result.total.value
                ? this.filtersApiData.result.total.value
                : 0;
                console.log(this.totalLength,"bestgifts1")
                if(this.CONFIG.title === "Taazah" ){
                  this.sortingForm.controls['sort_value'].setValue("sort")
                }
            }
           
       
            
      
         
        );
      }

      

    }
    else{
     
    console.log("dataaa")
      var req_filter_data_8 = {
    
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: null,
        "extras": {
          "find": {
              "brand": [],
              "category":[],
              "age":[],
                "price":this.allInOneData[6],
              "last30days": false,
              "includeoutofstock": false
          },
          "pagination": true,
          "paginationDetails": {
              "limit": event,
              "pagesize": 25
          },
          "sorting": true,
          "sortingDetails": {
              "sortfield": "pricing.raw.price",
              "sortorder": -1
          },
          "subcategoryfilter": false
      }
      };
      this.appService
        .postApiCall(req_filter_data_8, ENDPOINTS.GET_FILTER_PRODUCTS)
        .subscribe(
          (resp) => {
            this.filtersApiData = resp;
            this.products = this.filtersApiData.result.data;
            this.totalLength = this.filtersApiData.result.total
            ? this.filtersApiData.result.total
            : 0;
            this.totalLength = this.totalItemsOrProducts = this.filtersApiData
              .result.total.value
              ? this.filtersApiData.result.total.value
              : 0;
              console.log(this.totalLength,"bestgifts7")
       
            
          },
         
        );
    }

   
      




  }

  getHightoLowProducts(event: number){
    
    console.log(event,"tttww")
    if(this.allInOneData[1]!=null || this.allInOneData[1]!=undefined ){
      
if(this.CONFIG.title === "Babys Pride"){
      var req_filter_data = {
    
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: null,
        "extras": {
          "find": {
              "brand": [],
              "category":this.allInOneData[1],
              "age":this.allInOneData[12],
              "price":this.allInOneData[6],
              "last30days": false,
              "includeoutofstock": false
          },
          "pagination": true,
          "paginationDetails": {
              "limit": event,
              "pagesize": 25
          },
          "sorting": true,
          "sortingDetails": {
              "sortfield": "pricing.raw.price",
              "sortorder": 1
          },
          "subcategoryfilter": false
      }
      };
      this.appService
        .postApiCall( req_filter_data, ENDPOINTS.GET_FILTER_PRODUCTS)
        .subscribe(
          (resp) => {
            this.filtersApiData = resp;
            this.products = this.filtersApiData.result.data;
            this.totalLength = this.totalItemsOrProducts = this.filtersApiData
              .result.total.value
              ? this.filtersApiData.result.total.value
              : 0;
              console.log(this.totalLength,"bestgifts")
              if(this.CONFIG.title === "Babys Pride" ){
                this.sortingForm.controls['sort_value'].setValue("sort")
              }
          },
         
        );
      }
else{
  var req_filter_data_Taz = {
    
    domain_name: ORG_DETAILS.DOMAIN_NAME,
    user_id: null,
    "extras": {
      "find": {
          "brand": [],
          "category":this.allInOneData[1],
          "age":[],
          "price":[],
          "last30days": false,
          "includeoutofstock": false
      },
      "pagination": true,
      "paginationDetails": {
          "limit": event,
          "pagesize": 20
      },
      "sorting": true,
      "sortingDetails": {
          "sortfield": "pricing.raw.price",
          "sortorder": 1
      },
      "subcategoryfilter": false
  }
  };
  this.appService
    .postApiCall( req_filter_data_Taz, ENDPOINTS.GET_FILTER_PRODUCTS)
    .subscribe(
      (resp) => {
        this.filtersApiData = resp;
        this.products = this.filtersApiData.result.data;
        this.totalLength = this.totalItemsOrProducts = this.filtersApiData
          .result.total.value
          ? this.filtersApiData.result.total.value
          : 0;
          console.log(this.totalLength,"bestgifts")
          if(this.CONFIG.title === "Taazah" ){
            this.sortingForm.controls['sort_value'].setValue("sort")
          }
      },
     
    );
}
    }
    else{
      console.log("dataaa11")

      var req_filter_data_8 = {
    
        domain_name: ORG_DETAILS.DOMAIN_NAME,
        user_id: null,
        "extras": {
          "find": {
              "brand": [],
              "category":[],
              "last30days": false,
              "includeoutofstock": false
          },
          "pagination": true,
          "paginationDetails": {
              "limit": event,
              "pagesize": 25
          },
          "sorting": true,
          "sortingDetails": {
              "sortfield": "pricing.raw.price",
              "sortorder": 1
          },
          "subcategoryfilter": false
      }
      };
      this.appService
        .postApiCall(req_filter_data_8, ENDPOINTS.GET_FILTER_PRODUCTS)
        .subscribe(
          (resp) => {
            this.filtersApiData = resp;
            this.products = this.filtersApiData.result.data;
            this.totalLength = this.totalItemsOrProducts = this.filtersApiData
              .result.total.value
              ? this.filtersApiData.result.total.value
              : 0;
              console.log(this.totalLength,"bestgifts")
       
            
          },
         
        );
    }
  }
  openLink(data){
    //this.headerService.updateAdminFormEvent('clearSearchTerm');
    window.open("https://"+data)
  }
  selectSort(value){
    if(this.CONFIG.title !== "ShubhCards"){
   if( value=="Low to High"){
    this.low_to_high=true;
    this.high_to_low=false;
    this.Taz_price=true;
    this.getLowtoHighProducts(1)
   }
   else if(value=="High to Low"){
    this.low_to_high=false;
    this.high_to_low=true;
    this.Taz_price=true;
    this.getHightoLowProducts(1)
   }
   else if(value=="sort"){
    this.low_to_high=false;
    this.high_to_low=false;
    console.log("kmjnkn")
    this.getFilterByProductAll(1)
    

   }
   else if(value=="Recommended"){
    this.low_to_high=false;
    this.high_to_low=false;
    console.log("kmjnkn")
    this.getFilterByProductAll(1)
    

   }
   else{
    this.low_to_high=false;
    this.high_to_low=false;
    this.getFilterByProductAll(1)

   }
  }
  }


  getCategoryData(data){
    console.log(data,"data")
   
    this.category=[data];
    if(data=="All"){
      this.category=[];
      this.getFilterByProduct(1);
      this.activeTabIndex1=0;
    }
    else if(this.category!=null ){
      console.log("this.category",this.category )
      this.getFilterByProductAll(1);
      if(this.category[0]=="Classic"){
        this.activeTabIndex1=1;

     }
     else if (this.category[0]=="Elite" ){
        this.activeTabIndex1=2;

     }
     else if (this.category[0]=="Luxury"  ){
        this.activeTabIndex1=3;

     }
     else if (this.category[0]=="Premium"  ) {
        this.activeTabIndex1=4;

     }
     

    }
   
  }

  getThemeData(data,j){
    console.log(data,"data")
    this.activeTabIndex=Number(j);
    
    this.category=[]
    this.allInOneData[3]=data;
  
  {
      console.log("this.category",this.category )
      this.getFilterByProductAll(1);

    }
   
  }
//   toggleInfo() {
//     if(document.getElementById("cartpopups").style.visibility === 'hidden'){
//       document.getElementById("cartpopups").onclick = function() {
//         document.getElementById("cartpopups").style.display;
//     }
      
//     } else {
//       document.getElementById("cartpopups").onclick = function() {
//         document.getElementById("cartpopups").style.display="none";
//     }
    
//   }
// }

addToCartForLinenRaj(product){
  
  //document.getElementById("cart_ln").removeAttribute("margin-left")
  //document.getElementById("cart_ln").removeAttribute("margin-top")
  
  document.getElementById("linenrajcart4").click();
  console.log("ffffffff"+JSON.stringify(product))
  this.linenRajOption = product;
  this.products1 = product.variant.option_values;
  this.product1 = product.variant.option_values[this.current_index].assets[0].image_source;
  // this.LinenName = product.name;
  this.LinenName = product.name + " " + product.variant.option_values[0].option
  this.product3 = product.id;
  this.LinenPrice = product.variant.option_values[0].pricing.raw.price;
// product.variant.option_values[product.current_index].option
// product.variant.option_values[product.current_index].pricing.raw.price

}
openbagForLinenRaja(){

  document.getElementById("closemodal1").click()
  document.getElementById("openbaglinen").click()

}
openbagForSchift(){

  
  document.getElementById("openbagschift").click()

}
}

document.addEventListener('DOMContentLoaded', function() {
  var noProductsDialog = document.getElementById('noProductsDialog');
  var categoryNameElement = document.getElementById('Kraft Paper Pouches');
  
  var categoryNames = [
      'Kraft Paper Pouches'
  ];

  function updateCategory(categoryName:string) {
      noProductsDialog.style.display = 'block';
      categoryNameElement.textContent = categoryName;
  }

  
  document.addEventListener('click', function(event) {
      var clickedid = document.getElementById('Kraft Paper Pouches');
      var elementTextContent = clickedid.textContent.trim(); 

      
      if (categoryNames.includes(elementTextContent)) {
          event.preventDefault();
          updateCategory(elementTextContent);
      }
  });


})
;
